"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4718],{

/***/ 79381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91564);

var Criteo = {
  pageview: [_pageView__WEBPACK_IMPORTED_MODULE_0__["default"]]
};
/* harmony default export */ __webpack_exports__["default"] = (Criteo);

/***/ }),

/***/ 91564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85942);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33385);


var getView = function getView(_ref) {
  var _data$product, _data$search, _data$search$products;
  var data = _ref.data,
    structure = _ref.structure;
  switch (structure == null ? void 0 : structure.id) {
    case 'home':
      return {
        event: 'viewHome'
      };
    case 'product':
      return {
        event: 'viewItem',
        item: data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.id
      };
    default:
      return {
        event: 'viewList',
        item: data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$products = _data$search.products) == null ? void 0 : _data$search$products.reduce(function (acc, item) {
          return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc), [item.id]);
        }, [])
      };
  }
};
var pageView = function pageView() {
  var _window, _window2, _window2$criteo_q;
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    data = _ref2.data,
    structure = _ref2.structure;
  if (_utils_constants__WEBPACK_IMPORTED_MODULE_1__.PAGES.includes(structure == null ? void 0 : structure.id) && ((_window = window) == null ? void 0 : _window.criteo_q) && ((_window2 = window) == null ? void 0 : (_window2$criteo_q = _window2.criteo_q) == null ? void 0 : _window2$criteo_q.push)) {
    var _structure$cookies, _structure$cookies$ac;
    window.criteo_q.push({
      account: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.ACCOUNT,
      event: 'setAccount'
    }, {
      event: 'setSiteType',
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.DOMAIN
    }, {
      email: (structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.email) || '',
      event: 'setEmail'
    }, getView({
      data: data,
      structure: structure
    }));
  }
};
/* harmony default export */ __webpack_exports__["default"] = (pageView);

/***/ }),

/***/ 33385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ACCOUNT": function() { return /* binding */ ACCOUNT; },
/* harmony export */   "DOMAIN": function() { return /* binding */ DOMAIN; },
/* harmony export */   "PAGES": function() { return /* binding */ PAGES; }
/* harmony export */ });
var ACCOUNT = [6459, 53315];
var DOMAIN = "m";
var PAGES = ['product', 'home', 'search', 'subcategory'];

/***/ }),

/***/ 78807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addProductToCart": function() { return /* binding */ addProductToCart; },
/* harmony export */   "addServicesToCart": function() { return /* binding */ addServicesToCart; },
/* harmony export */   "addToCartError": function() { return /* binding */ addToCartError; },
/* harmony export */   "addToCartSuccess": function() { return /* binding */ addToCartSuccess; },
/* harmony export */   "buildCheckoutTrace": function() { return /* binding */ buildCheckoutTrace; },
/* harmony export */   "buildCommonEvent": function() { return /* binding */ buildCommonEvent; },
/* harmony export */   "buildServicesEventLabel": function() { return /* binding */ buildServicesEventLabel; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85942);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19777);
/* harmony import */ var _utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15950);
/* harmony import */ var _utils_productFormatter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67412);
/* harmony import */ var _utils_getTypeButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22078);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59075);








var addToCartError = function addToCartError(_ref) {
  var product = _ref.product,
    error = _ref.error;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    eventAction: 'add-to-cart:error',
    eventCategory: _constants__WEBPACK_IMPORTED_MODULE_5__.GENERAL_PRODUCT,
    eventLabel: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(error).toLowerCase(),
    eventNonInteraction: '1'
  }, (0,_utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_1__["default"])(product));
};
var buildCheckoutTrace = function buildCheckoutTrace(_ref2) {
  var eventCategory = _ref2.eventCategory,
    typeButton = _ref2.typeButton;
  return "".concat(eventCategory, "->").concat(typeButton);
};
var buildCommonEvent = function buildCommonEvent() {
  var _structure$cookies, _structure$cookies$ac, _product$seller, _product$shipping, _product$shipping$, _product$shipping$$pa, _product$shipping$$pa2, _product$price;
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$product = _ref3.product,
    product = _ref3$product === void 0 ? {} : _ref3$product,
    services = _ref3.services,
    _ref3$location = _ref3.location,
    location = _ref3$location === void 0 ? {} : _ref3$location,
    _ref3$structure = _ref3.structure,
    structure = _ref3$structure === void 0 ? {} : _ref3$structure,
    eventId = _ref3.eventId;
  var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'geral';
  return {
    currency: _constants__WEBPACK_IMPORTED_MODULE_5__.CURRENCY,
    ecommerce: {
      add: {
        products: [(0,_utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, product, {
          accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id,
          id: product == null ? void 0 : product.variationId,
          location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(location),
          overview: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_3__["default"])(services !== undefined ? {
            product: product,
            services: services
          } : product, formatter),
          shippingValues: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_3__["default"])(product, 'frete')
        }))]
      }
    },
    event: 'addToCart',
    eventAction: 'add-to-cart',
    eventId: eventId,
    eventNonInteraction: '0',
    produtoDisponivel: product == null ? void 0 : product.available,
    sellerEntrega: product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.deliveryId,
    tipoDeCliente: undefined,
    valorFrete: product == null ? void 0 : (_product$shipping = product.shipping) == null ? void 0 : (_product$shipping$ = _product$shipping[0]) == null ? void 0 : (_product$shipping$$pa = _product$shipping$.packages) == null ? void 0 : (_product$shipping$$pa2 = _product$shipping$$pa[0]) == null ? void 0 : _product$shipping$$pa2.price,
    value: parseFloat(product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.fullPrice)
  };
};
var buildServicesEventLabel = function buildServicesEventLabel(servicesId, services) {
  if (!(servicesId == null ? void 0 : servicesId.length)) return 'servico:nenhum';
  var selectedServices = services.reduce(function (acc, item) {
    var offerSelected = item == null ? void 0 : item.offers.filter(function (offer) {
      return servicesId.includes(offer.id);
    });
    return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(acc), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(offerSelected));
  }, []);
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .mapNestedKey */ .yC)(Object.values(selectedServices), 'description').map(function (desc) {
    return "servico:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(desc)).toLowerCase();
  }).join('|');
};
var addProductToCart = function addProductToCart(_ref4) {
  var location = _ref4.location,
    product = _ref4.product,
    typeButton = _ref4.typeButton,
    _ref4$structure = _ref4.structure,
    structure = _ref4$structure === void 0 ? {} : _ref4$structure,
    eventId = _ref4.eventId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    eventCategory: _constants__WEBPACK_IMPORTED_MODULE_5__.GENERAL_PRODUCT,
    eventLabel: 'adicionar-a-sacola',
    inicioCheckout: buildCheckoutTrace({
      eventCategory: _constants__WEBPACK_IMPORTED_MODULE_5__.GENERAL_PRODUCT,
      typeButton: typeButton
    }),
    screenName: 'produto'
  }, buildCommonEvent({
    eventId: eventId,
    location: location,
    product: product,
    structure: structure
  }));
};
var addServicesToCart = function addServicesToCart(_ref5) {
  var location = _ref5.location,
    product = _ref5.product,
    services = _ref5.services,
    typeButton = _ref5.typeButton,
    eventId = _ref5.eventId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    eventCategory: 'servico',
    eventLabel: buildServicesEventLabel(services, product == null ? void 0 : product.financialServices),
    inicioCheckout: buildCheckoutTrace({
      eventCategory: 'servico',
      typeButton: typeButton
    }),
    screenName: 'servico'
  }, buildCommonEvent({
    eventId: eventId,
    location: location,
    product: product,
    services: services
  }, 'service'));
};
var addToCartSuccess = function addToCartSuccess(_ref6) {
  var location = _ref6.location,
    product = _ref6.product,
    services = _ref6.services,
    defaultTypeButton = _ref6.typeButton;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var typeButton = (0,_utils_getTypeButton__WEBPACK_IMPORTED_MODULE_4__["default"])(defaultTypeButton);
  if (services !== undefined) return addServicesToCart((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    location: location,
    product: product,
    services: services,
    typeButton: typeButton
  }, args));
  return addProductToCart((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    location: location,
    product: product,
    typeButton: typeButton
  }, args));
};

/***/ }),

/***/ 97100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildBlogPageView": function() { return /* binding */ buildBlogPageView; }
/* harmony export */ });
var blogPageView = function blogPageView(_ref) {
  var structure = _ref.structure;
  return {
    clientId: structure == null ? void 0 : structure.cookies.clientId,
    device: structure == null ? void 0 : structure.device,
    event: 'virtualPageview',
    idParceiro: structure == null ? void 0 : structure.cookies.partnerId,
    idUsuario: structure == null ? void 0 : structure.cookies.customerId,
    pageType: "blog-".concat(structure == null ? void 0 : structure.id),
    screenName: "blog ".concat(structure == null ? void 0 : structure.name)
  };
};
var buildBlogPageView = function buildBlogPageView(_ref2) {
  var structure = _ref2.structure;
  var siteName = structure.site;
  if (siteName === 'blog' || siteName === 'blog-mobile') {
    return blogPageView({
      structure: structure
    });
  }
  return null;
};

/***/ }),

/***/ 6870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "postClick": function() { return /* binding */ postClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var postClick = function postClick(_ref, _ref2) {
  var title = _ref.title,
    categoryId = _ref.categoryId,
    recomendationLayout = _ref.recomendationLayout;
  var structure = _ref2.structure;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "blog:".concat(structure == null ? void 0 : structure.id, ":").concat(recomendationLayout),
    eventLabel: "post:".concat(categoryId, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(title))
  };
};

/***/ }),

/***/ 73191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "shareBlogButtonClick": function() { return /* binding */ shareBlogButtonClick; }
/* harmony export */ });
var shareBlogButtonClick = function shareBlogButtonClick(_ref, _ref2) {
  var socialName = _ref.socialName;
  var structure = _ref2.structure;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "blog-".concat(structure == null ? void 0 : structure.id, ":redes-sociais"),
    eventLabel: "".concat(socialName)
  };
};

/***/ }),

/***/ 31956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buyBoxButtonClick": function() { return /* binding */ buyBoxButtonClick; },
/* harmony export */   "buyBoxSeeMoreOffers": function() { return /* binding */ buyBoxSeeMoreOffers; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19777);


var buildBuyBoxImpression = function buildBuyBoxImpression() {
  return {
    content_id: 'veja-mais-ofertas-para-este-produto',
    content_type: 'produto',
    event: 'select_content'
  };
};
var buildBuyBoxButtonImpression = function buildBuyBoxButtonImpression(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var product = _ref.product,
    structure = _ref.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    eventAction: 'add-to-cart:click',
    eventCategory: 'produto:geral',
    eventLabel: 'escolha-a-melhor-oferta',
    eventNonInteraction: '0'
  }, (0,_utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id
  }, product)));
};
var buyBoxButtonClick = function buyBoxButtonClick(_ref2) {
  var product = _ref2.product;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildBuyBoxButtonImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    product: product
  }, args));
};
var buyBoxSeeMoreOffers = function buyBoxSeeMoreOffers() {
  return buildBuyBoxImpression();
};

/***/ }),

/***/ 58346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buyButtonClick": function() { return /* binding */ buyButtonClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19777);
/* harmony import */ var _utils_getTypeButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22078);



var buildEventLabels = function buildEventLabels(type) {
  return type === 'typeFloat' ? {
    eventCategory: 'produto:flutuante',
    eventLabel: (0,_utils_getTypeButton__WEBPACK_IMPORTED_MODULE_1__["default"])('oneTouch')
  } : {
    eventCategory: 'produto:geral',
    eventLabel: (0,_utils_getTypeButton__WEBPACK_IMPORTED_MODULE_1__["default"])(type)
  };
};
var buildBuyButtonClick = function buildBuyButtonClick(_ref) {
  var _structure$cookies, _structure$cookies$ac;
  var _ref$structure = _ref.structure,
    structure = _ref$structure === void 0 ? {} : _ref$structure,
    product = _ref.product,
    typeButton = _ref.typeButton;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: 'clickEvent'
  }, buildEventLabels(typeButton), {
    eventAction: 'add-to-cart:click',
    eventNonInteraction: '0'
  }, (0,_utils_buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, product, {
    accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id
  })));
};
var buyButtonClick = function buyButtonClick(_ref2) {
  var product = _ref2.product,
    typeButton = _ref2.typeButton;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildBuyButtonClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    product: product,
    typeButton: typeButton
  }));
};

/***/ }),

/***/ 68789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buybuttonServicesOnClick": function() { return /* binding */ buybuttonServicesOnClick; }
/* harmony export */ });
var buybuttonServicesOnClick = function buybuttonServicesOnClick(_ref) {
  var _product$price, _product$price2;
  var product = _ref.product;
  return {
    basketId: undefined,
    currency: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.currency,
    event: 'add_to_cart',
    eventAction: 'add-to-cart',
    eventCategory: 'sacola:produto',
    eventLabel: 'ver-produtos-e-precos',
    item: product,
    screenName: 'carrinho',
    value: Number((product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.fullPrice) || 0)
  };
};

/***/ }),

/***/ 82378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickFollowSellerEvent": function() { return /* binding */ clickFollowSellerEvent; }
/* harmony export */ });
var buildFollowSellerEvent = function buildFollowSellerEvent(isFollowing, sellerId) {
  return {
    content_id: isFollowing ? 'seguir' : 'nao-seguir',
    content_type: "chat-lojista:".concat(sellerId),
    event: 'select_content',
    mini_app_name: 'fale-lojista'
  };
};
var clickFollowSellerEvent = function clickFollowSellerEvent(_ref) {
  var isFollowing = _ref.isFollowing,
    sellerId = _ref.sellerId;
  return buildFollowSellerEvent(isFollowing, sellerId);
};

/***/ }),

/***/ 6450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "chatbotLuClick": function() { return /* binding */ chatbotLuClick; },
/* harmony export */   "chatbotLuImpression": function() { return /* binding */ chatbotLuImpression; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildChatBotEvent = function buildChatBotEvent(_ref) {
  var pagetype = _ref.pagetype;
  return {
    event: 'clickEvent',
    eventAction: 'impression',
    eventCategory: "".concat(pagetype, ":chatbot-lu"),
    eventLabel: 'chat',
    pagetype: pagetype
  };
};
var chatbotLuClick = function chatbotLuClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pagetype = _ref2.pagetype;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildChatBotEvent({
    pagetype: pagetype
  }), {
    eventAction: 'click'
  });
};
var chatbotLuImpression = function chatbotLuImpression() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pagetype = _ref3.pagetype;
  return buildChatBotEvent({
    pagetype: pagetype
  });
};

/***/ }),

/***/ 59075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CURRENCY": function() { return /* binding */ CURRENCY; },
/* harmony export */   "DELIVERY": function() { return /* binding */ DELIVERY; },
/* harmony export */   "GENERAL_PRODUCT": function() { return /* binding */ GENERAL_PRODUCT; }
/* harmony export */ });
var CURRENCY = 'BRL';
var DELIVERY = {
  delivery_24h: 'entrega-em-1-dia-util',
  delivery_plus_1: 'entrega-em-2-dias-uteis',
  magalu_indica: 'magalu-indica',
  'magalu-entregas': 'entregue-por-magalu',
  'magalu-partner': 'perto-de-voce',
  promocao_sazonal_1: 'ofertas-de-natal',
  promocao_sazonal_2: 'cupons',
  promocao_sazonal_3: 'super-ofertas',
  promocao_sazonal_4: 'ofertas-fantasticas',
  store_pickup_available: 'retira-na-loja'
};
var GENERAL_PRODUCT = 'produto:geral';

/***/ }),

/***/ 7779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var buildContinueToCartImpression = function buildContinueToCartImpression(data) {
  var _data$shipping, _data$shipping$, _data$shipping$$packa, _data$shipping2, _data$shipping2$, _data$shipping2$$pack, _data$shipping2$$pack2, _data$shipping2$$pack3, _data$category, _data$seller, _data$seller2, _data$seller3, _data$seller4, _data$subcategory;
  var shippingPackage = (data == null ? void 0 : (_data$shipping = data.shipping) == null ? void 0 : (_data$shipping$ = _data$shipping[0]) == null ? void 0 : (_data$shipping$$packa = _data$shipping$.packages) == null ? void 0 : _data$shipping$$packa[0]) || {};
  var hasPickupStore = !!(data == null ? void 0 : (_data$shipping2 = data.shipping) == null ? void 0 : (_data$shipping2$ = _data$shipping2[0]) == null ? void 0 : (_data$shipping2$$pack = _data$shipping2$.packages) == null ? void 0 : (_data$shipping2$$pack2 = _data$shipping2$$pack[0]) == null ? void 0 : (_data$shipping2$$pack3 = _data$shipping2$$pack2.deliveryTypes) == null ? void 0 : _data$shipping2$$pack3.some(function (el) {
    return el.type === 'store_pickup';
  }));
  return {
    categorias: data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id,
    categoriaSeller: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    event: 'clickEvent',
    eventAction: 'add-to-cart:click',
    eventCategory: 'home:continuar-compra',
    eventLabel: 'continuar-sua-compra',
    eventNonInteraction: '0',
    freteTotal: shippingPackage == null ? void 0 : shippingPackage.price,
    nomeSeller: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    produtoClube: (data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.discounts) ? 'verdadeiro' : 'falso',
    produtoDisponivel: (data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso',
    produtoFavoritado: undefined,
    retiraLoja: hasPickupStore ? 'verdadeiro' : 'falso',
    sellerEntrega: data == null ? void 0 : (_data$seller4 = data.seller) == null ? void 0 : _data$seller4.id,
    sku: data == null ? void 0 : data.id,
    subcategorias: data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id
  };
};
var continueToCart = function continueToCart(_ref) {
  var product = _ref.product;
  return buildContinueToCartImpression(product);
};
/* harmony default export */ __webpack_exports__["default"] = (continueToCart);

/***/ }),

/***/ 71330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "didYouMeanSelect": function() { return /* binding */ didYouMeanSelect; },
/* harmony export */   "didYouMeanView": function() { return /* binding */ didYouMeanView; }
/* harmony export */ });
var contentType = 'busca';
var didYouMeanSelect = function didYouMeanSelect(_ref) {
  var raw = _ref.raw,
    refined = _ref.refined;
  return {
    content_id: refined,
    content_type: contentType,
    event: 'select_content',
    raw: raw
  };
};
var didYouMeanView = function didYouMeanView(_ref2) {
  var raw = _ref2.raw,
    refined = _ref2.refined;
  return {
    content_id: refined,
    content_type: contentType,
    event: 'view_content',
    raw: raw
  };
};

/***/ }),

/***/ 1602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);



var displayType = function displayType() {
  var _args$structure, _args$structure$cooki, _args$structure2, _args$structure3, _args$structure3$rout, _args$structure4, _args$structure4$rout, _args$structure5, _args$structure5$rout, _args$structure6, _args$structure6$rout, _args$data;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (data == null ? void 0 : data.label) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location),
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.name) || '', ":grid"),
    eventLabel: data.label,
    eventNonInteraction: '0',
    pageCategory: (args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : (_args$structure3$rout = _args$structure3.route) == null ? void 0 : _args$structure3$rout.categoryId) || 'nao-se-aplica',
    pageSubcategory: (args == null ? void 0 : (_args$structure4 = args.structure) == null ? void 0 : (_args$structure4$rout = _args$structure4.route) == null ? void 0 : _args$structure4$rout.subCategoryId) || 'nao-se-aplica',
    termoBuscado: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure5 = args.structure) == null ? void 0 : (_args$structure5$rout = _args$structure5.route) == null ? void 0 : _args$structure5$rout.term),
    termoDigitado: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure6 = args.structure) == null ? void 0 : (_args$structure6$rout = _args$structure6.route) == null ? void 0 : _args$structure6$rout.term)
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"])(args.data.channel)));
};
/* harmony default export */ __webpack_exports__["default"] = (displayType);

/***/ }),

/***/ 64056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildFilterClick": function() { return /* binding */ buildFilterClick; },
/* harmony export */   "fastFilterClick": function() { return /* binding */ fastFilterClick; },
/* harmony export */   "fastFilterView": function() { return /* binding */ fastFilterView; },
/* harmony export */   "filterClean": function() { return /* binding */ filterClean; },
/* harmony export */   "filterClose": function() { return /* binding */ filterClose; },
/* harmony export */   "filterDeliveryClear": function() { return /* binding */ filterDeliveryClear; },
/* harmony export */   "filterDeliverySelect": function() { return /* binding */ filterDeliverySelect; },
/* harmony export */   "filterItemClick": function() { return /* binding */ filterItemClick; },
/* harmony export */   "filterLinkListClick": function() { return /* binding */ filterLinkListClick; },
/* harmony export */   "filterOpen": function() { return /* binding */ filterOpen; },
/* harmony export */   "filterRemove": function() { return /* binding */ filterRemove; },
/* harmony export */   "filterTypeClick": function() { return /* binding */ filterTypeClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59740);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27903);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59075);


var _excluded = ["eventLabel", "eventAction"];



var buildFilterClick = function buildFilterClick(_ref) {
  var data = _ref.data,
    _ref$eventLabel = _ref.eventLabel,
    eventLabel = _ref$eventLabel === void 0 ? '' : _ref$eventLabel,
    _ref$eventCategory = _ref.eventCategory,
    eventCategory = _ref$eventCategory === void 0 ? 'filtro' : _ref$eventCategory,
    _ref$eventAction = _ref.eventAction,
    eventAction = _ref$eventAction === void 0 ? 'click' : _ref$eventAction,
    structure = _ref.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: eventAction,
    eventCategory: "".concat((structure == null ? void 0 : structure.name) || '', ":").concat(eventCategory),
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__["default"])(data.channel)));
};
var filterItemClickLabel = function filterItemClickLabel(custom, selected) {
  if (custom) return 'selecionar';
  return "".concat(selected ? 'remover' : 'adicionar', "-filtro");
};
var filterDeliveryClick = function filterDeliveryClick(_ref2) {
  var _args$structure, _args$structure$cooki;
  var _ref2$eventLabel = _ref2.eventLabel,
    eventLabel = _ref2$eventLabel === void 0 ? '' : _ref2$eventLabel,
    eventAction = _ref2.eventAction,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location)
  }, buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: eventAction,
    eventCategory: 'delivery',
    eventLabel: _constants__WEBPACK_IMPORTED_MODULE_1__.DELIVERY[eventLabel || '']
  })));
};
var fastFilterClick = function fastFilterClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterLabel = _ref3.filterLabel,
    filterValue = _ref3.slug;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'click',
    eventCategory: "filtro-rapido",
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(filterLabel), ":").concat(filterValue)
  }));
};
var fastFilterView = function fastFilterView() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    eventLabel = _ref4.eventLabel;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'impression',
    eventCategory: "filtro-rapido",
    eventLabel: eventLabel
  }));
};
var filterClean = function filterClean() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventLabel: 'limpar-tudo'
  }));
};
var filterClose = function filterClose() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventLabel: 'fechar'
  }));
};
var filterDeliveryClear = function filterDeliveryClear() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return filterDeliveryClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'limpar'
  }));
};
var filterDeliverySelect = function filterDeliverySelect() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return filterDeliveryClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: 'aplicar'
  }));
};
var filterItemClick = function filterItemClick() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    filterLabel = _ref5.filterLabel,
    _ref5$position = _ref5.position,
    position = _ref5$position === void 0 ? '' : _ref5$position,
    label = _ref5.label,
    _ref5$selected = _ref5.selected,
    selected = _ref5$selected === void 0 ? false : _ref5$selected,
    _ref5$searchTerm = _ref5.searchTerm,
    searchTerm = _ref5$searchTerm === void 0 ? '' : _ref5$searchTerm,
    _ref5$custom = _ref5.custom,
    custom = _ref5$custom === void 0 ? false : _ref5$custom;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: "".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(filterLabel)),
    eventLabel: "".concat(filterItemClickLabel(custom, selected), ":").concat(position || '', ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)).concat(searchTerm && ":".concat(searchTerm))
  }));
};
var filterLinkListClick = function filterLinkListClick() {
  var _args$structure2;
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    label = _ref6.label;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var pathName = (args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.name) || '';
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventCategory: 'consultas-relacionadas',
    eventLabel: "".concat(pathName, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label))
  }));
};
var filterOpen = function filterOpen() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventLabel: 'abrir'
  }));
};
var filterRemove = function filterRemove() {
  var _args$structure3;
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    position = _ref7.position,
    label = _ref7.label;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _args$structure$route = args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : _args$structure3.route,
    _args$structure$route2 = _args$structure$route.term,
    term = _args$structure$route2 === void 0 ? '' : _args$structure$route2;
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: "".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)),
    eventLabel: "remover-filtro-busca:".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)).concat(term && ":".concat(term))
  }));
};
var filterTypeClick = function filterTypeClick() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref8$label = _ref8.label,
    label = _ref8$label === void 0 ? '' : _ref8$label,
    _ref8$position = _ref8.position,
    position = _ref8$position === void 0 ? '' : _ref8$position;
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildFilterClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, args, {
    eventAction: "".concat(position, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)),
    eventLabel: "selecionar-categoria:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label))
  }));
};

/***/ }),

/***/ 75088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "financialServicesSeparateSaleDetailsOnClick": function() { return /* binding */ financialServicesSeparateSaleDetailsOnClick; },
/* harmony export */   "financialServicesSeparateSaleOnChange": function() { return /* binding */ financialServicesSeparateSaleOnChange; },
/* harmony export */   "financialServicesSeparateSaleOnView": function() { return /* binding */ financialServicesSeparateSaleOnView; },
/* harmony export */   "financialServicesSeparateSalePaymentOnClick": function() { return /* binding */ financialServicesSeparateSalePaymentOnClick; },
/* harmony export */   "financialServicesSeparateSaleSeeMoreOnClick": function() { return /* binding */ financialServicesSeparateSaleSeeMoreOnClick; },
/* harmony export */   "financialServicesSeparateSaleTermOnClick": function() { return /* binding */ financialServicesSeparateSaleTermOnClick; },
/* harmony export */   "financialServicesSeparateSaleVideoOnClick": function() { return /* binding */ financialServicesSeparateSaleVideoOnClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var screenName = 'adicione-protecao';
var sellerName = 'mlseguros';
var financialServicesSeparateSaleDetailsOnClick = function financialServicesSeparateSaleDetailsOnClick() {
  return {
    content_id: 'detalhes-do-seguro',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleOnChange = function financialServicesSeparateSaleOnChange(_ref) {
  var validity = _ref.validity;
  return {
    content_id: "meses-de-garantia-".concat(validity),
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleOnView = function financialServicesSeparateSaleOnView(_ref2) {
  var device = _ref2.device,
    partnerId = _ref2.partnerId,
    userId = _ref2.userId,
    userIsLogged = _ref2.userIsLogged,
    userLocation = _ref2.userLocation;
  return {
    barraLocalizacao: undefined,
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(userLocation),
    device: "site-".concat(device),
    event: 'virtualPageview',
    existeDelivery: undefined,
    hitTimestamp: new Date().getTime(),
    idDaLoja: sellerName,
    idParceiro: partnerId,
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    nomeDaLoja: sellerName,
    pageType: 'servico',
    screenName: screenName,
    usuarioClube: undefined
  };
};
var financialServicesSeparateSalePaymentOnClick = function financialServicesSeparateSalePaymentOnClick() {
  return {
    content_id: 'ir-para-pagamento',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleSeeMoreOnClick = function financialServicesSeparateSaleSeeMoreOnClick() {
  return {
    content_id: 'ver-mais',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleTermOnClick = function financialServicesSeparateSaleTermOnClick() {
  return {
    content_id: 'termos-de-autorizacao-cobranca',
    content_type: screenName,
    event: 'select_content'
  };
};
var financialServicesSeparateSaleVideoOnClick = function financialServicesSeparateSaleVideoOnClick() {
  return {
    content_id: 'ver-video',
    content_type: screenName,
    event: 'select_content'
  };
};

/***/ }),

/***/ 96134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickEvent": function() { return /* binding */ clickEvent; },
/* harmony export */   "gateKeeperButtonClick": function() { return /* binding */ gateKeeperButtonClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var clickEvent = function clickEvent(_ref) {
  var _ref$ga = _ref.ga,
    ga = _ref$ga === void 0 ? {} : _ref$ga;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'porteiro',
    eventLabel: 'cta',
    eventNonInteraction: 0
  }, ga);
};
var gateKeeperButtonClick = function gateKeeperButtonClick(data) {
  return data && clickEvent(data);
};

/***/ }),

/***/ 8139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickEvent": function() { return /* binding */ clickEvent; },
/* harmony export */   "hotlinkClick": function() { return /* binding */ hotlinkClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var clickEvent = function clickEvent(_ref, config) {
  var _config$structure;
  var text = _ref.text,
    _ref$ga = _ref.ga,
    ga = _ref$ga === void 0 ? {} : _ref$ga;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat(config == null ? void 0 : (_config$structure = config.structure) == null ? void 0 : _config$structure.name, ":hotlinks"),
    eventLabel: text,
    eventNonInteraction: 0
  }, ga);
};
var hotlinkClick = function hotlinkClick(data, config) {
  return data && clickEvent(data, config);
};

/***/ }),

/***/ 6115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24169);
/* harmony import */ var _addtocart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78807);
/* harmony import */ var _buybox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31956);
/* harmony import */ var _buybutton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58346);
/* harmony import */ var _blogPost__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6870);
/* harmony import */ var _continueToCart__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(7779);
/* harmony import */ var _pageView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96617);
/* harmony import */ var _pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(66298);
/* harmony import */ var _productList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84638);
/* harmony import */ var _paginate__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(64141);
/* harmony import */ var _reviewFilterClick__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(42354);
/* harmony import */ var _zipCodeBar__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(46091);
/* harmony import */ var _signin__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(84950);
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87003);
/* harmony import */ var _hotlinks__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(8139);
/* harmony import */ var _gatekeeperbutton__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(96134);
/* harmony import */ var _luContent__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(89937);
/* harmony import */ var _menu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1772);
/* harmony import */ var _linkSuggestions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48383);
/* harmony import */ var _suggestionImpression__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81656);
/* harmony import */ var _subcategoryList__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(43444);
/* harmony import */ var _displayType__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1602);
/* harmony import */ var _sort__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77948);
/* harmony import */ var _filter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64056);
/* harmony import */ var _product__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63707);
/* harmony import */ var _shipping__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90803);
/* harmony import */ var _review__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56778);
/* harmony import */ var _blogbutton__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(73191);
/* harmony import */ var _viewItem__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67663);
/* harmony import */ var _miniapps__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23481);
/* harmony import */ var _questions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(84093);
/* harmony import */ var _blogPageView__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(97100);
/* harmony import */ var _sellerDetails__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(92908);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(42340);
/* harmony import */ var _productTags__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(1041);
/* harmony import */ var _productLabels__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(39478);
/* harmony import */ var _productBenefits__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(44541);
/* harmony import */ var _chatbotLu__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6450);
/* harmony import */ var _sellerChat__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(48339);
/* harmony import */ var _reviewFormSubmit__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(96866);
/* harmony import */ var _promotionBanner__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(31519);
/* harmony import */ var _financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(75088);
/* harmony import */ var _buybuttonServices__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(68789);
/* harmony import */ var _didYouMean__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(71330);
/* harmony import */ var _spacePageView__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(29563);
/* harmony import */ var _chatConversationFollowSeller__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(82378);














































var events = {
  'action:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_signin__WEBPACK_IMPORTED_MODULE_22__.signInClick)],
  'addtocart:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addtocart__WEBPACK_IMPORTED_MODULE_1__.addToCartError)],
  'addtocart:success': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addtocart__WEBPACK_IMPORTED_MODULE_1__.addToCartSuccess)],
  'blogpost:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_blogPost__WEBPACK_IMPORTED_MODULE_4__.postClick)],
  'buybox:addtocart': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybox__WEBPACK_IMPORTED_MODULE_2__.buyBoxButtonClick)],
  'buybox:seemoreoffers': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybox__WEBPACK_IMPORTED_MODULE_2__.buyBoxSeeMoreOffers)],
  'buybutton-services:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybuttonServices__WEBPACK_IMPORTED_MODULE_23__.buybuttonServicesOnClick)],
  'buybuttons:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_buybutton__WEBPACK_IMPORTED_MODULE_3__.buyButtonClick)],
  'chat-conversation:followSeller:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_chatConversationFollowSeller__WEBPACK_IMPORTED_MODULE_24__.clickFollowSellerEvent)],
  'chatbotLu:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_chatbotLu__WEBPACK_IMPORTED_MODULE_25__.chatbotLuClick)],
  'chatbotLu:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_chatbotLu__WEBPACK_IMPORTED_MODULE_25__.chatbotLuImpression)],
  'continuetocart:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_continueToCart__WEBPACK_IMPORTED_MODULE_26__["default"])],
  'delivery:filter:clear': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterDeliveryClear)],
  'delivery:filter:selected': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterDeliverySelect)],
  'didyoumean:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_didYouMean__WEBPACK_IMPORTED_MODULE_27__.didYouMeanSelect)],
  'didyoumean:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_didYouMean__WEBPACK_IMPORTED_MODULE_27__.didYouMeanView)],
  'financial-services-separate-sale:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSaleOnChange)],
  'financial-services-separate-sale:details:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSaleDetailsOnClick)],
  'financial-services-separate-sale:payment:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSalePaymentOnClick)],
  'financial-services-separate-sale:seemore:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSaleSeeMoreOnClick)],
  'financial-services-separate-sale:term:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSaleTermOnClick)],
  'financial-services-separate-sale:video:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSaleVideoOnClick)],
  'financial-services-separate-sale:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_financialServicesSeparateSale__WEBPACK_IMPORTED_MODULE_21__.financialServicesSeparateSaleOnView)],
  'gatekeeper:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_gatekeeperbutton__WEBPACK_IMPORTED_MODULE_28__.gateKeeperButtonClick)],
  'hotlink:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_hotlinks__WEBPACK_IMPORTED_MODULE_29__.hotlinkClick)],
  'link-suggestions:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_linkSuggestions__WEBPACK_IMPORTED_MODULE_9__.suggestionLinkClick)],
  'link-suggestions:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_suggestionImpression__WEBPACK_IMPORTED_MODULE_10__.suggestionImpression)],
  'listlink:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterLinkListClick)],
  'lucontent:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_luContent__WEBPACK_IMPORTED_MODULE_30__.luContentClick)],
  'lucontent:socialmedia:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_luContent__WEBPACK_IMPORTED_MODULE_30__.luContentSocialMediaClick)],
  'lucontent:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_luContent__WEBPACK_IMPORTED_MODULE_30__.luContentView)],
  'menu:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_menu__WEBPACK_IMPORTED_MODULE_8__.menuClick)],
  'menu:header:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_menu__WEBPACK_IMPORTED_MODULE_8__.menuHeaderClick)],
  pageview: [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pageView__WEBPACK_IMPORTED_MODULE_5__["default"]), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.questionPageView), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_miniapps__WEBPACK_IMPORTED_MODULE_18__.miniAppLoad), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_blogPageView__WEBPACK_IMPORTED_MODULE_31__.buildBlogPageView), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_16__.reviewPageView), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.servicesPageView)],
  pageviewspace: [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_spacePageView__WEBPACK_IMPORTED_MODULE_32__.spacePageView)],
  'paginate:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_paginate__WEBPACK_IMPORTED_MODULE_33__.paginateClick)],
  'pmd:sharelinks:add:ready:bag:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__.addToReadyBag)],
  'pmd:sharelinks:generate:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__.generateLink)],
  'pmd:sharelinks:share:product:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_pmdShareLinks__WEBPACK_IMPORTED_MODULE_34__.shareProduct)],
  'product:attribute:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_product__WEBPACK_IMPORTED_MODULE_14__.productAttributeClick)],
  'product:benefits:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productBenefits__WEBPACK_IMPORTED_MODULE_35__.productBenefitsLinkClick)],
  'product:benefits:tags:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productTags__WEBPACK_IMPORTED_MODULE_36__.productTagsClick)],
  'product:benefits:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productBenefits__WEBPACK_IMPORTED_MODULE_35__.productBenefitsView)],
  'product:details': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItem__WEBPACK_IMPORTED_MODULE_17__["default"])],
  'product:label:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productLabels__WEBPACK_IMPORTED_MODULE_37__.productLabelClick)],
  'product:paymentmethod:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_product__WEBPACK_IMPORTED_MODULE_14__.productPaymentMethodChange)],
  'product:paymentmethod:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_product__WEBPACK_IMPORTED_MODULE_14__.productPaymentMethodClick)],
  'product:review:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_16__.productReviewClick)],
  'product:review:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_16__.productReviewSubmit)],
  'product:reviewform:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewFormSubmit__WEBPACK_IMPORTED_MODULE_38__["default"])],
  'product:shipping:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_15__.shippingImpression)],
  'product:shipping:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_15__.shippingClick)],
  'product:shipping:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_15__.shippingError)],
  'product:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productView)],
  'productlist:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productListClick)],
  'productlist:display:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_displayType__WEBPACK_IMPORTED_MODULE_11__["default"])],
  'productlist:fastFilter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.fastFilterClick)],
  'productlist:fastFilter:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.fastFilterView)],
  'productlist:filter:clean': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterClean)],
  'productlist:filter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterItemClick)],
  'productlist:filter:close': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterClose)],
  'productlist:filter:open': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterOpen)],
  'productlist:filter:remove': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterRemove)],
  'productlist:filter:showdetail': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_filter__WEBPACK_IMPORTED_MODULE_13__.filterTypeClick)],
  'productlist:showFullList': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productListShowFullList)],
  'productlist:showmore': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.productListShowMore)],
  'productlist:sort:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sort__WEBPACK_IMPORTED_MODULE_12__["default"])],
  'productlist:start:experiment': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.startExperiment)],
  'promotion:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.selectPromotionBanner)],
  'promotion:video:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.selectPromotionBannerVideo)],
  'promotion:video:complete': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.videoCompletePromotionBanner)],
  'promotion:video:progress': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.videoProgressPromotionBanner)],
  'promotion:video:start': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.videoStartPromotionBanner)],
  'promotion:video:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.viewPromotionBannerVideo)],
  'promotion:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_promotionBanner__WEBPACK_IMPORTED_MODULE_39__.viewPromotionBanner)],
  'question:form:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.questionClickOpenConfirm)],
  'question:miniapp:open:float:modal': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.clickMiniappFloatButtonForm)],
  'question:open:float:modal': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.clickFloatButtonForm)],
  'question-confirm:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.questionClickConfirmQuestion)],
  'question-feedback:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.questionFeedbackResponseError)],
  'question-form:see-more': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.questionFormSeeMore)],
  'question-list:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_questions__WEBPACK_IMPORTED_MODULE_19__.questionListImpression)],
  'review:filter:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewFilterClick__WEBPACK_IMPORTED_MODULE_40__["default"])],
  'reviewlist:button:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_16__.writeReviewClick)],
  'reviewlist:sort:change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_16__.reviewListSort)],
  'reviewpdp:button:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_review__WEBPACK_IMPORTED_MODULE_16__.reviewPdpClick)],
  'search:clear': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.searchClear)],
  'search:close': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.searchClose)],
  'search:submit': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.searchSubmit)],
  'sellerchat:conversation:onview': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerChat__WEBPACK_IMPORTED_MODULE_41__.conversationOnView)],
  'sellerchat:inbox:conversations:onclick': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerChat__WEBPACK_IMPORTED_MODULE_41__.inboxConversationOnClick)],
  'sellerchat:inbox:conversations:onview': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerChat__WEBPACK_IMPORTED_MODULE_41__.inboxConversationListOnView)],
  'sellerdetails:click:about:rating': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsRatingClick)],
  'sellerdetails:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerScoreImpression)],
  'sellerdetails:offers:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsOffersLinkClick)],
  'sellerdetails:open:modal:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsClickOpenModal)],
  'sellerdetailspdp:open:modal:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_sellerDetails__WEBPACK_IMPORTED_MODULE_42__.sellerDetailsPdpLinkClick)],
  'services:add': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.addService)],
  'services:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.clickService)],
  'services:know-more': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.servicesKnowMore)],
  'services:legal-info': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.servicesLegalInfo)],
  'services:more-details': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.servicesMoreDetails)],
  'services:offer-change': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.servicesOfferChange)],
  'services:refuse': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.refuseService)],
  'services:video': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_services__WEBPACK_IMPORTED_MODULE_20__.servicesVideo)],
  'shareblog:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_blogbutton__WEBPACK_IMPORTED_MODULE_43__.shareBlogButtonClick)],
  'subcategoryfulllist:click': (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subcategoryList__WEBPACK_IMPORTED_MODULE_44__.subcategoryFullListClick),
  'subcategorylist:click': (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subcategoryList__WEBPACK_IMPORTED_MODULE_44__.subcategoryListClick),
  'subcategorytop:click': (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_subcategoryList__WEBPACK_IMPORTED_MODULE_44__.subcategoryTopClick),
  'suggestion:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.suggestionClick)],
  'suggestion:topterm:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__.topTermClick)],
  'variation:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_productList__WEBPACK_IMPORTED_MODULE_6__.variationClick)],
  'zipcodebar:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarClick)],
  'zipcodebar:popup:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipClick)],
  'zipcodebar:popup:close': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipClose)],
  'zipcodebar:popup:success': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipView)],
  'zipcodebar:popup:view': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarTooltipView)],
  'zipcodebar:response:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarResponseError)],
  'zipcodebar:response:success': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_zipCodeBar__WEBPACK_IMPORTED_MODULE_45__.zipCodeBarResponseSuccess)]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 48383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "suggestionLinkClick": function() { return /* binding */ suggestionLinkClick; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var suggestionLinkClick = function suggestionLinkClick(link) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'magalu-has',
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(link.value).toLowerCase())
  };
};

/***/ }),

/***/ 89937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildLuContent": function() { return /* binding */ buildLuContent; },
/* harmony export */   "buildLuContentClickImpression": function() { return /* binding */ buildLuContentClickImpression; },
/* harmony export */   "buildLuContentSocialMediaClickImpression": function() { return /* binding */ buildLuContentSocialMediaClickImpression; },
/* harmony export */   "buildLuContentViewImpression": function() { return /* binding */ buildLuContentViewImpression; },
/* harmony export */   "luContentClick": function() { return /* binding */ luContentClick; },
/* harmony export */   "luContentSocialMediaClick": function() { return /* binding */ luContentSocialMediaClick; },
/* harmony export */   "luContentView": function() { return /* binding */ luContentView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildLuContent = function buildLuContent(_ref) {
  var id = _ref.id,
    title = _ref.title,
    position = _ref.position;
  return {
    id: id,
    name: title,
    position: position
  };
};
var buildLuContentClickImpression = function buildLuContentClickImpression() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pageType = _ref2.pageType,
    id = _ref2.id,
    title = _ref2.title,
    position = _ref2.position,
    _ref2$eventLabel = _ref2.eventLabel,
    eventLabel = _ref2$eventLabel === void 0 ? 'materia' : _ref2$eventLabel;
  return {
    ecommerce: {
      promoClick: {
        promotions: [{
          id: id,
          name: title,
          position: position
        }]
      }
    },
    event: 'promotionClick',
    eventAction: 'click',
    eventCategory: "".concat(pageType, ":lu-explica"),
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  };
};
var buildLuContentSocialMediaClickImpression = function buildLuContentSocialMediaClickImpression() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    pageType = _ref3.pageType,
    id = _ref3.id;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat(pageType, ":redes-sociais"),
    eventLabel: id,
    eventNonInteraction: '0'
  };
};
var buildLuContentViewImpression = function buildLuContentViewImpression(_ref4) {
  var _ref4$eventLabel = _ref4.eventLabel,
    eventLabel = _ref4$eventLabel === void 0 ? 'materias' : _ref4$eventLabel,
    pageType = _ref4.pageType,
    _ref4$promotions = _ref4.promotions,
    promotions = _ref4$promotions === void 0 ? [] : _ref4$promotions;
  return {
    ecommerce: {
      promoView: {
        promotions: promotions.map(function (promotion) {
          return buildLuContent(promotion);
        })
      }
    },
    event: 'promotionView',
    eventAction: 'impression',
    eventCategory: "".concat(pageType, ":lu-explica"),
    eventLabel: eventLabel,
    eventNonInteraction: 1
  };
};
var luContentClick = function luContentClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref5.structure;
  return buildLuContentClickImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, {
    pageType: structure == null ? void 0 : structure.name
  }));
};
var luContentSocialMediaClick = function luContentSocialMediaClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref6.structure;
  return buildLuContentSocialMediaClickImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, {
    pageType: structure == null ? void 0 : structure.name
  }));
};
var luContentView = function luContentView(data) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    structure = _ref7.structure;
  return buildLuContentViewImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, {
    pageType: structure == null ? void 0 : structure.name
  }));
};

/***/ }),

/***/ 1772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "menuClick": function() { return /* binding */ menuClick; },
/* harmony export */   "menuHeaderClick": function() { return /* binding */ menuHeaderClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);


var buildEvent = {
  event: 'clickEvent',
  eventAction: 'click',
  eventCategory: 'menu',
  eventNonInteraction: '0'
};
var handleContact = function handleContact(label) {
  return label === 'compre-pelo-chat' ? 'chat' : 'telefone';
};
var clickHeaderEvent = function clickHeaderEvent(structure, label) {
  var _ref = (structure == null ? void 0 : structure.cookies) || {},
    accountData = _ref.accountData;
  var accountStatus = accountData ? 'logado' : 'deslogado';
  var headerLabel = accountData ? 'meu-espaco' : 'entre-ou-cadastre-se';
  var termLabel = label ? "".concat(accountStatus, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)) : headerLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, buildEvent, {
    eventLabel: termLabel
  });
};
var clickEvent = function clickEvent(positionLabel, label) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, buildEvent, {
    eventLabel: "".concat(positionLabel || '').concat(positionLabel === 'contato:' ? handleContact((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label)) : (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label))
  });
};
var menuClick = function menuClick(_ref2) {
  var positionLabel = _ref2.positionLabel,
    label = _ref2.label;
  return clickEvent(positionLabel, label);
};
var menuHeaderClick = function menuHeaderClick(_ref3) {
  var structure = _ref3.structure,
    label = _ref3.label;
  return clickHeaderEvent(structure, label);
};

/***/ }),

/***/ 23481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildParamsByPath": function() { return /* binding */ buildParamsByPath; },
/* harmony export */   "miniAppLoad": function() { return /* binding */ miniAppLoad; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var baseMiniAppParams = function baseMiniAppParams(userId) {
  return {
    idUsuario: userId,
    loginAtivo: userId ? 'logado' : 'nao-logado'
  };
};
var buildParamsByPath = function buildParamsByPath() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var userId = arguments.length > 1 ? arguments[1] : undefined;
  var siteId = arguments.length > 2 ? arguments[2] : undefined;
  var pathParams = {
    'product-review': {
      event: 'customScreenView',
      mini_app_name: 'avaliacao'
    },
    questions: {
      mini_app_name: 'perguntas-e-respostas',
      pageType: 'perguntas',
      screenName: 'webview:perguntas-e-respostas'
    },
    'review-list': {
      event: 'customScreenView',
      mini_app_name: 'avaliacao',
      pageType: 'avaliacao',
      screenName: 'avaliacao'
    }
  };
  var params = pathParams[id];
  if (params && siteId === 'mini-apps') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, baseMiniAppParams(userId), params);
  }
  return {};
};
var customScreenView = function customScreenView(structure) {
  var _ref = (structure == null ? void 0 : structure.cookies) || {},
    accountData = _ref.accountData;
  var userId = accountData == null ? void 0 : accountData.id;
  var customParams = buildParamsByPath(structure == null ? void 0 : structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'customScreenView'
  }, customParams);
};
var buildMiniAppLoad = function buildMiniAppLoad(eventListener) {
  return function (_ref2) {
    var _ref2$structure = _ref2.structure,
      structure = _ref2$structure === void 0 ? {} : _ref2$structure;
    var pageId = structure.id,
      siteId = structure.site;
    if (pageId === 'questions' && siteId === 'mini-apps') {
      return eventListener(structure);
    }
    return null;
  };
};
var miniAppLoad = buildMiniAppLoad(customScreenView);

/***/ }),

/***/ 96617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_productFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67412);
/* harmony import */ var _utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15950);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27903);





var parseEcommerce = function parseEcommerce(data) {
  return (data == null ? void 0 : data.pageType) === 'produto' && (data == null ? void 0 : data.products) ? {
    ecommerce: {
      detail: {
        products: data.products.map(function (product) {
          return (0,_utils_gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, product, {
            accountId: data.accountId,
            location: data.location,
            overview: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_1__["default"])(product, 'geral'),
            query: data.query,
            shippingValues: (0,_utils_productFormatter__WEBPACK_IMPORTED_MODULE_1__["default"])(product, 'frete')
          }));
        })
      }
    }
  } : {};
};
var pageView = function pageView(data) {
  var _data$products, _data$products2, _data$products3, _data$products3$, _data$products3$$ship, _data$products3$$ship2, _data$products3$$ship3, _data$products3$$ship4;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    barraLocalizacao: data.zipCodeBar ? 'verdadeiro' : 'falso',
    cepPreenchido: (data == null ? void 0 : data.zipCode) ? 'verdadeiro' : 'falso',
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    clientId: data == null ? void 0 : data.clientId,
    device: data.device,
    event: 'virtualPageview',
    existeDelivery: (data == null ? void 0 : data.valuesFilterDelivery) || undefined,
    fbc: data.fbc,
    fbp: data.fbp,
    idParceiro: (data == null ? void 0 : data.partnerId) || undefined,
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    impressaoElemento: 1,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'deslogado',
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: data.pageType,
    screenName: data.pageType,
    siteName: data == null ? void 0 : data.site,
    usuarioClube: undefined
  }, data.pageType === 'busca' && {
    termoBuscado: (data == null ? void 0 : data.term) || undefined
  }, (data == null ? void 0 : data.products) && {
    listaVazia: (data == null ? void 0 : (_data$products = data.products) == null ? void 0 : _data$products.length) > 0 ? 'falso' : 'verdadeiro'
  }, {
    valorFrete: data.pageType === 'produto' && (data == null ? void 0 : (_data$products2 = data.products) == null ? void 0 : _data$products2.length) > 0 ? data == null ? void 0 : (_data$products3 = data.products) == null ? void 0 : (_data$products3$ = _data$products3[0]) == null ? void 0 : (_data$products3$$ship = _data$products3$.shipping) == null ? void 0 : (_data$products3$$ship2 = _data$products3$$ship[0]) == null ? void 0 : (_data$products3$$ship3 = _data$products3$$ship2.packages) == null ? void 0 : (_data$products3$$ship4 = _data$products3$$ship3[0]) == null ? void 0 : _data$products3$$ship4.price : undefined
  }, data.storeDimensions, parseEcommerce(data));
};
var willPageViewTrigger = function willPageViewTrigger(siteName, pageType) {
  var excludedSites = ['blog'];
  var excludedPages = ['listagem-de-reviews', 'avaliar-produto', 'service-new'];
  return !(excludedSites.includes(siteName) || excludedPages.includes(pageType));
};
var buildPageView = function buildPageView(listener) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      structure = _ref.structure,
      data = _ref.data;
    var _ref2 = structure || {},
      _ref2$name = _ref2.name,
      pageType = _ref2$name === void 0 ? 'busca' : _ref2$name,
      _ref2$device = _ref2.device,
      device = _ref2$device === void 0 ? 'mobile' : _ref2$device,
      components = _ref2.components,
      siteName = _ref2.site,
      query = _ref2.query;
    var _ref3 = (structure == null ? void 0 : structure.cookies) || {},
      location = _ref3.location,
      clientId = _ref3.clientId,
      accountData = _ref3.accountData,
      partnerId = _ref3.partnerId;
    var _ref4 = (structure == null ? void 0 : structure.route) || {},
      term = _ref4.term,
      slug = _ref4.slug,
      categoryId = _ref4.categoryId,
      subCategoryId = _ref4.subCategoryId;
    if (willPageViewTrigger(siteName, pageType)) {
      var _data$search, _data$search2, _data$search2$filters, _filterBySlug$values, _filterBySlug$values$;
      var products = pageType === 'produto' && data.product ? [data.product] : data == null ? void 0 : (_data$search = data.search) == null ? void 0 : _data$search.products;
      var filterBySlug = data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : (_data$search2$filters = _data$search2.filters) == null ? void 0 : _data$search2$filters.find(_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .filterByDelivery */ .wz);
      var valuesFilterDelivery = filterBySlug == null ? void 0 : (_filterBySlug$values = filterBySlug.values) == null ? void 0 : (_filterBySlug$values$ = _filterBySlug$values.map(function (item) {
        return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(item.label);
      })) == null ? void 0 : _filterBySlug$values$.join('|');
      var storeDimensions = (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.channel);
      return listener({
        accountId: accountData == null ? void 0 : accountData.id,
        accountName: accountData == null ? void 0 : accountData.name,
        categoryId: categoryId,
        clientId: clientId,
        device: "site-".concat(device),
        fbc: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)('_fbc'),
        fbp: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)('_fbp'),
        location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(location),
        pageType: pageType,
        partnerId: partnerId,
        products: products,
        query: query,
        slug: slug,
        storeDimensions: storeDimensions,
        subCategoryId: subCategoryId,
        term: term,
        valuesFilterDelivery: valuesFilterDelivery,
        zipCode: location == null ? void 0 : location.zipCode,
        zipCodeBar: components == null ? void 0 : components.find(function (_ref5) {
          var name = _ref5.name;
          return name === 'ZipCodeBar';
        })
      });
    }
    return null;
  };
};
/* harmony default export */ __webpack_exports__["default"] = (buildPageView(pageView));

/***/ }),

/***/ 64141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "paginateClick": function() { return /* binding */ paginateClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59740);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);


var _excluded = ["structure"];

var clickEvent = function clickEvent(_ref2, _ref) {
  var _args$data;
  var eventLabel = _ref2.eventLabel;
  var structure = _ref.structure,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat(structure == null ? void 0 : structure.name, ":paginacao"),
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"])(args.data.channel)));
};
var paginateClick = function paginateClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return clickEvent(data, args);
};

/***/ }),

/***/ 66298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToReadyBag": function() { return /* binding */ addToReadyBag; },
/* harmony export */   "generateLink": function() { return /* binding */ generateLink; },
/* harmony export */   "shareProduct": function() { return /* binding */ shareProduct; }
/* harmony export */ });
var addToReadyBag = function addToReadyBag(_ref) {
  var productId = _ref.productId,
    productName = _ref.productName;
  return {
    event: 'add_to_ready_bag',
    item_id: productId,
    item_name: productName
  };
};
var generateLink = function generateLink(_ref2) {
  var pageType = _ref2.pageType,
    productId = _ref2.productId,
    productName = _ref2.productName;
  return {
    content_type: "".concat(pageType, ":gerar-link"),
    event: 'generate_link',
    item_id: productId,
    item_name: productName
  };
};
var shareProduct = function shareProduct(_ref3) {
  var shareAction = _ref3.shareAction,
    pageType = _ref3.pageType,
    productId = _ref3.productId,
    productName = _ref3.productName;
  return {
    content_id: shareAction,
    content_type: "".concat(pageType, ":compartilhar-link"),
    event: 'share_product',
    item_id: productId,
    item_name: productName
  };
};

/***/ }),

/***/ 63707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildActualPaymentClick": function() { return /* binding */ buildActualPaymentClick; },
/* harmony export */   "buildPaymentMethodChange": function() { return /* binding */ buildPaymentMethodChange; },
/* harmony export */   "productAttributeClick": function() { return /* binding */ productAttributeClick; },
/* harmony export */   "productPaymentMethodChange": function() { return /* binding */ productPaymentMethodChange; },
/* harmony export */   "productPaymentMethodClick": function() { return /* binding */ productPaymentMethodClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildAttributeImpression = function buildAttributeImpression() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref.type,
    value = _ref.value;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:variacao',
    eventLabel: "".concat(type, ":").concat(value),
    eventNonInteraction: '0'
  };
};
var buildPaymentMethodImpression = function buildPaymentMethodImpression() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:forma-de-pagamento',
    eventNonInteraction: '0'
  };
};
var Enum = {
  luiza_ouro: 'cartao-luiza',
  visa: 'cartao-de-credito'
};
var buildActualPaymentClick = function buildActualPaymentClick(_ref2) {
  var _ref2$paymentId = _ref2.paymentId,
    paymentId = _ref2$paymentId === void 0 ? 'visa' : _ref2$paymentId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildPaymentMethodImpression(), {
    eventLabel: "visualizar:".concat(Enum[paymentId] || paymentId)
  });
};
var buildPaymentMethodChange = function buildPaymentMethodChange(_ref3) {
  var paymentId = _ref3.paymentId;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildPaymentMethodImpression(), {
    eventLabel: "selecionar:".concat(Enum[paymentId] || paymentId)
  });
};
var productAttributeClick = function productAttributeClick(data) {
  return buildAttributeImpression(data);
};
var productPaymentMethodChange = function productPaymentMethodChange(data) {
  return buildPaymentMethodChange(data);
};
var productPaymentMethodClick = function productPaymentMethodClick(data) {
  return buildActualPaymentClick(data);
};

/***/ }),

/***/ 44541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productBenefitsLinkClick": function() { return /* binding */ productBenefitsLinkClick; },
/* harmony export */   "productBenefitsView": function() { return /* binding */ productBenefitsView; }
/* harmony export */ });
var buildBenefitsLinkClick = function buildBenefitsLinkClick(_ref) {
  var eventLabel = _ref.eventLabel;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:beneficios',
    eventLabel: eventLabel,
    eventNonInteraction: 0
  };
};
var buldBenefitsImpression = function buldBenefitsImpression(_ref2) {
  var labels = _ref2.labels,
    offerTags = _ref2.offerTags;
  var label;
  if (offerTags == null ? void 0 : offerTags.includes('magalu_indica')) {
    label = labels.join(':');
  } else {
    label = labels.slice(1).join(':');
  }
  return {
    event: 'clickEvent',
    eventAction: 'impression',
    eventCategory: 'produto:beneficios',
    eventLabel: label,
    eventNonInteraction: 0
  };
};
var productBenefitsLinkClick = function productBenefitsLinkClick() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    eventLabel = _ref3.eventLabel;
  return eventLabel && buildBenefitsLinkClick({
    eventLabel: eventLabel
  });
};
var productBenefitsView = function productBenefitsView(_ref4) {
  var labels = _ref4.labels,
    offerTags = _ref4.offerTags;
  return labels && buldBenefitsImpression({
    labels: labels,
    offerTags: offerTags
  });
};

/***/ }),

/***/ 39478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productLabelClick": function() { return /* binding */ productLabelClick; }
/* harmony export */ });
var buildEvent = function buildEvent(_ref) {
  var label = _ref.label,
    variationId = _ref.variationId;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:etiqueta',
    eventLabel: "".concat(label, ":").concat(variationId),
    eventNonInteraction: 0
  };
};
var productLabelClick = function productLabelClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    label = _ref2.label,
    variationId = _ref2.variationId;
  return label && variationId && buildEvent({
    label: label,
    variationId: variationId
  });
};

/***/ }),

/***/ 84638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildProductImpression": function() { return /* binding */ buildProductImpression; },
/* harmony export */   "productListClick": function() { return /* binding */ productListClick; },
/* harmony export */   "productListShowFullList": function() { return /* binding */ productListShowFullList; },
/* harmony export */   "productListShowMore": function() { return /* binding */ productListShowMore; },
/* harmony export */   "productListView": function() { return /* binding */ productListView; },
/* harmony export */   "productView": function() { return /* binding */ productView; },
/* harmony export */   "startExperiment": function() { return /* binding */ startExperiment; },
/* harmony export */   "variationClick": function() { return /* binding */ variationClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59740);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90545);


var _excluded = ["accountId", "id", "variationId", "title", "list"],
  _excluded2 = ["eventCategory", "structure"],
  _excluded3 = ["list", "filters", "listPosition", "origin", "display"],
  _excluded4 = ["product", "list", "filters", "listPosition", "origin", "display"];


var eventLabel = 'product-list';
var displayEnum = {
  gallery: 'galeria',
  list: 'lista',
  miniature: 'miniatura'
};
var buildProductImpression = function buildProductImpression() {
  var _data$brand, _data$category, _data$subcategory, _data$installment, _data$seller, _data$seller2, _data$attributes, _data$attributes2, _data$attributes2$, _data$offerTags, _data$contextSearch, _data$rating, _data$price, _data$price2, _data$parsedAttribute, _data$parsedAttribute2, _data$parsedAttribute3, _data$rating2, _data$badges, _data$badges$, _data$geoLocTags, _data$shippingTag, _data$shippingTag2, _data$shippingTag3, _data$shippingTag4, _data$shippingTag5, _data$price3, _data$price4;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var accountId = _ref.accountId,
    id = _ref.id,
    variationId = _ref.variationId,
    name = _ref.title,
    list = _ref.list,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    brand: (data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || undefined,
    category: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .categoryToString */ .H6)(data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id, data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id),
    dimension10: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.handleOrigin)(data),
    dimension11: data == null ? void 0 : data.listPosition,
    dimension12: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaBoolean */ .w6)(data == null ? void 0 : data.available),
    dimension13: accountId ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaBoolean */ .w6)(data == null ? void 0 : data.isOnWishlist) : undefined,
    dimension14: 'falso',
    dimension15: data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount,
    dimension16: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    dimension17: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    dimension18: (data == null ? void 0 : (_data$attributes = data.attributes) == null ? void 0 : _data$attributes.length) ? data == null ? void 0 : (_data$attributes2 = data.attributes) == null ? void 0 : (_data$attributes2$ = _data$attributes2[0]) == null ? void 0 : _data$attributes2$.value : undefined,
    dimension26: data == null ? void 0 : data.term,
    dimension41: "etiqueta:".concat((data == null ? void 0 : (_data$offerTags = data.offerTags) == null ? void 0 : _data$offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0'),
    dimension48: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSelectedFilters */ .Q8)(data == null ? void 0 : data.filters),
    dimension49: data == null ? void 0 : data.orderBy,
    dimension52: (data == null ? void 0 : data.contextSearch) ? data == null ? void 0 : (_data$contextSearch = data.contextSearch) == null ? void 0 : _data$contextSearch.value : 'none',
    dimension60: displayEnum[data == null ? void 0 : data.display],
    dimension62: undefined,
    dimension65: list,
    dimension68: data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : _data$rating.score,
    dimension70: (data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.bestPrice) ? data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.price : undefined,
    dimension72: data == null ? void 0 : data.location,
    dimension74: data == null ? void 0 : (_data$parsedAttribute = data.parsedAttributes) == null ? void 0 : (_data$parsedAttribute2 = _data$parsedAttribute[0]) == null ? void 0 : (_data$parsedAttribute3 = _data$parsedAttribute2.values) == null ? void 0 : _data$parsedAttribute3.length,
    dimension76: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getBestPriceDiscount)(data),
    dimension77: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getDiscount)(data),
    dimension78: (0,_utils__WEBPACK_IMPORTED_MODULE_1__.getInstallmentQuantity)(data),
    dimension79: data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : _data$rating2.count,
    dimension85: data == null ? void 0 : data.page,
    dimension86: "selo:".concat((data == null ? void 0 : (_data$badges = data.badges) == null ? void 0 : (_data$badges$ = _data$badges[0]) == null ? void 0 : _data$badges$.text) || 'sem-selo', "|tags:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$geoLocTags = data.geoLocTags) == null ? void 0 : _data$geoLocTags.title) || 'sem-tag')
  }, (data == null ? void 0 : data.showcase) ? {
    dimension90: "".concat(data.showcase.pageId, "-").concat(data.showcase.placeId).concat(data.showcase.id ? "-".concat(data.showcase.id) : ''),
    dimension91: data.showcase.type,
    dimension92: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data.showcase.title)
  } : {}, {
    dimension112: !(0,_utils__WEBPACK_IMPORTED_MODULE_1__.isSomeParametersEmpty)(data == null ? void 0 : data.shippingTag) ? "entrega-padr\xE3o:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$shippingTag = data.shippingTag) == null ? void 0 : _data$shippingTag.time) || 'null'), ":").concat((data == null ? void 0 : (_data$shippingTag2 = data.shippingTag) == null ? void 0 : _data$shippingTag2.cost) === 0 ? 0 : (data == null ? void 0 : (_data$shippingTag3 = data.shippingTag) == null ? void 0 : _data$shippingTag3.cost) || 'null', "|retira-loja:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$shippingTag4 = data.shippingTag) == null ? void 0 : _data$shippingTag4.complement) || 'null'), ":").concat((data == null ? void 0 : (_data$shippingTag5 = data.shippingTag) == null ? void 0 : _data$shippingTag5.source) || 'null') : undefined,
    id: variationId || id,
    list: list,
    name: name,
    position: data == null ? void 0 : data.position,
    price: (data == null ? void 0 : (_data$price3 = data.price) == null ? void 0 : _data$price3.bestPrice) || (data == null ? void 0 : (_data$price4 = data.price) == null ? void 0 : _data$price4.price) || undefined,
    quantity: '1',
    variant: variationId
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_utils__WEBPACK_IMPORTED_MODULE_1__.channelStoreDimensions)(data.channel)));
};
var buildProductListView = function buildProductListView(_ref3, _ref2) {
  var _ref3$products = _ref3.products,
    products = _ref3$products === void 0 ? [] : _ref3$products,
    _ref3$list = _ref3.list,
    list = _ref3$list === void 0 ? '' : _ref3$list,
    filters = _ref3.filters,
    origin = _ref3.origin,
    display = _ref3.display,
    listPosition = _ref3.listPosition,
    showcase = _ref3.showcase;
  var eventCategory = _ref2.eventCategory,
    structure = _ref2.structure,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);
  return {
    ecommerce: {
      impressions: products.map(function (product) {
        var _structure$cookies, _structure$cookies$ac, _product$price, _structure$cookies2, _gaSortFallback, _structure$route, _structure$route2, _structure$route3, _structure$route4, _structure$route5;
        return buildProductImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, product, args, {
          accountId: structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id,
          discount: Number((product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.discount) || 0) ? "".concat(Number(product.price.discount), "%") : undefined,
          display: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(display),
          filters: filters,
          list: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(list),
          listPosition: listPosition,
          location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.location),
          orderBy: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(((_gaSortFallback = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSortFallback */ .j1)({
            orientation: structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.sortOrientation,
            type: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.sortType
          })) == null ? void 0 : _gaSortFallback.label) || '') || undefined,
          origin: origin,
          page: (structure == null ? void 0 : (_structure$route3 = structure.route) == null ? void 0 : _structure$route3.page) ? "page-".concat(structure == null ? void 0 : (_structure$route4 = structure.route) == null ? void 0 : _structure$route4.page) : 'page-1',
          showcase: showcase,
          term: structure == null ? void 0 : (_structure$route5 = structure.route) == null ? void 0 : _structure$route5.term,
          title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : product.title)
        }));
      })
    },
    event: 'productListView',
    eventAction: 'impression',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '1'
  };
};
var buildProductListClick = function buildProductListClick(_ref4, _ref5) {
  var _structure$cookies3, _gaSortFallback2, _structure$route6, _structure$route7, _structure$route8, _structure$route9, _structure$route10;
  var eventCategory = _ref5.eventCategory,
    structure = _ref5.structure;
  var _ref4$list = _ref4.list,
    list = _ref4$list === void 0 ? '' : _ref4$list,
    filters = _ref4.filters,
    listPosition = _ref4.listPosition,
    origin = _ref4.origin,
    display = _ref4.display,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref4, _excluded3);
  return {
    ecommerce: {
      click: {
        actionField: {
          list: list || undefined
        },
        products: [buildProductImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, {
          display: display,
          filters: filters,
          list: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(list),
          listPosition: listPosition,
          location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(structure == null ? void 0 : (_structure$cookies3 = structure.cookies) == null ? void 0 : _structure$cookies3.location),
          orderBy: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(((_gaSortFallback2 = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSortFallback */ .j1)({
            orientation: structure == null ? void 0 : (_structure$route6 = structure.route) == null ? void 0 : _structure$route6.sortOrientation,
            type: structure == null ? void 0 : (_structure$route7 = structure.route) == null ? void 0 : _structure$route7.sortType
          })) == null ? void 0 : _gaSortFallback2.label) || '') || undefined,
          origin: origin,
          page: (structure == null ? void 0 : (_structure$route8 = structure.route) == null ? void 0 : _structure$route8.page) ? "page-".concat(structure == null ? void 0 : (_structure$route9 = structure.route) == null ? void 0 : _structure$route9.page) : 'page-1',
          term: structure == null ? void 0 : (_structure$route10 = structure.route) == null ? void 0 : _structure$route10.term,
          title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.title)
        }))]
      }
    },
    event: 'productListClick',
    eventAction: 'product-click',
    eventCategory: eventCategory,
    eventLabel: "product-list:".concat(data.variationId || data.id),
    eventNonInteraction: '0'
  };
};
var productListClick = function productListClick() {
  var _args$structure, _args$structure2, _args$structure3;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildProductListClick(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    eventCategory: "".concat(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : _args$structure.name, ":").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSearchTerm)(args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.id, data, args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : _args$structure3.route))
  }, args));
};
var productListShowFullList = function productListShowFullList() {
  var _args$structure4;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure4 = args.structure) == null ? void 0 : _args$structure4.name) || '', ":veja-a-lista-completa"),
    eventLabel: data.eventLabel || '',
    eventNonInteraction: '0'
  };
};
var productListShowMore = function productListShowMore() {
  var _args$structure5;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure5 = args.structure) == null ? void 0 : _args$structure5.name) || '', ":mostrar-mais-produtos"),
    eventLabel: data.eventLabel || '',
    eventNonInteraction: '0'
  };
};
var productListView = function productListView() {
  var _args$structure6, _args$structure7, _args$structure8;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildProductListView(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    eventCategory: "".concat(args == null ? void 0 : (_args$structure6 = args.structure) == null ? void 0 : _args$structure6.name, ":").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSearchTerm)(args == null ? void 0 : (_args$structure7 = args.structure) == null ? void 0 : _args$structure7.id, data, args == null ? void 0 : (_args$structure8 = args.structure) == null ? void 0 : _args$structure8.route))
  }, args));
};
var buildProductItem = function buildProductItem() {
  var _structure$cookies4, _gaSortFallback3, _structure$route11, _structure$route12, _structure$route13;
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventCategory = _ref7.eventCategory,
    structure = _ref7.structure;
  var product = _ref6.product,
    _ref6$list = _ref6.list,
    list = _ref6$list === void 0 ? '' : _ref6$list,
    filters = _ref6.filters,
    listPosition = _ref6.listPosition,
    origin = _ref6.origin,
    display = _ref6.display,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref6, _excluded4);
  return {
    ecommerce: {
      impressions: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, buildProductImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, product, {
        display: display,
        filters: filters,
        list: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(list),
        listPosition: listPosition,
        location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(structure == null ? void 0 : (_structure$cookies4 = structure.cookies) == null ? void 0 : _structure$cookies4.location),
        orderBy: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(((_gaSortFallback3 = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .gaSortFallback */ .j1)({
          orientation: structure == null ? void 0 : (_structure$route11 = structure.route) == null ? void 0 : _structure$route11.sortOrientation,
          type: structure == null ? void 0 : (_structure$route12 = structure.route) == null ? void 0 : _structure$route12.sortType
        })) == null ? void 0 : _gaSortFallback3.label) || '') || undefined,
        origin: origin,
        term: structure == null ? void 0 : (_structure$route13 = structure.route) == null ? void 0 : _structure$route13.term,
        title: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(product == null ? void 0 : product.title)
      })))]
    },
    event: 'productListView',
    eventAction: 'impression',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '1'
  };
};
var productView = function productView() {
  var _args$structure9, _args$structure10, _args$structure11;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return buildProductItem(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    eventCategory: "".concat(args == null ? void 0 : (_args$structure9 = args.structure) == null ? void 0 : _args$structure9.name, ":").concat((0,_utils__WEBPACK_IMPORTED_MODULE_1__.getSearchTerm)(args == null ? void 0 : (_args$structure10 = args.structure) == null ? void 0 : _args$structure10.id, data, args == null ? void 0 : (_args$structure11 = args.structure) == null ? void 0 : _args$structure11.route))
  }, args));
};
var startExperiment = function startExperiment() {
  var _args$structure12, _data$abTesting, _data$abTesting2, _data$abTesting3, _data$abTesting4;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    event: 'Search_startExperiment',
    experimentChannel: args == null ? void 0 : (_args$structure12 = args.structure) == null ? void 0 : _args$structure12.device,
    experimentID: data == null ? void 0 : (_data$abTesting = data.abTesting) == null ? void 0 : _data$abTesting.id,
    experimentName: data == null ? void 0 : (_data$abTesting2 = data.abTesting) == null ? void 0 : _data$abTesting2.name,
    experimentVariantID: data == null ? void 0 : (_data$abTesting3 = data.abTesting) == null ? void 0 : _data$abTesting3.variantId,
    experimentVariantName: data == null ? void 0 : (_data$abTesting4 = data.abTesting) == null ? void 0 : _data$abTesting4.variantName
  };
};
var variationClick = function variationClick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "busca",
    eventLabel: "imagens-variacoes:".concat(data == null ? void 0 : data.type, ":").concat(data == null ? void 0 : data.value) || 0,
    eventNonInteraction: '0'
  };
};

/***/ }),

/***/ 1041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productTagsClick": function() { return /* binding */ productTagsClick; }
/* harmony export */ });
var buildEvent = function buildEvent(label) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:beneficios',
    eventLabel: label,
    eventNonInteraction: 0
  };
};
var productTagsClick = function productTagsClick(label) {
  return label && buildEvent(label);
};

/***/ }),

/***/ 31519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "selectPromotionBanner": function() { return /* binding */ selectPromotionBanner; },
/* harmony export */   "selectPromotionBannerVideo": function() { return /* binding */ selectPromotionBannerVideo; },
/* harmony export */   "videoCompletePromotionBanner": function() { return /* binding */ videoCompletePromotionBanner; },
/* harmony export */   "videoProgressPromotionBanner": function() { return /* binding */ videoProgressPromotionBanner; },
/* harmony export */   "videoStartPromotionBanner": function() { return /* binding */ videoStartPromotionBanner; },
/* harmony export */   "viewPromotionBanner": function() { return /* binding */ viewPromotionBanner; },
/* harmony export */   "viewPromotionBannerVideo": function() { return /* binding */ viewPromotionBannerVideo; }
/* harmony export */ });
var buildPromotionBanner = function buildPromotionBanner(eventType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isVideo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    content_type: isVideo ? 'video' : data == null ? void 0 : data.contentType,
    creative_name: "".concat(data == null ? void 0 : data.page, ":magalu:").concat(isVideo ? 'video' : data == null ? void 0 : data.contentType),
    creative_slot: "".concat(data == null ? void 0 : data.position, ":").concat(data == null ? void 0 : data.slot),
    dimension4: data == null ? void 0 : data.campaignId,
    event: eventType,
    location_id: "".concat(data == null ? void 0 : data.size, ":").concat(data == null ? void 0 : data.page, ":banner").concat((data == null ? void 0 : data.contentType) === 'banner_list' ? ":".concat((data == null ? void 0 : data.index) + 1) : ''),
    motorBanner: 'topsort',
    screenName: data == null ? void 0 : data.screenName
  };
};
var buildPromotionVideo = function buildPromotionVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    content_type: 'video',
    creative_slot: data == null ? void 0 : data.creative_slot,
    event: eventType,
    video_current_time: data == null ? void 0 : data.video_current_time,
    video_duration: data == null ? void 0 : data.video_duration,
    video_percent: data == null ? void 0 : data.video_percent,
    video_provider: 'interno',
    video_url: data == null ? void 0 : data.video_url,
    visible: 'true'
  };
};
var selectPromotionBanner = function selectPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('select_promotion', data);
};
var selectPromotionBannerVideo = function selectPromotionBannerVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('select_promotion', data, true);
};
var videoCompletePromotionBanner = function videoCompletePromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_complete');
};
var videoProgressPromotionBanner = function videoProgressPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_progress');
};
var videoStartPromotionBanner = function videoStartPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionVideo(data, 'video_start');
};
var viewPromotionBanner = function viewPromotionBanner() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('view_promotion', data);
};
var viewPromotionBannerVideo = function viewPromotionBannerVideo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return buildPromotionBanner('view_promotion', data, true);
};

/***/ }),

/***/ 84093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "baseFloatFormButtonClick": function() { return /* binding */ baseFloatFormButtonClick; },
/* harmony export */   "clickFloatButtonForm": function() { return /* binding */ clickFloatButtonForm; },
/* harmony export */   "clickMiniappFloatButtonForm": function() { return /* binding */ clickMiniappFloatButtonForm; },
/* harmony export */   "questionClickConfirmQuestion": function() { return /* binding */ questionClickConfirmQuestion; },
/* harmony export */   "questionClickOpenConfirm": function() { return /* binding */ questionClickOpenConfirm; },
/* harmony export */   "questionFeedbackResponseError": function() { return /* binding */ questionFeedbackResponseError; },
/* harmony export */   "questionFormSeeMore": function() { return /* binding */ questionFormSeeMore; },
/* harmony export */   "questionListImpression": function() { return /* binding */ questionListImpression; },
/* harmony export */   "questionPageView": function() { return /* binding */ questionPageView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _miniapps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23481);



var eventClick = 'clickEvent';
var buildLabel = function buildLabel(_ref) {
  var _data$questions, _structure$route, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure,
    userId = _ref.userId;
  var logged = userId ? 'logado' : 'nao-logado';
  var questionsLength = (data == null ? void 0 : (_data$questions = data.questions) == null ? void 0 : _data$questions.totalQuestions) || 0;
  var variationId = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId) || (structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.questionVariationId);
  return "".concat(variationId, "|").concat(logged, "|perguntas:").concat(questionsLength);
};
var eventCategory = 'produto:perguntas';
var eventNonInteraction = 1;
var baseFloatFormButtonClick = function baseFloatFormButtonClick(_ref2) {
  var _data$product;
  var data = _ref2.data,
    label = _ref2.label,
    userId = _ref2.userId,
    structure = _ref2.structure;
  var productId = (_data$product = data.product) == null ? void 0 : _data$product.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label), ":").concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    idUsuario: userId
  }, miniAppKeys);
};
var clickFloatButtonForm = function clickFloatButtonForm(_ref3, _ref4) {
  var label = _ref3.label,
    userId = _ref3.userId;
  var data = _ref4.data,
    structure = _ref4.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, baseFloatFormButtonClick({
    data: data,
    label: label,
    structure: structure,
    userId: userId
  }));
};
var clickMiniappFloatButtonForm = function clickMiniappFloatButtonForm(_ref5, _ref6) {
  var label = _ref5.label,
    userId = _ref5.userId;
  var data = _ref6.data,
    structure = _ref6.structure;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, baseFloatFormButtonClick({
    data: data,
    label: label,
    structure: structure,
    userId: userId
  }), {
    pageType: 'perguntas',
    screenName: 'webview:perguntas-e-respostas'
  });
};
var questionClickConfirmQuestion = function questionClickConfirmQuestion(_ref7, _ref8) {
  var _data$product2;
  var userId = _ref7.userId;
  var data = _ref8.data,
    structure = _ref8.structure;
  var productId = (_data$product2 = data.product) == null ? void 0 : _data$product2.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "confirmar:".concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: 0
  }, miniAppKeys);
};
var questionClickOpenConfirm = function questionClickOpenConfirm(_ref9, _ref10) {
  var _data$product3;
  var label = _ref9.label,
    userId = _ref9.userId;
  var data = _ref10.data,
    structure = _ref10.structure;
  var productId = (_data$product3 = data.product) == null ? void 0 : _data$product3.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label), ":").concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: 0
  }, miniAppKeys);
};
var questionFeedbackResponseError = function questionFeedbackResponseError(_ref11, _ref12) {
  var error = _ref11.error,
    userId = _ref11.userId;
  var structure = _ref12.structure;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: 'erro',
    eventCategory: eventCategory,
    eventLabel: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(error == null ? void 0 : error.message),
    eventNonInteraction: 1
  }, miniAppKeys);
};
var questionFormSeeMore = function questionFormSeeMore(_ref13, _ref14) {
  var _data$product4;
  var label = _ref13.label,
    userId = _ref13.userId;
  var data = _ref14.data,
    structure = _ref14.structure;
  var productId = data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(label), ":").concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: 0
  }, miniAppKeys);
};
var questionListImpression = function questionListImpression(_ref15, _ref16) {
  var _data$product5;
  var userId = _ref15.userId;
  var data = _ref16.data,
    structure = _ref16.structure;
  var productId = (_data$product5 = data.product) == null ? void 0 : _data$product5.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "impressao:".concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: eventNonInteraction
  }, miniAppKeys);
};
var viewItem = function viewItem(data, structure) {
  var _data$product6, _structure$cookies, _structure$cookies$ac;
  var productId = (_data$product6 = data.product) == null ? void 0 : _data$product6.id;
  var userId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id;
  var miniAppKeys = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(structure.id, userId, structure.site);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    event: eventClick,
    eventAction: "view_item:".concat(productId),
    eventCategory: eventCategory,
    eventLabel: buildLabel({
      data: data,
      structure: structure,
      userId: userId
    }),
    eventNonInteraction: eventNonInteraction
  }, miniAppKeys);
};
var buildQuestionPageView = function buildQuestionPageView(eventListener) {
  return function (_ref17) {
    var data = _ref17.data,
      structure = _ref17.structure;
    var pageId = structure.id;
    if (pageId === 'questions') {
      return eventListener(data, structure);
    }
    return null;
  };
};
var questionPageView = buildQuestionPageView(viewItem);

/***/ }),

/***/ 56778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productReviewClick": function() { return /* binding */ productReviewClick; },
/* harmony export */   "productReviewSubmit": function() { return /* binding */ productReviewSubmit; },
/* harmony export */   "reviewListSort": function() { return /* binding */ reviewListSort; },
/* harmony export */   "reviewPageView": function() { return /* binding */ reviewPageView; },
/* harmony export */   "reviewPdpClick": function() { return /* binding */ reviewPdpClick; },
/* harmony export */   "writeReviewClick": function() { return /* binding */ writeReviewClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _miniapps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23481);



var buildReviewPageView = function buildReviewPageView(_ref) {
  var structure = _ref.structure;
  var _ref2 = structure || {},
    components = _ref2.components,
    cookies = _ref2.cookies,
    id = _ref2.id,
    pageType = _ref2.name,
    route = _ref2.route,
    site = _ref2.site;
  var _ref3 = cookies || {},
    accountData = _ref3.accountData,
    customerId = _ref3.customerId;
  var allowedPageTypes = ['listagem-de-reviews', 'avaliar-produto'];
  var isReview = allowedPageTypes.includes(pageType);
  if (isReview) {
    var _cookies$location;
    var miniAppParams = (0,_miniapps__WEBPACK_IMPORTED_MODULE_1__.buildParamsByPath)(id, accountData == null ? void 0 : accountData.id, site);
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      barraLocalizacao: Number(!!(components == null ? void 0 : components.some(function (_ref4) {
        var name = _ref4.name;
        return name === 'ZipCodeBar';
      }))),
      cepPreenchido: Number(!!(cookies == null ? void 0 : (_cookies$location = cookies.location) == null ? void 0 : _cookies$location.zipCode)),
      cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(cookies == null ? void 0 : cookies.location),
      device: "site-".concat((structure == null ? void 0 : structure.device) || 'mobile'),
      event: 'virtualPageview',
      existeDelivery: 'falso',
      experimentId: undefined,
      idUsuario: customerId,
      loginAtivo: (accountData == null ? void 0 : accountData.id) ? 'logado' : 'deslogado',
      mundos: null,
      pageType: "".concat(pageType),
      permitirRastreio: undefined,
      screenName: "".concat(pageType),
      sku: route == null ? void 0 : route.productId,
      usuarioClube: null
    }, miniAppParams);
  }
  return null;
};
var buildReviewImpression = function buildReviewImpression() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:avaliacao',
    eventLabel: 'avaliacoes:avaliar',
    eventNonInteraction: '0'
  };
};
var statusType = {
  ERROR_DUPLICATE_SUBMISSION: 'erro',
  INVALID_PAYLOAD: 'erro',
  OK: 'sucesso'
};
var productReviewClick = function productReviewClick() {
  return buildReviewImpression();
};
var productReviewSubmit = function productReviewSubmit(_ref5) {
  var status = _ref5.status,
    errorMessage = _ref5.errorMessage;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewImpression(), {
    eventAction: (statusType == null ? void 0 : statusType[status]) || 'erro',
    eventLabel: errorMessage || 'sucesso'
  });
};
var buildReviewListImpression = function buildReviewListImpression(miniAppName) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewImpression(), {
    eventCategory: 'avaliacao:geral',
    mini_app_name: miniAppName
  });
};
var reviewListSort = function reviewListSort() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    miniAppName = _ref6.miniAppName,
    filterLabel = _ref6.filterLabel,
    sku = _ref6.sku;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewListImpression(miniAppName), {
    eventLabel: "".concat(filterLabel, ":").concat(sku)
  });
};
var reviewPageView = function reviewPageView(args) {
  return buildReviewPageView(args || {});
};
var reviewPdpClick = function reviewPdpClick() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewImpression(), {
    eventCategory: 'produto:avaliacao',
    eventLabel: 'ver-todas-as-avaliacoes'
  });
};
var writeReviewClick = function writeReviewClick() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    miniAppName = _ref7.miniAppName,
    buttonLabel = _ref7.buttonLabel,
    sku = _ref7.sku;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, buildReviewListImpression(miniAppName), {
    eventLabel: "".concat(buttonLabel, ":").concat(sku)
  });
};

/***/ }),

/***/ 42354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var reviewFilterClick = function reviewFilterClick(type, _ref) {
  var data = _ref.data,
    structure = _ref.structure;
  if (structure.config.isMiniApp) {
    return {
      event: 'clickEvent',
      eventAction: 'click',
      eventCategory: 'avaliacao:geral',
      eventLabel: "".concat(type, ":").concat(data.product.variationId),
      mini_app_name: 'avaliacao'
    };
  }
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'avaliacao:geral',
    eventLabel: "".concat(type, ":").concat(data.product.variationId)
  };
};
/* harmony default export */ __webpack_exports__["default"] = (reviewFilterClick);

/***/ }),

/***/ 96866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var reviewFormSubmit = function reviewFormSubmit(comment, rating, _ref) {
  var _structure$config;
  var structure = _ref.structure;
  var eventFormSubmit = {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'avaliar-produto',
    eventLabel: "finalizar-avaliacao:".concat(rating, ":").concat((comment == null ? void 0 : comment.length) ? 1 : 0),
    eventNonInteraction: '0',
    screenName: 'avaliar-produto'
  };
  if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventFormSubmit, {
      mini_app_name: 'avaliacao'
    });
  }
  return eventFormSubmit;
};
/* harmony default export */ __webpack_exports__["default"] = (reviewFormSubmit);

/***/ }),

/***/ 87003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildSearch": function() { return /* binding */ buildSearch; },
/* harmony export */   "searchClear": function() { return /* binding */ searchClear; },
/* harmony export */   "searchClose": function() { return /* binding */ searchClose; },
/* harmony export */   "searchSubmit": function() { return /* binding */ searchSubmit; },
/* harmony export */   "suggestionClick": function() { return /* binding */ suggestionClick; },
/* harmony export */   "topTermClick": function() { return /* binding */ topTermClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59740);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27903);


var _excluded = ["eventAction", "eventLabel", "channelDimensions"];


var clickEvent = function clickEvent(data, _ref) {
  var _args$data;
  var eventAction = _ref.eventAction,
    eventLabel = _ref.eventLabel,
    channelDimensions = _ref.channelDimensions,
    args = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    contextoDaBusca: (data == null ? void 0 : data.origin) || undefined,
    event: 'clickEvent',
    eventAction: eventAction,
    eventCategory: 'busca:autocomplete',
    eventLabel: eventLabel || (data == null ? void 0 : data.position) || undefined,
    eventNonInteraction: '0',
    termoBuscado: (data == null ? void 0 : data.searchValue) || undefined,
    termoDigitado: (data == null ? void 0 : data.term) || undefined
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_3__["default"])(args.data.channel)));
};
var buildSearch = function buildSearch(listener) {
  return function () {
    var _args$structure, _args$structure$cooki, _args$structure2, _args$structure2$rout;
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      origin = _ref2.origin,
      _ref2$term = _ref2.term,
      term = _ref2$term === void 0 ? '' : _ref2$term,
      position = _ref2.position;
    var args = arguments.length > 1 ? arguments[1] : undefined;
    return listener({
      location: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location),
      origin: origin,
      position: position,
      searchValue: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(term),
      term: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : (_args$structure2$rout = _args$structure2.route) == null ? void 0 : _args$structure2$rout.term)
    }, args);
  };
};
var onClear = function onClear(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click',
    eventLabel: 'limpar'
  }, args));
};
var searchClear = buildSearch(onClear);
var onClose = function onClose(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click',
    eventLabel: 'fechar'
  }, args));
};
var searchClose = buildSearch(onClose);
var onSearch = function onSearch(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'pesquisar',
    eventLabel: 'termo'
  }, args));
};
var searchSubmit = buildSearch(onSearch);
var onClick = function onClick(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click'
  }, args));
};
var suggestionClick = buildSearch(onClick);
var onClickTop = function onClickTop(data, args) {
  return clickEvent(data, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    eventAction: 'click',
    eventLabel: data.searchValue ? "top:".concat(data == null ? void 0 : data.searchValue) : undefined
  }, args));
};
var topTermClick = buildSearch(onClickTop);

/***/ }),

/***/ 48339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "conversationOnView": function() { return /* binding */ conversationOnView; },
/* harmony export */   "inboxConversationListOnView": function() { return /* binding */ inboxConversationListOnView; },
/* harmony export */   "inboxConversationOnClick": function() { return /* binding */ inboxConversationOnClick; },
/* harmony export */   "locationToString": function() { return /* binding */ locationToString; }
/* harmony export */ });
var conversationOnView = function conversationOnView(_ref) {
  var userId = _ref.userId,
    userIsLogged = _ref.userIsLogged,
    userLocation = _ref.userLocation,
    sellerName = _ref.sellerName;
  return {
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: locationToString(userLocation),
    event: 'virtualPageview',
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    mini_app_name: 'fale-lojista',
    pageType: 'chat',
    screenName: 'chat-lojista',
    seller: "seller:".concat(sellerName)
  };
};
var inboxConversationListOnView = function inboxConversationListOnView(_ref2) {
  var userId = _ref2.userId,
    userIsLogged = _ref2.userIsLogged,
    userLocation = _ref2.userLocation;
  return {
    cepPreenchido: userLocation.zipCode ? 1 : 0,
    cidadeuf: locationToString(userLocation),
    event: 'virtualPageview',
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    mini_app_name: 'fale-lojista',
    pageType: 'historico-chat',
    screenName: 'historico-chat'
  };
};
var inboxConversationOnClick = function inboxConversationOnClick(_ref3) {
  var userId = _ref3.userId,
    sellerId = _ref3.sellerId;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "chat-lojista",
    eventLabel: "chat:".concat(sellerId),
    idUsuario: userId,
    mini_app_name: 'fale-lojista'
  };
};
var locationToString = function locationToString(location) {
  if (!location || (location == null ? void 0 : location.locationError) || !(location == null ? void 0 : location.zipCodeCity) || !(location == null ? void 0 : location.zipCodeState)) {
    return undefined;
  }
  return "".concat(location.zipCodeCity, ":").concat(location.zipCodeState);
};

/***/ }),

/***/ 92908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sellerDetailsClickOpenModal": function() { return /* binding */ sellerDetailsClickOpenModal; },
/* harmony export */   "sellerDetailsOffersLinkClick": function() { return /* binding */ sellerDetailsOffersLinkClick; },
/* harmony export */   "sellerDetailsPdpLinkClick": function() { return /* binding */ sellerDetailsPdpLinkClick; },
/* harmony export */   "sellerDetailsRatingClick": function() { return /* binding */ sellerDetailsRatingClick; },
/* harmony export */   "sellerScoreImpression": function() { return /* binding */ sellerScoreImpression; }
/* harmony export */ });
var buildEvent = function buildEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$event = _ref.event,
    event = _ref$event === void 0 ? 'clickEvent' : _ref$event,
    _ref$eventAction = _ref.eventAction,
    eventAction = _ref$eventAction === void 0 ? 'click' : _ref$eventAction,
    eventCategory = _ref.eventCategory,
    eventLabel = _ref.eventLabel,
    _ref$eventNonInteract = _ref.eventNonInteraction,
    eventNonInteraction = _ref$eventNonInteract === void 0 ? 0 : _ref$eventNonInteract;
  return {
    event: event,
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: eventNonInteraction
  };
};
var sellerDetailsClickOpenModal = function sellerDetailsClickOpenModal() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    seller = _ref2.seller,
    variationId = _ref2.variationId;
  return variationId && (seller == null ? void 0 : seller.id) && buildEvent({
    eventCategory: "produto:geral",
    eventLabel: "ver-mais-produtos-da-loja-parceira:".concat(variationId, ":").concat(seller == null ? void 0 : seller.id)
  });
};
var sellerDetailsOffersLinkClick = function sellerDetailsOffersLinkClick(_ref3) {
  var seller = _ref3.seller;
  return buildEvent({
    eventCategory: "produto:lojista:".concat(seller == null ? void 0 : seller.id),
    eventLabel: 'ver-mais-produtos-da-loja'
  });
};
var sellerDetailsPdpLinkClick = function sellerDetailsPdpLinkClick(_ref4) {
  var seller = _ref4.seller;
  return buildEvent({
    eventCategory: "produto:".concat(seller == null ? void 0 : seller.id),
    eventLabel: 'ver-mais-sobre-a-loja'
  });
};
var sellerDetailsRatingClick = function sellerDetailsRatingClick(_ref5) {
  var seller = _ref5.seller;
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "produto:".concat(seller == null ? void 0 : seller.id),
    eventLabel: 'saiba-como-foi-calculada-essa-nota',
    eventNonInteraction: 0
  };
};
var sellerScoreImpression = function sellerScoreImpression(_ref6) {
  var seller = _ref6.seller;
  var _seller$details = seller.details,
    details = _seller$details === void 0 ? {} : _seller$details;
  var deliveryRate = (details == null ? void 0 : details.deliveryRate) || {};
  var answerRate = (details == null ? void 0 : details.answerRate) || {};
  var score = null;
  var totalSales = '';
  var deliveryRateStatus = '';
  var answerRateStatus = '';
  if (details == null ? void 0 : details.score) {
    score = details.score;
    totalSales = (details == null ? void 0 : details.totalSales) ? ":".concat(details.totalSales) : '';
    deliveryRateStatus = (deliveryRate == null ? void 0 : deliveryRate.status) ? ":".concat(deliveryRate.status) : '';
    answerRateStatus = (answerRate == null ? void 0 : answerRate.status) ? ":".concat(answerRate.status) : '';
  }
  return {
    event: 'clickEvent',
    eventAction: 'impression',
    eventCategory: "produto:".concat((seller == null ? void 0 : seller.id) || null),
    eventLabel: "score:".concat(score).concat(totalSales).concat(deliveryRateStatus).concat(answerRateStatus),
    eventNonInteraction: 1
  };
};

/***/ }),

/***/ 42340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addService": function() { return /* binding */ addService; },
/* harmony export */   "clickService": function() { return /* binding */ clickService; },
/* harmony export */   "refuseService": function() { return /* binding */ refuseService; },
/* harmony export */   "servicesKnowMore": function() { return /* binding */ servicesKnowMore; },
/* harmony export */   "servicesLegalInfo": function() { return /* binding */ servicesLegalInfo; },
/* harmony export */   "servicesMoreDetails": function() { return /* binding */ servicesMoreDetails; },
/* harmony export */   "servicesOfferChange": function() { return /* binding */ servicesOfferChange; },
/* harmony export */   "servicesPageView": function() { return /* binding */ servicesPageView; },
/* harmony export */   "servicesVideo": function() { return /* binding */ servicesVideo; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var eventCategory = 'servicos';
var screenName = 'servicos';
var addService = function addService(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "incluir-protecao:".concat(args == null ? void 0 : args.offers),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var clickService = function clickService(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: args == null ? void 0 : args.eventLabel,
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var refuseService = function refuseService() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: 'agora-nao',
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var servicesKnowMore = function servicesKnowMore(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "saiba-mais-servico:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var servicesLegalInfo = function servicesLegalInfo(args) {
  return {
    content_type: eventCategory,
    event: 'select_content',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "saiba-mais-informacoes-garantia:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    item_id: "saiba-mais-informacoes-garantia:".concat(args == null ? void 0 : args.service),
    screenName: screenName
  };
};
var servicesMoreDetails = function servicesMoreDetails(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "mais-detalhes-do-seguro:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var servicesOfferChange = function servicesOfferChange(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "".concat((args == null ? void 0 : args.higher) ? 'aumentar-protecao' : 'diminuir-protecao', ":").concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};
var viewItem = function viewItem(data) {
  var _data$product, _data$product$seller, _data$product2, _data$product2$seller;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    barraLocalizacao: (data == null ? void 0 : data.zipCodeBar) ? 'verdadeiro' : 'falso',
    cepPreenchido: (data == null ? void 0 : data.zipCode) ? 1 : 0,
    cidadeuf: (data == null ? void 0 : data.location) ? "cep:".concat(data == null ? void 0 : data.zipCode, ":").concat(data == null ? void 0 : data.location) : undefined,
    clientId: data == null ? void 0 : data.clientId,
    device: data == null ? void 0 : data.device,
    event: 'virtualPageview',
    existeDelivery: (data == null ? void 0 : data.valuesFilterDelivery) || undefined,
    experimentId: undefined,
    idDaloja: data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$seller = _data$product.seller) == null ? void 0 : _data$product$seller.deliveryId,
    idParceiro: (data == null ? void 0 : data.partnerId) || undefined,
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    impressaoElemento: 1,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'nao-logado',
    mundos: 'magalu',
    nomeDaLoja: data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$seller = _data$product2.seller) == null ? void 0 : _data$product2$seller.deliveryDescription,
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: 'servicos',
    screenName: screenName,
    siteName: data == null ? void 0 : data.site,
    usuarioClube: undefined
  }, data == null ? void 0 : data.storeDimensions);
};
var buildServicesPageView = function buildServicesPageView(eventListener) {
  return function (props) {
    var data = props.data,
      structure = props.structure;
    var pageId = structure.id;
    if (pageId === 'service-new') {
      return eventListener(data, structure);
    }
    return null;
  };
};
var servicesPageView = buildServicesPageView(viewItem);
var servicesVideo = function servicesVideo(args) {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: "video-lu-explica:".concat(args == null ? void 0 : args.service),
    eventNonInteraction: 0,
    screenName: screenName
  };
};

/***/ }),

/***/ 90803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "shippingClick": function() { return /* binding */ shippingClick; },
/* harmony export */   "shippingError": function() { return /* binding */ shippingError; },
/* harmony export */   "shippingImpression": function() { return /* binding */ shippingImpression; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);


var eventCategory = 'produto:frete';
var buildShippingCalculateItemId = function buildShippingCalculateItemId(data) {
  var _deliveries$, _deliveries$2, _structure$route;
  var deliveries = data.deliveries,
    structure = data.structure;
  var isShippingAvailable = (deliveries == null ? void 0 : (_deliveries$ = deliveries[0]) == null ? void 0 : _deliveries$.status.code) || 'unavailable';
  var deliveryModalities = Array.from(new Set(deliveries == null ? void 0 : (_deliveries$2 = deliveries[0]) == null ? void 0 : _deliveries$2.modalities.map(function (_ref) {
    var type = _ref.type;
    return type;
  }))).join(':');
  return "".concat(structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId, ":").concat(isShippingAvailable).concat(deliveryModalities.length ? ":".concat(deliveryModalities) : '');
};
var buildShippingClick = function buildShippingClick(data) {
  var _data$deliveries, _data$deliveries$;
  return {
    action: 'click',
    cep: data.zipcode,
    content_type: eventCategory,
    deliveriesId: (_data$deliveries = data.deliveries) == null ? void 0 : (_data$deliveries$ = _data$deliveries[0]) == null ? void 0 : _data$deliveries$.id,
    event: 'shipping',
    item_id: buildShippingCalculateItemId(data)
  };
};
var buildShippingError = function buildShippingError(data) {
  var _data$structure, _data$structure$route;
  return {
    event: 'clickEvent',
    eventAction: 'erro',
    eventCategory: eventCategory,
    eventLabel: "consulta-prazo:".concat((_data$structure = data.structure) == null ? void 0 : (_data$structure$route = _data$structure.route) == null ? void 0 : _data$structure$route.productId, ":erro:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data.error)),
    eventNonInteraction: '1'
  };
};
var buildShippingImpression = function buildShippingImpression(data) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, buildShippingClick(data), {
    action: 'impression'
  });
};
var shippingClick = function shippingClick(data, args) {
  return buildShippingClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, args));
};
var shippingError = function shippingError(data, args) {
  return buildShippingError((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, args));
};
var shippingImpression = function shippingImpression(data, args) {
  return buildShippingImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, args));
};

/***/ }),

/***/ 84950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildClickImpression": function() { return /* binding */ buildClickImpression; },
/* harmony export */   "signInClick": function() { return /* binding */ signInClick; }
/* harmony export */ });
var buildClickImpression = function buildClickImpression() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'home:login',
    eventLabel: 'entrar',
    eventNonInteraction: 0
  };
};
var signInClick = function signInClick(action, config) {
  var _config$structure;
  if ((action == null ? void 0 : action.type) === 'login' && (config == null ? void 0 : (_config$structure = config.structure) == null ? void 0 : _config$structure.name) === 'home') {
    return buildClickImpression();
  }
  return {};
};

/***/ }),

/***/ 77948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);



var sort = function sort() {
  var _data$sort, _args$structure, _args$structure$cooki, _args$structure2, _data$sort2, _args$structure3, _args$structure3$rout, _args$structure4, _args$structure4$rout, _args$structure5, _args$structure5$rout, _args$structure6, _args$structure6$rout, _args$data;
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (data == null ? void 0 : (_data$sort = data.sort) == null ? void 0 : _data$sort.label) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(args == null ? void 0 : (_args$structure = args.structure) == null ? void 0 : (_args$structure$cooki = _args$structure.cookies) == null ? void 0 : _args$structure$cooki.location),
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: "".concat((args == null ? void 0 : (_args$structure2 = args.structure) == null ? void 0 : _args$structure2.name) || '', ":ordenacao"),
    eventLabel: data == null ? void 0 : (_data$sort2 = data.sort) == null ? void 0 : _data$sort2.label,
    eventNonInteraction: '0',
    pageCategory: (args == null ? void 0 : (_args$structure3 = args.structure) == null ? void 0 : (_args$structure3$rout = _args$structure3.route) == null ? void 0 : _args$structure3$rout.categoryId) || 'nao-se-aplica',
    pageSubcategory: (args == null ? void 0 : (_args$structure4 = args.structure) == null ? void 0 : (_args$structure4$rout = _args$structure4.route) == null ? void 0 : _args$structure4$rout.subCategoryId) || 'nao-se-aplica',
    termoBuscado: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure5 = args.structure) == null ? void 0 : (_args$structure5$rout = _args$structure5.route) == null ? void 0 : _args$structure5$rout.term),
    termoDigitado: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(args == null ? void 0 : (_args$structure6 = args.structure) == null ? void 0 : (_args$structure6$rout = _args$structure6.route) == null ? void 0 : _args$structure6$rout.term)
  }, (args == null ? void 0 : (_args$data = args.data) == null ? void 0 : _args$data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"])(args.data.channel)));
};
/* harmony default export */ __webpack_exports__["default"] = (sort);

/***/ }),

/***/ 29563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "spacePageView": function() { return /* binding */ spacePageView; }
/* harmony export */ });
var spacePageView = function spacePageView(data) {
  return {
    barraLocalizacao: data.zipCodeBar ? 'verdadeiro' : 'falso',
    cepPreenchido: data.zipCode ? 'verdadeiro' : 'falso',
    cidadeuf: (data == null ? void 0 : data.location) || undefined,
    event: 'virtualPageview',
    idUsuario: (data == null ? void 0 : data.accountId) || undefined,
    loginAtivo: (data == null ? void 0 : data.accountId) ? 'logado' : 'deslogado',
    pageCategory: (data == null ? void 0 : data.categoryId) || 'nao-se-aplica',
    pageSubcategory: (data == null ? void 0 : data.subCategoryId) || 'nao-se-aplica',
    pageType: 'seu-espaco',
    screenName: 'seu-espaco'
  };
};

/***/ }),

/***/ 43444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildSubcategoryFullListClick": function() { return /* binding */ buildSubcategoryFullListClick; },
/* harmony export */   "buildSubcategoryListClick": function() { return /* binding */ buildSubcategoryListClick; },
/* harmony export */   "buildSubcategoryTopClick": function() { return /* binding */ buildSubcategoryTopClick; },
/* harmony export */   "subcategoryFullListClick": function() { return /* binding */ subcategoryFullListClick; },
/* harmony export */   "subcategoryListClick": function() { return /* binding */ subcategoryListClick; },
/* harmony export */   "subcategoryTopClick": function() { return /* binding */ subcategoryTopClick; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var buildClick = function buildClick() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'categoria:subcategoria',
    eventNonInteraction: '0'
  };
};
var buildSubcategoryFullListClick = function buildSubcategoryFullListClick() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildClick(), {
    eventLabel: 'veja-a-lista-completa'
  });
};
var buildSubcategoryListClick = function buildSubcategoryListClick(_ref) {
  var _ref$eventLabel = _ref.eventLabel,
    eventLabel = _ref$eventLabel === void 0 ? '' : _ref$eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildClick(), {
    eventLabel: "todas".concat(eventLabel ? ":".concat(eventLabel) : '')
  });
};
var buildSubcategoryTopClick = function buildSubcategoryTopClick(_ref2) {
  var _ref2$eventLabel = _ref2.eventLabel,
    eventLabel = _ref2$eventLabel === void 0 ? '' : _ref2$eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, buildClick(), {
    eventLabel: "principais".concat(eventLabel ? ":".concat(eventLabel) : '')
  });
};
var subcategoryFullListClick = function subcategoryFullListClick() {
  return buildSubcategoryFullListClick();
};
var subcategoryListClick = function subcategoryListClick(data) {
  return buildSubcategoryListClick(data);
};
var subcategoryTopClick = function subcategoryTopClick(data) {
  return buildSubcategoryTopClick(data);
};

/***/ }),

/***/ 81656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildEvent": function() { return /* binding */ buildEvent; },
/* harmony export */   "suggestionImpression": function() { return /* binding */ suggestionImpression; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var buildEvent = function buildEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$event = _ref.event,
    event = _ref$event === void 0 ? 'clickEvent' : _ref$event,
    _ref$eventAction = _ref.eventAction,
    eventAction = _ref$eventAction === void 0 ? 'impression' : _ref$eventAction,
    _ref$eventCategory = _ref.eventCategory,
    eventCategory = _ref$eventCategory === void 0 ? 'magalu-has' : _ref$eventCategory,
    eventLabel = _ref.eventLabel;
  return {
    event: event,
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel: eventLabel
  };
};
var suggestionImpression = function suggestionImpression(data) {
  var label = data.linksSuggestions.links.map(function (item, index) {
    var pipe = item.length === index ? '' : "|";
    return "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(item.value)).concat(pipe);
  });
  var formattedLabel = label.toString().replace(/\,/g, '').replace(/\s/g, '-').replace(/\W$/, '');
  return buildEvent({
    eventLabel: "".concat(formattedLabel.toLowerCase())
  });
};

/***/ }),

/***/ 67663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var _utils_ga4ParseDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53004);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59075);



var parseEcommerce = function parseEcommerce(data) {
  return {
    ecommerce: {
      detail: {
        products: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
          brand: data.brand.label,
          category: "".concat(data.category.id, "/").concat(data.subcategory.id),
          id: data.variationId,
          name: data.title.replace(/\s/g, '-'),
          price: data.price.price,
          quantity: '1',
          variant: data.variationId
        }, (0,_utils_ga4ParseDimensions__WEBPACK_IMPORTED_MODULE_0__.ga4ParseDimensions)(data))]
      }
    }
  };
};
var viewItem = function viewItem(_ref) {
  var product = _ref.product,
    shippingError = _ref.shippingError,
    structure = _ref.structure;
  var pageName = structure.name,
    _structure$cookies = structure.cookies,
    _structure$cookies2 = _structure$cookies === void 0 ? {} : _structure$cookies,
    togglePdpSellerScore = _structure$cookies2.togglePdpSellerScore,
    query = structure.query;
  var ecommerceData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, product, {
    query: query,
    shippingError: shippingError
  });
  if (pageName === 'product' || product) {
    ecommerceData.togglePdpSellerScore = togglePdpSellerScore;
  } else {
    return null;
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    currency: _constants__WEBPACK_IMPORTED_MODULE_1__.CURRENCY,
    event: 'detail',
    eventAction: 'page-load',
    eventCategory: 'produto:geral',
    eventLabel: 'view_detail',
    screenName: 'produto',
    value: product.price.fullPrice
  }, parseEcommerce(ecommerceData));
};
/* harmony default export */ __webpack_exports__["default"] = (viewItem);

/***/ }),

/***/ 46091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eventCategory": function() { return /* binding */ eventCategory; },
/* harmony export */   "zipCodeBarClick": function() { return /* binding */ zipCodeBarClick; },
/* harmony export */   "zipCodeBarResponseError": function() { return /* binding */ zipCodeBarResponseError; },
/* harmony export */   "zipCodeBarResponseSuccess": function() { return /* binding */ zipCodeBarResponseSuccess; },
/* harmony export */   "zipCodeBarTooltipClick": function() { return /* binding */ zipCodeBarTooltipClick; },
/* harmony export */   "zipCodeBarTooltipClose": function() { return /* binding */ zipCodeBarTooltipClose; },
/* harmony export */   "zipCodeBarTooltipSuccessView": function() { return /* binding */ zipCodeBarTooltipSuccessView; },
/* harmony export */   "zipCodeBarTooltipView": function() { return /* binding */ zipCodeBarTooltipView; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);
/* harmony import */ var _utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27903);


var eventCategory = "barra-localizacao";
var buildPopupZipCodeBarImpression = function buildPopupZipCodeBarImpression(_ref) {
  var data = _ref.data,
    eventLabel = _ref.eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'tooltipView',
    eventAction: 'impression',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '1'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var buildPopupZipCodeBarClick = function buildPopupZipCodeBarClick(_ref2) {
  var data = _ref2.data,
    eventLabel = _ref2.eventLabel;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: eventLabel,
    eventNonInteraction: '0'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var buildZipCodeBarClick = function buildZipCodeBarClick(_ref3) {
  var data = _ref3.data;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: eventCategory,
    eventLabel: 'ver-ofertas-para-minha-regiao',
    eventNonInteraction: '0'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var buildZipCodeBarResponseError = function buildZipCodeBarResponseError(error) {
  return {
    event: 'clickEvent',
    eventAction: 'erro',
    eventCategory: eventCategory,
    eventLabel: error == null ? void 0 : error.message,
    eventNonInteraction: '0'
  };
};
var buildZipCodeBarResponseSuccess = function buildZipCodeBarResponseSuccess(_ref4) {
  var data = _ref4.data;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    event: 'clickEvent',
    eventAction: 'calcular',
    eventCategory: eventCategory,
    eventLabel: 'sucesso',
    eventNonInteraction: '1'
  }, (data == null ? void 0 : data.channel) && (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (0,_utils_channelStoreDimensions__WEBPACK_IMPORTED_MODULE_1__["default"])(data.channel)));
};
var zipCodeBarClick = function zipCodeBarClick(data, args) {
  return buildZipCodeBarClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args));
};
var zipCodeBarResponseError = function zipCodeBarResponseError(data) {
  return buildZipCodeBarResponseError(data);
};
var zipCodeBarResponseSuccess = function zipCodeBarResponseSuccess(data, args) {
  return buildZipCodeBarResponseSuccess((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args));
};
var zipCodeBarTooltipClick = function zipCodeBarTooltipClick(data, args) {
  return buildPopupZipCodeBarClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'preencher'
  }));
};
var zipCodeBarTooltipClose = function zipCodeBarTooltipClose(data, args) {
  return buildPopupZipCodeBarClick((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'fechar'
  }));
};
var zipCodeBarTooltipSuccessView = function zipCodeBarTooltipSuccessView(data, args) {
  return buildPopupZipCodeBarImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'tooltip:preencheu-localizacao'
  }));
};
var zipCodeBarTooltipView = function zipCodeBarTooltipView(data, args) {
  return buildPopupZipCodeBarImpression((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, data, args, {
    eventLabel: 'tooltip:compartilhe-sua-localizacao'
  }));
};

/***/ }),

/***/ 19487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6115);


/***/ }),

/***/ 19777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _gaBoolean__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20914);



var buildClickCommonEvent = function buildClickCommonEvent(data) {
  var _data$shipping, _data$shipping$, _data$shipping$$packa, _data$category, _data$seller, _data$seller2, _data$seller3, _data$subcategory, _data$seller4, _data$price;
  var withFreight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var shippingPackage = (data == null ? void 0 : (_data$shipping = data.shipping) == null ? void 0 : (_data$shipping$ = _data$shipping[0]) == null ? void 0 : (_data$shipping$$packa = _data$shipping$.packages) == null ? void 0 : _data$shipping$$packa[0]) || {};
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    categorias: data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id,
    categoriaSeller: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    event: 'clickEvent',
    nomeSeller: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    produtoClube: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])((_data$seller3 = data.seller) == null ? void 0 : _data$seller3.discounts),
    produtoDisponivel: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])(data == null ? void 0 : data.available),
    produtoFavoritado: (data == null ? void 0 : data.accountId) ? (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])(data == null ? void 0 : data.isOnWishlist) : undefined,
    sku: data == null ? void 0 : data.id,
    subcategorias: data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id
  }, withFreight && {
    freteTotal: shippingPackage == null ? void 0 : shippingPackage.price
  }, withFreight && {
    valorFrete: shippingPackage == null ? void 0 : shippingPackage.price
  }, withFreight && {
    sellerEntrega: data == null ? void 0 : (_data$seller4 = data.seller) == null ? void 0 : _data$seller4.deliveryId
  }, withFreight && {
    retiraLoja: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .hasPickupStore */ .V9)(shippingPackage == null ? void 0 : shippingPackage.deliveryTypes))
  }, {
    value: (data == null ? void 0 : data.price) ? parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) : undefined
  });
};
/* harmony default export */ __webpack_exports__["default"] = (buildClickCommonEvent);

/***/ }),

/***/ 98011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var categoryToString = function categoryToString(category, subcategory) {
  if (!category || !subcategory) {
    return undefined;
  }
  return "".concat(category, "/").concat(subcategory);
};
/* harmony default export */ __webpack_exports__["default"] = (categoryToString);

/***/ }),

/***/ 27903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var channelStoreDimensions = function channelStoreDimensions(channel) {
  var _channel$data;
  var store = channel == null ? void 0 : (_channel$data = channel.data) == null ? void 0 : _channel$data.find(function (item) {
    return item.name === 'store';
  });
  var hasStore = !!(store == null ? void 0 : store.value);
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, hasStore ? {
    idDaLoja: store.value.id,
    nomeDaLoja: store.value.name
  } : {});
};
/* harmony default export */ __webpack_exports__["default"] = (channelStoreDimensions);

/***/ }),

/***/ 24169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);


var dataLayerPush = function dataLayerPush(listener) {
  return function () {
    var _structure$config;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _ref = args[args.length - 1] || {},
      config = _ref.config,
      structure = _ref.structure;
    var isDevelopment = (config == null ? void 0 : config.environment) === 'development';
    if (!listener || _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .whereAmI.onServer */ .er.onServer || !window.dataLayer || !document) return;
    var data = listener.apply(void 0, args);
    if (!data) {
      if (isDevelopment) {
        console.warn('[dataLayer.push]: ocorreu uma tentativa de envio de evento sem dados', args);
      }
      return;
    }
    var object = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, data, {
      hitTimestamp: new Date().getTime()
    });
    if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
      (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .useFirebasePush */ .Gz)(object);
    } else {
      window.dataLayer.push(object);
    }
    if (isDevelopment) {
      var listnerResult = listener.apply(void 0, args);
      if (listnerResult) {
        var event = listnerResult.event,
          eventCategory = listnerResult.eventCategory,
          pageType = listnerResult.pageType,
          contentType = listnerResult.content_type;
        var title = "%c[ga log] ".concat(eventCategory || pageType || contentType, " ").concat(event, "\n");
        console.groupCollapsed(title, 'color: #03A9F4');
        console.log("\uD83D\uDCE1 [dataLayer.push]", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, listener.apply(void 0, args)));
        console.groupEnd(title);
      }
    }
  };
};
/* harmony default export */ __webpack_exports__["default"] = (dataLayerPush);

/***/ }),

/***/ 53004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ga4ParseDimensions": function() { return /* binding */ ga4ParseDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var ga4ParseDimensions = function ga4ParseDimensions(data) {
  var _data$shippingError, _data$seller, _data$seller$details, _data$seller$details$, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$offerTags, _data$badges, _data$badges$, _data$geoLocTags, _data$query;
  var reason = (data == null ? void 0 : (_data$shippingError = data.shippingError) == null ? void 0 : _data$shippingError.includes('Estoque')) ? 'sem-estoque' : 'cep-indisponivel';
  return {
    dimension5: data.seller.category,
    dimension7: undefined,
    dimension11: data.shippingError ? "falso:".concat(reason) : 'verdadeiro',
    dimension23: data.seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[data.seller.id] ? undefined : "".concat(Number(!!(data == null ? void 0 : data.togglePdpSellerScore)), ":").concat((data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : (_data$seller$details = _data$seller.details) == null ? void 0 : (_data$seller$details$ = _data$seller$details.score) == null ? void 0 : _data$seller$details$.toString()) || null),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString(), "|av:").concat(data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()),
    dimension41: "etiqueta:".concat((data == null ? void 0 : (_data$offerTags = data.offerTags) == null ? void 0 : _data$offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0'),
    dimension61: data.seller.id,
    dimension62: data.seller.deliveryId || undefined,
    dimension86: "selo:".concat((data == null ? void 0 : (_data$badges = data.badges) == null ? void 0 : (_data$badges$ = _data$badges[0]) == null ? void 0 : _data$badges$.text) || 'sem-selo', "|tags:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$geoLocTags = data.geoLocTags) == null ? void 0 : _data$geoLocTags.title) || 'sem-tag'),
    dimension103: (data == null ? void 0 : (_data$query = data.query) == null ? void 0 : _data$query.chatbot_lu) ? 'chatbot-lu' : undefined,
    dimension104: undefined,
    dimension112: undefined,
    dimension115: undefined
  };
};

/***/ }),

/***/ 20914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var gaBoolean = function gaBoolean(data) {
  if (data === undefined) return undefined;
  return data && (!Array.isArray(data) || data.length) ? 'verdadeiro' : 'falso';
};
/* harmony default export */ __webpack_exports__["default"] = (gaBoolean);

/***/ }),

/***/ 15950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59740);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _events_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59075);
/* harmony import */ var _categoryToString__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98011);
/* harmony import */ var _gaBoolean__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20914);

var _excluded = ["accountId", "id", "variationId", "title"];




var gaEcommerceProduct = function gaEcommerceProduct() {
  var _data$brand, _data$category, _data$subcategory, _data$installment, _data$seller, _data$seller2, _data$attributes, _data$attributes2, _data$attributes2$, _data$shippingValues, _data$shippingValues2, _data$shippingValues3, _data$shippingValues4, _data$shippingValues5, _data$offerTags, _data$overview, _data$overview2, _data$financialServic, _data$financialServic2, _data$financialServic3, _data$seller3, _data$overview3, _data$overview4, _data$rating, _data$rating$score, _data$price, _data$price2, _data$overview5, _data$installment2, _data$installment2$qu, _data$rating2, _data$rating2$count, _data$badges, _data$badges$, _data$geoLocTags, _data$query, _data$price3, _data$price4;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var accountId = _ref.accountId,
    id = _ref.id,
    variationId = _ref.variationId,
    name = _ref.title,
    data = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  return {
    brand: (data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || undefined,
    category: (0,_categoryToString__WEBPACK_IMPORTED_MODULE_3__["default"])(data == null ? void 0 : (_data$category = data.category) == null ? void 0 : _data$category.id, data == null ? void 0 : (_data$subcategory = data.subcategory) == null ? void 0 : _data$subcategory.id),
    currency: _events_constants__WEBPACK_IMPORTED_MODULE_1__.CURRENCY,
    dimension12: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.available),
    dimension13: accountId ? (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.isOnWishlist) : undefined,
    dimension14: 'falso',
    dimension15: data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount,
    dimension16: data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category,
    dimension17: data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id,
    dimension18: (data == null ? void 0 : (_data$attributes = data.attributes) == null ? void 0 : _data$attributes.length) ? data == null ? void 0 : (_data$attributes2 = data.attributes) == null ? void 0 : (_data$attributes2$ = _data$attributes2[0]) == null ? void 0 : _data$attributes2$.value : undefined,
    dimension19: data == null ? void 0 : data.term,
    dimension20: data == null ? void 0 : (_data$shippingValues = data.shippingValues) == null ? void 0 : _data$shippingValues.store_pickup,
    dimension21: data == null ? void 0 : (_data$shippingValues2 = data.shippingValues) == null ? void 0 : _data$shippingValues2.default_ship,
    dimension22: data == null ? void 0 : (_data$shippingValues3 = data.shippingValues) == null ? void 0 : _data$shippingValues3.shipping_value,
    dimension23: data == null ? void 0 : (_data$shippingValues4 = data.shippingValues) == null ? void 0 : _data$shippingValues4.days,
    dimension24: data == null ? void 0 : (_data$shippingValues5 = data.shippingValues) == null ? void 0 : _data$shippingValues5.days_pickup,
    dimension41: "etiqueta:".concat((data == null ? void 0 : (_data$offerTags = data.offerTags) == null ? void 0 : _data$offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0'),
    dimension44: data == null ? void 0 : (_data$overview = data.overview) == null ? void 0 : _data$overview.warranty,
    dimension45: data == null ? void 0 : (_data$overview2 = data.overview) == null ? void 0 : _data$overview2.theft,
    dimension46: (data == null ? void 0 : (_data$financialServic = data.financialServices) == null ? void 0 : (_data$financialServic2 = _data$financialServic.filter(function (item) {
      return item.description === 'Troca Certa';
    })[0]) == null ? void 0 : (_data$financialServic3 = _data$financialServic2.offers) == null ? void 0 : _data$financialServic3.reduce(function (ac, item) {
      return ac + (ac === '' ? item.treeId : " | ".concat(item.treeId));
    }, '')) || 'none',
    dimension57: (0,_gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"])(data == null ? void 0 : data.isBuyBox),
    dimension58: undefined,
    dimension62: data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.deliveryId,
    dimension66: data == null ? void 0 : (_data$overview3 = data.overview) == null ? void 0 : _data$overview3.images,
    dimension67: data == null ? void 0 : (_data$overview4 = data.overview) == null ? void 0 : _data$overview4.media,
    dimension68: data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$score = _data$rating.score) == null ? void 0 : _data$rating$score.toString(),
    dimension70: data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.price,
    dimension71: undefined,
    dimension72: data.location,
    dimension76: data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice,
    dimension77: data == null ? void 0 : (_data$overview5 = data.overview) == null ? void 0 : _data$overview5.discountPercenter,
    dimension78: data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : (_data$installment2$qu = _data$installment2.quantity) == null ? void 0 : _data$installment2$qu.toString(),
    dimension79: data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$count = _data$rating2.count) == null ? void 0 : _data$rating2$count.toString(),
    dimension85: undefined,
    dimension86: "selo:".concat((data == null ? void 0 : (_data$badges = data.badges) == null ? void 0 : (_data$badges$ = _data$badges[0]) == null ? void 0 : _data$badges$.text) || 'sem-selo', "|tags:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : (_data$geoLocTags = data.geoLocTags) == null ? void 0 : _data$geoLocTags.title) || 'sem-tag'),
    dimension87: undefined,
    dimension103: (data == null ? void 0 : (_data$query = data.query) == null ? void 0 : _data$query.chatbot_lu) ? 'chatbot-lu' : undefined,
    id: id,
    name: name,
    price: Math.round((data == null ? void 0 : (_data$price3 = data.price) == null ? void 0 : _data$price3.bestPrice) * 1e2) / 1e2 || Math.round((data == null ? void 0 : (_data$price4 = data.price) == null ? void 0 : _data$price4.price) * 1e2) / 1e2 || undefined,
    quantity: 1,
    variant: variationId
  };
};
/* harmony default export */ __webpack_exports__["default"] = (gaEcommerceProduct);

/***/ }),

/***/ 66724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var gaSelectedFilters = function gaSelectedFilters(filters) {
  return filters && Array.isArray(filters) && filters.length ? filters.map(function (f) {
    return f.value;
  }).filter(Boolean).join('|') || undefined : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (gaSelectedFilters);

/***/ }),

/***/ 82115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getBestPriceDiscount = function getBestPriceDiscount(data) {
  var _data$price, _data$price2;
  return (data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.bestPrice) && Boolean(Number(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.discount)) ? data.price.bestPrice : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (getBestPriceDiscount);

/***/ }),

/***/ 54730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getDiscount = function getDiscount(data) {
  var _data$price, _data$price2;
  return Number(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.discount) ? "".concat(Number(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.discount), "%") : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (getDiscount);

/***/ }),

/***/ 50734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getInstallmentQuantity = function getInstallmentQuantity(data) {
  var _data$installment, _data$installment2;
  return (data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.quantity) ? "parcelas-".concat(data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) : undefined;
};
/* harmony default export */ __webpack_exports__["default"] = (getInstallmentQuantity);

/***/ }),

/***/ 6983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var getSearchTerm = function getSearchTerm(pageId) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var route = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var pages = {
    brand: route == null ? void 0 : route.brandId,
    category: route == null ? void 0 : route.categorySlug,
    search: route == null ? void 0 : route.term,
    selection: route == null ? void 0 : route.selectionId,
    seller: route == null ? void 0 : route.sellerId,
    subcategory: route == null ? void 0 : route.slug1
  };
  return (data == null ? void 0 : data.type) || pages[pageId];
};
/* harmony default export */ __webpack_exports__["default"] = (getSearchTerm);

/***/ }),

/***/ 22078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var typesButton = {
  addToBag: 'adicionar-a-sacola',
  oneTouch: 'comprar-agora',
  pickupStore: 'retira-loja',
  typeFloat: 'botao-flutuante'
};
var getTypeButton = function getTypeButton(typeButton) {
  return typesButton[typeButton] || typesButton.addToBag;
};
/* harmony default export */ __webpack_exports__["default"] = (getTypeButton);

/***/ }),

/***/ 10924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var handleOrigin = function handleOrigin(data) {
  var _data$ads, _data$ads2, _data$ads3;
  return (data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.id) ? "ads:".concat(data == null ? void 0 : (_data$ads2 = data.ads) == null ? void 0 : _data$ads2.id, "|campaignId:").concat(data == null ? void 0 : (_data$ads3 = data.ads) == null ? void 0 : _data$ads3.campaignId) : data == null ? void 0 : data.origin;
};
/* harmony default export */ __webpack_exports__["default"] = (handleOrigin);

/***/ }),

/***/ 90545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildClickCommonEvent": function() { return /* reexport safe */ _buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__["default"]; },
/* harmony export */   "categoryToString": function() { return /* reexport safe */ _categoryToString__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   "channelStoreDimensions": function() { return /* reexport safe */ _channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__["default"]; },
/* harmony export */   "dataLayerPush": function() { return /* reexport safe */ _dataLayerPush__WEBPACK_IMPORTED_MODULE_3__["default"]; },
/* harmony export */   "gaBoolean": function() { return /* reexport safe */ _gaBoolean__WEBPACK_IMPORTED_MODULE_4__["default"]; },
/* harmony export */   "gaEcommerceProduct": function() { return /* reexport safe */ _gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_5__["default"]; },
/* harmony export */   "gaSelectedFilters": function() { return /* reexport safe */ _gaSelectedFilters__WEBPACK_IMPORTED_MODULE_6__["default"]; },
/* harmony export */   "getBestPriceDiscount": function() { return /* reexport safe */ _getBestPriceDiscount__WEBPACK_IMPORTED_MODULE_7__["default"]; },
/* harmony export */   "getDiscount": function() { return /* reexport safe */ _getDiscount__WEBPACK_IMPORTED_MODULE_8__["default"]; },
/* harmony export */   "getInstallmentQuantity": function() { return /* reexport safe */ _getInstallmentQuantity__WEBPACK_IMPORTED_MODULE_9__["default"]; },
/* harmony export */   "getSearchTerm": function() { return /* reexport safe */ _getSearchTerm__WEBPACK_IMPORTED_MODULE_10__["default"]; },
/* harmony export */   "getTypeButton": function() { return /* reexport safe */ _getTypeButton__WEBPACK_IMPORTED_MODULE_11__["default"]; },
/* harmony export */   "handleOrigin": function() { return /* reexport safe */ _handleOrigin__WEBPACK_IMPORTED_MODULE_12__["default"]; },
/* harmony export */   "isSomeParametersEmpty": function() { return /* reexport safe */ _isSomeParametersEmpty__WEBPACK_IMPORTED_MODULE_14__["default"]; },
/* harmony export */   "productFormatter": function() { return /* reexport safe */ _productFormatter__WEBPACK_IMPORTED_MODULE_13__["default"]; }
/* harmony export */ });
/* harmony import */ var _buildClickCommonEvent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19777);
/* harmony import */ var _categoryToString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98011);
/* harmony import */ var _channelStoreDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27903);
/* harmony import */ var _dataLayerPush__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24169);
/* harmony import */ var _gaBoolean__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20914);
/* harmony import */ var _gaEcommerceProduct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15950);
/* harmony import */ var _gaSelectedFilters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66724);
/* harmony import */ var _getBestPriceDiscount__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82115);
/* harmony import */ var _getDiscount__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54730);
/* harmony import */ var _getInstallmentQuantity__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50734);
/* harmony import */ var _getSearchTerm__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6983);
/* harmony import */ var _getTypeButton__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22078);
/* harmony import */ var _handleOrigin__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10924);
/* harmony import */ var _productFormatter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67412);
/* harmony import */ var _isSomeParametersEmpty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12530);
















/***/ }),

/***/ 12530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var isSomeParametersEmpty = function isSomeParametersEmpty(data) {
  if (data === undefined || data === null) {
    return true;
  }
  var time = data.time,
    complement = data.complement,
    cost = data.cost;
  var restData = {
    complement: complement,
    cost: cost,
    time: time
  };
  var values = Object.values(restData);
  return values.every(function (value) {
    return value === undefined || value === null || value === '';
  });
};
/* harmony default export */ __webpack_exports__["default"] = (isSomeParametersEmpty);

/***/ }),

/***/ 67412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "productFormatterOptions": function() { return /* binding */ productFormatterOptions; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76854);

var conditionalToString = function conditionalToString(items) {
  return items ? 'verdadeiro' : 'falso';
};
var slugServicesIds = function slugServicesIds(service) {
  return service ? service == null ? void 0 : service.map(function (item) {
    return String(item == null ? void 0 : item.treeId);
  }).join('|') : 'None';
};
var getMedias = function getMedias(medias) {
  var _medias$videos, _medias$audios, _medias$podcasts;
  var media = [];
  if (medias == null ? void 0 : (_medias$videos = medias.videos) == null ? void 0 : _medias$videos.length) {
    media.push('video');
  }
  if (medias == null ? void 0 : (_medias$audios = medias.audios) == null ? void 0 : _medias$audios.length) {
    media.push('audio');
  }
  if (medias == null ? void 0 : (_medias$podcasts = medias.podcasts) == null ? void 0 : _medias$podcasts.length) {
    media.push('podcasts');
  }
  return media.length ? media.join('|') : 'falso';
};
var productFormatterOptions = {
  frete: function frete(product) {
    var _product$shipping;
    if (!product.shipping || (product == null ? void 0 : (_product$shipping = product.shipping) == null ? void 0 : _product$shipping.length) === 0) return {};
    var _product$shipping$map = product.shipping.map(function (ship) {
        return ship.packages.map(function (pack) {
          var _pack$deliveryTypes, _pack$deliveryTypes2;
          var pickup = pack == null ? void 0 : (_pack$deliveryTypes = pack.deliveryTypes) == null ? void 0 : _pack$deliveryTypes.find(function (val) {
            return val.type === 'store_pickup';
          });
          var conventional = (_pack$deliveryTypes2 = pack.deliveryTypes) == null ? void 0 : _pack$deliveryTypes2.find(function (val) {
            return val.type === 'conventional';
          });
          return {
            days: (conventional == null ? void 0 : conventional.time.toString()) || undefined,
            days_pickup: (pickup == null ? void 0 : pickup.time.toString()) || undefined,
            default_ship: conditionalToString(conventional),
            shipping_value: pack.price,
            store_pickup: conditionalToString(pickup)
          };
        });
      }),
      _product$shipping$map2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_product$shipping$map, 1),
      firstArray = _product$shipping$map2[0];
    return firstArray[0];
  },
  geral: function geral(product) {
    if (Object.keys(product).length > 0) {
      var _product$financialSer, _product$financialSer2, _product$media, _product$media$images;
      var extendedWarranty = (_product$financialSer = product.financialServices) == null ? void 0 : _product$financialSer.find(function (financial) {
        return financial.description === 'Garantia Estendida';
      });
      var robberyAndTheft = (_product$financialSer2 = product.financialServices) == null ? void 0 : _product$financialSer2.find(function (financial) {
        return financial.description === 'Roubo e Furto';
      });
      var media = getMedias(product.media);
      var _ref = product.price || {},
        bestPrice = _ref.bestPrice,
        price = _ref.price;
      var discountPercenter;
      if (bestPrice && price) {
        discountPercenter = 100 * parseFloat(bestPrice) / parseFloat(price);
        discountPercenter = "".concat(Math.abs(discountPercenter - 100).toFixed(2), "%");
      }
      return {
        discountPercenter: discountPercenter,
        images: (_product$media = product.media) == null ? void 0 : (_product$media$images = _product$media.images) == null ? void 0 : _product$media$images.length.toString(),
        media: media,
        theft: robberyAndTheft ? 'verdadeiro' : 'falso',
        warranty: extendedWarranty ? 'verdadeiro' : 'falso'
      };
    }
    return {};
  },
  service: function service(_ref2) {
    var product = _ref2.product,
      services = _ref2.services;
    if (Object.keys(product).length > 0) {
      var _product$media2, _product$media2$image;
      var _ref3 = services || {},
        extendedWarranty = _ref3.extendedWarranty,
        robberyAndTheft = _ref3.robberyAndTheft;
      var media = getMedias(product.media);
      var _ref4 = product.price || {},
        bestPrice = _ref4.bestPrice,
        price = _ref4.price;
      var discountPercenter;
      if (bestPrice && price) {
        discountPercenter = 100 * parseFloat(bestPrice) / parseFloat(price);
        discountPercenter = "".concat(Math.abs(discountPercenter - 100).toFixed(2), "%");
      }
      return {
        discountPercenter: discountPercenter,
        images: (_product$media2 = product.media) == null ? void 0 : (_product$media2$image = _product$media2.images) == null ? void 0 : _product$media2$image.length.toString(),
        media: media,
        theft: slugServicesIds(robberyAndTheft),
        warranty: slugServicesIds(extendedWarranty)
      };
    }
    return {};
  }
};
var productFormatter = function productFormatter(items, option) {
  if (option) {
    var selectedOption = productFormatterOptions[option];
    return selectedOption(items);
  }
  return {};
};
/* harmony default export */ __webpack_exports__["default"] = (productFormatter);

/***/ }),

/***/ 51852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var stringNormalize = function stringNormalize(label) {
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)(label == null ? void 0 : label.replace == null ? void 0 : label.replace(/\s/g, '-'));
};
var accountLinkClick = function accountLinkClick(event) {
  return {
    content_id: "".concat(stringNormalize(event == null ? void 0 : event.category), ":").concat(stringNormalize(event == null ? void 0 : event.item)),
    content_type: 'seu-espaco',
    event: 'select_content',
    screenName: 'seu-espaco'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (accountLinkClick);

/***/ }),

/***/ 86963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62322);
/* harmony import */ var _utils_addToCartDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33637);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6422);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);






var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID;
var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var getProductPrice = function getProductPrice(data) {
  var _data$product, _data$product$price, _data$product2, _data$product2$price, _data$product3, _data$product3$instal;
  var bestPrice = parseFloat(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$price = _data$product.price) == null ? void 0 : _data$product$price.bestPrice);
  var fullPrice = parseFloat(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$price = _data$product2.price) == null ? void 0 : _data$product2$price.fullPrice);
  var installmentTotal = parseFloat(data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : (_data$product3$instal = _data$product3.installment) == null ? void 0 : _data$product3$instal.totalAmount);
  return (data == null ? void 0 : data.pageName) === 'buybox' ? bestPrice || fullPrice || null : installmentTotal || fullPrice || bestPrice || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$product4, _data$product4$brand, _data$product5, _data$product6, _data$product7, _data$product7$rating, _data$product7$rating2, _data$product8, _data$product8$rating, _data$product8$rating2, _data$product9, _data$product$seller$, _data$product10, _data$product10$selle, _data$product$seller$2, _data$product11, _data$product11$selle, _data$product12, _data$product13, _data$product14, _data$product15;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$brand = _data$product4.brand) == null ? void 0 : _data$product4$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.category, data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$rating = _data$product7.rating) == null ? void 0 : (_data$product7$rating2 = _data$product7$rating.count) == null ? void 0 : _data$product7$rating2.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$rating = _data$product8.rating) == null ? void 0 : (_data$product8$rating2 = _data$product8$rating.score) == null ? void 0 : _data$product8$rating2.toString()) || null, "|").concat((data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
      item_category4: "ven-por:".concat((_data$product$seller$ = data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : (_data$product10$selle = _data$product10.seller) == null ? void 0 : _data$product10$selle.id) !== null && _data$product$seller$ !== void 0 ? _data$product$seller$ : null, "|ent-por:").concat((_data$product$seller$2 = data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : (_data$product11$selle = _data$product11.seller) == null ? void 0 : _data$product11$selle.deliveryId) !== null && _data$product$seller$2 !== void 0 ? _data$product$seller$2 : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.list) || 'null')),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : _data$product14.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_4__.itemVariantParser)(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : _data$product15.attributes) || null,
      price: getProductPrice(data),
      quantity: 1
    }, (0,_utils_addToCartDimensions__WEBPACK_IMPORTED_MODULE_0__.addToCartDimensions)(data))]
  };
};
var addToCart = function addToCart(newData) {
  var _newData$product, _newData$product2, _newData$product3, _data$customer_id;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref.eventId;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product, {
      category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product.category, {
        id: newData.product.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product = newData.product) == null ? void 0 : _newData$product.url, 1)
      }),
      subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.product.subcategory, {
        id: newData.product.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product2 = newData.product) == null ? void 0 : _newData$product2.url, 2)
      }),
      variationId: newData.product.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_5__.parseUrl)(newData == null ? void 0 : (_newData$product3 = newData.product) == null ? void 0 : _newData$product3.url, 0)
    })
  });
  var getEventLabel = function getEventLabel(label) {
    if (label == null ? void 0 : label.typeButton.includes('oneTouch')) {
      return 'comprar-agora';
    }
    if (label == null ? void 0 : label.typeButton.includes('addToBag')) {
      return 'adicionar-a-sacola';
    }
    if (label == null ? void 0 : label.typeButton.includes('pickupStore')) {
      return 'retirar-na-loja';
    }
    return null;
  };
  var basketId = newData.cartId || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)(ML2_SID) || null;
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    basketId: basketId,
    event: 'add_to_cart',
    eventCategory: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(data == null ? void 0 : data.pageName) || null,
    eventId: eventId,
    eventLabel: getEventLabel(data),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    mundos: 'magalu',
    screenName: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (addToCart);

/***/ }),

/***/ 81760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85942);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);


var categories = [{
  id: 3,
  name: 'GE12'
}, {
  id: 4,
  name: 'GE24'
}, {
  id: 9,
  name: 'GE36'
}, {
  id: 7,
  name: 'RF12'
}, {
  id: 8,
  name: 'RF24'
}, {
  id: 5,
  name: 'TC12'
}, {
  id: 6,
  name: 'TC24'
}, {
  id: 10,
  name: 'TC36'
}];
var parseEcommerce = function parseEcommerce(value) {
  var _value$product, _value$product$financ;
  var validServiceIds = (value == null ? void 0 : value.services) || [];
  var fullPrice = 0;
  var filteredOptions = value.adaptedServices.flatMap(function (item) {
    return item.period.options.filter(function (option) {
      return option.checked;
    });
  });
  var items = (value == null ? void 0 : (_value$product = value.product) == null ? void 0 : (_value$product$financ = _value$product.financialServices) == null ? void 0 : _value$product$financ.flatMap(function (itemService) {
    return itemService.offers.filter(function (offer) {
      return validServiceIds.includes(offer.id);
    }).map(function (offer) {
      var _categories$find, _value$product2;
      var nameFound = ((_categories$find = categories.find(function (cat) {
        return cat.id === offer.id;
      })) == null ? void 0 : _categories$find.name) || '';
      fullPrice += Number(offer.price) || 0;
      var matched = filteredOptions.find(function (opt) {
        return opt.value === offer.id;
      });
      return {
        dimension87: "tag:".concat((matched == null ? void 0 : matched.recommended) ? 'recomendado' : 'sem-tag'),
        item_category: "servicos/".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(offer.description || '')),
        item_id: offer.id,
        item_name: nameFound,
        item_variant: value == null ? void 0 : (_value$product2 = value.product) == null ? void 0 : _value$product2.id,
        price: offer.price,
        quantity: 1
      };
    });
  })) || [];
  return {
    fullPrice: fullPrice,
    items: items
  };
};
var addToCartWarranty = function addToCartWarranty(_ref) {
  var _window, _window$crypto;
  var value = _ref.value;
  var eventId = (_window = window) == null ? void 0 : (_window$crypto = _window.crypto) == null ? void 0 : _window$crypto.randomUUID == null ? void 0 : _window$crypto.randomUUID();
  var userId = (value == null ? void 0 : value.customerId) || null;
  var _parseEcommerce = parseEcommerce(value),
    fullPrice = _parseEcommerce.fullPrice,
    items = _parseEcommerce.items;
  return {
    currency: 'BRL',
    event: 'add_to_cart',
    eventId: eventId,
    eventLabel: 'seguro:incluir-protecao',
    idUsuario: userId || null,
    items: (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(items),
    loginAtivo: userId ? 'logado' : 'nao-logado',
    screenName: 'seguro',
    value: fullPrice
  };
};
/* harmony default export */ __webpack_exports__["default"] = (addToCartWarranty);

/***/ }),

/***/ 72003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_addToWishlistDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8886);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6422);
/* harmony import */ var _utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var priceValue = function priceValue(val) {
  var _val$installment, _val$price, _val$price2;
  return parseFloat(val == null ? void 0 : (_val$installment = val.installment) == null ? void 0 : _val$installment.totalAmount) || parseFloat(val == null ? void 0 : (_val$price = val.price) == null ? void 0 : _val$price.fullPrice) || parseFloat(val == null ? void 0 : (_val$price2 = val.price) == null ? void 0 : _val$price2.bestPrice) || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$brand, _data$brand$label, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller$id, _data$seller, _data$seller$delivery, _data$seller2;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      discount: (0,_utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price),
      index: (data == null ? void 0 : data.position) || null,
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : (_data$brand$label = _data$brand.label) == null ? void 0 : _data$brand$label.slice(0, 99)) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : data.category, data == null ? void 0 : data.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()) || null, "|").concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
      item_category4: "ven-por:".concat((_data$seller$id = data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.id) !== null && _data$seller$id !== void 0 ? _data$seller$id : null, "|ent-por:").concat((_data$seller$delivery = data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.deliveryId) !== null && _data$seller$delivery !== void 0 ? _data$seller$delivery : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : data.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : data.attributes) || null,
      price: priceValue(data),
      quantity: 1
    }, (0,_utils_addToWishlistDimensions__WEBPACK_IMPORTED_MODULE_0__.addToWishlistDimensions)(data))]
  };
};
var addToWishlist = function addToWishlist(newData) {
  var _data$customer_id, _data$installment, _data$price, _data$price2;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.category, {
      id: newData.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 1)
    }),
    subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.subcategory, {
      id: newData.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 2)
    }),
    variationId: newData.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 0)
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    currency: 'BRL',
    event: 'add_to_wishlist',
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
    loginAtivo: (data == null ? void 0 : data.customer_id) ? 'logado' : 'null',
    mundos: 'magalu',
    screenName: (data == null ? void 0 : data.pageName) || null,
    value: parseFloat(data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (addToWishlist);

/***/ }),

/***/ 82022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var formatValue = function formatValue(value) {
  return parseFloat(value || 0).toFixed(2);
};
var calculateTaxes = function calculateTaxes(taxes) {
  return {
    event: 'tax',
    imposto: "".concat(formatValue(taxes == null ? void 0 : taxes.importTax), "|icms:").concat(formatValue(taxes == null ? void 0 : taxes.icms)),
    screenName: 'produto'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (calculateTaxes);

/***/ }),

/***/ 30821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CHAR_MAP": function() { return /* binding */ CHAR_MAP; },
/* harmony export */   "CURRENCY": function() { return /* binding */ CURRENCY; },
/* harmony export */   "DELIVERY": function() { return /* binding */ DELIVERY; },
/* harmony export */   "GENERAL_PRODUCT": function() { return /* binding */ GENERAL_PRODUCT; }
/* harmony export */ });
var CHAR_MAP = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  ç: 'c',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ñ: 'n',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u'
};
var CURRENCY = 'BRL';
var DELIVERY = {
  delivery_24h: 'entrega-em-1-dia-util',
  delivery_plus_1: 'entrega-em-2-dias-uteis',
  magalu_indica: 'magalu-indica',
  'magalu-entregas': 'entregue-por-magalu',
  'magalu-partner': 'perto-de-voce',
  promocao_sazonal_1: 'ofertas-de-natal',
  promocao_sazonal_2: 'cupons',
  promocao_sazonal_3: 'super-ofertas',
  promocao_sazonal_4: 'ofertas-fantasticas',
  store_pickup_available: 'retira-na-loja'
};
var GENERAL_PRODUCT = 'produto:geral';

/***/ }),

/***/ 38015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "couponClick": function() { return /* binding */ couponClick; },
/* harmony export */   "couponView": function() { return /* binding */ couponView; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30821);


var slugifyCouponTitle = function slugifyCouponTitle(couponTitle) {
  if (!couponTitle) return '';
  var dollarSign = /R\$\s?(\d+)/;
  var thousandSeparator = /\.(\d{3})/g;
  var decimals = /,\d+/;
  var specialCharacters = /[,%!]/g;
  var dictionary = /[àáâãäåçèéêëìíîïñòóôõöùúûü]/g;
  var str = couponTitle.trim().replace(dollarSign, 'r$1').replace(thousandSeparator, '$1').replace(decimals, '').replace(specialCharacters, '').replace(dictionary, function (match) {
    return _constants__WEBPACK_IMPORTED_MODULE_1__.CHAR_MAP[match] || match;
  });
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(str);
};
var couponClick = function couponClick(data) {
  var couponName = data.couponName,
    sectionTitle = data.sectionTitle,
    screenName = data.screenName;
  return {
    content_id: "copiar-cupom:".concat(slugifyCouponTitle(sectionTitle), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(couponName)),
    content_type: screenName,
    event: 'select_content'
  };
};
var couponView = function couponView(data) {
  var couponName = data.couponName,
    sectionTitle = data.sectionTitle,
    screenName = data.screenName;
  return {
    content_id: "cupom-disponivel:".concat(slugifyCouponTitle(sectionTitle), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(couponName)),
    content_type: screenName,
    event: 'view_content'
  };
};

/***/ }),

/***/ 5503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "certificatesEventsFooter": function() { return /* binding */ certificatesEventsFooter; },
/* harmony export */   "eventsFooter": function() { return /* binding */ eventsFooter; },
/* harmony export */   "paymentEventsFooter": function() { return /* binding */ paymentEventsFooter; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var certificatesEventsFooter = function certificatesEventsFooter(data) {
  return {
    content_id: "selo:".concat((data == null ? void 0 : data.title) ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.title) : null),
    content_type: 'footer',
    event: 'select_content'
  };
};
var eventsFooter = function eventsFooter(data, title) {
  var titleDepartament = title ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(title) : null;
  var label = (data == null ? void 0 : data.content[0].label) ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.content[0].label) : null;
  return {
    content_id: "".concat(titleDepartament, ":").concat(label),
    content_type: 'footer',
    event: 'select_content'
  };
};
var paymentEventsFooter = function paymentEventsFooter(data) {
  return {
    content_id: "forma-de-pagamento:".concat((data == null ? void 0 : data.title) ? (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.title) : null),
    content_type: 'footer',
    event: 'select_content'
  };
};

/***/ }),

/***/ 45073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var importTaxesInfoModalClose = function importTaxesInfoModalClose() {
  return {
    event: 'clickEvent',
    eventAction: 'click',
    eventCategory: 'produto:compra-internacional',
    eventLabel: 'entendi'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (importTaxesInfoModalClose);

/***/ }),

/***/ 36082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45842);
/* harmony import */ var _accountLinkClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51852);
/* harmony import */ var _addToCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86963);
/* harmony import */ var _addToWishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72003);
/* harmony import */ var _coupon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38015);
/* harmony import */ var _selectItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55544);
/* harmony import */ var _viewItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75589);
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13075);
/* harmony import */ var _share__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(87889);
/* harmony import */ var _shippingError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53827);
/* harmony import */ var _viewItemList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20944);
/* harmony import */ var _virtualPageview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14093);
/* harmony import */ var _importTaxesInfoModalClose__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45073);
/* harmony import */ var _calculateTaxes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(82022);
/* harmony import */ var _showCaseSelectContent__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(41547);
/* harmony import */ var _summaryTechnicalSheet__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(52571);
/* harmony import */ var _selectContent__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80773);
/* harmony import */ var _selectPromotion__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(4193);
/* harmony import */ var _shipping__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35468);
/* harmony import */ var _viewPromotion__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(67155);
/* harmony import */ var _reviewFormSubmitModal__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(55442);
/* harmony import */ var _reviewAttachMedia__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38774);
/* harmony import */ var _reviewCondensedMedia__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16539);
/* harmony import */ var _orderEligibleList__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27341);
/* harmony import */ var _footerEvents__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5503);
/* harmony import */ var _quickClick__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64233);
/* harmony import */ var _selectContentHeader__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23620);
/* harmony import */ var _viewContentHeader__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29371);
/* harmony import */ var _addToCartWarranty__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(81760);





























var events = {
  'account:link:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_accountLinkClick__WEBPACK_IMPORTED_MODULE_1__["default"])],
  'addToCartWarranty:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToCartWarranty__WEBPACK_IMPORTED_MODULE_20__["default"])],
  'addToWishlist:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToWishlist__WEBPACK_IMPORTED_MODULE_3__["default"])],
  'coupon:selectItem': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_coupon__WEBPACK_IMPORTED_MODULE_4__.couponClick)],
  'coupon:viewItem': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_coupon__WEBPACK_IMPORTED_MODULE_4__.couponView)],
  'footer:certificate:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_footerEvents__WEBPACK_IMPORTED_MODULE_16__.certificatesEventsFooter)],
  'footer:menu:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_footerEvents__WEBPACK_IMPORTED_MODULE_16__.eventsFooter)],
  'footer:payment:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_footerEvents__WEBPACK_IMPORTED_MODULE_16__.paymentEventsFooter)],
  'header:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewContentHeader__WEBPACK_IMPORTED_MODULE_19__["default"])],
  'header:selectContent': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectContentHeader__WEBPACK_IMPORTED_MODULE_18__["default"])],
  'order-eligible-list:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderEligibleListOnClick)],
  'order-eligible-list:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderEligibleListOnViewItemList)],
  'order-eligible-list:onview': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderEligibleListOnView)],
  'order-not-eligible:impression': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_orderEligibleList__WEBPACK_IMPORTED_MODULE_15__.orderNotEligibleOnView)],
  pageview: [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_search__WEBPACK_IMPORTED_MODULE_7__["default"]), (0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_virtualPageview__WEBPACK_IMPORTED_MODULE_10__["default"])],
  'product:addToCart': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_addToCart__WEBPACK_IMPORTED_MODULE_2__["default"])],
  'product:calculateTaxes': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_calculateTaxes__WEBPACK_IMPORTED_MODULE_21__["default"])],
  'product:details': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItem__WEBPACK_IMPORTED_MODULE_6__["default"])],
  'product:importTaxesClose:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_importTaxesInfoModalClose__WEBPACK_IMPORTED_MODULE_22__["default"])],
  'product:quickClickSelectItem': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_quickClick__WEBPACK_IMPORTED_MODULE_17__.quickClickSelectItem)],
  'product:quickClickViewItemList': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_quickClick__WEBPACK_IMPORTED_MODULE_17__.quickClickViewItemList)],
  'product:review:condensedMedia:image:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewCondensedMedia__WEBPACK_IMPORTED_MODULE_14__.clickCondensedMediaImage)],
  'product:review:condensedMedia:video:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewCondensedMedia__WEBPACK_IMPORTED_MODULE_14__.clickCondensedMediaVideo)],
  'product:reviewform:attachimage:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewAttachMedia__WEBPACK_IMPORTED_MODULE_13__.clickAttachImageEvent)],
  'product:reviewform:attachvideo:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewAttachMedia__WEBPACK_IMPORTED_MODULE_13__.clickAttachVideoEvent)],
  'product:reviewform:modal': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_reviewFormSubmitModal__WEBPACK_IMPORTED_MODULE_23__["default"])],
  'product:selectContent': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectContent__WEBPACK_IMPORTED_MODULE_11__["default"])],
  'product:selectPromotion': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectPromotion__WEBPACK_IMPORTED_MODULE_24__["default"])],
  'product:share': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_share__WEBPACK_IMPORTED_MODULE_25__["default"])],
  'product:shipping': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shipping__WEBPACK_IMPORTED_MODULE_12__["default"])],
  'product:showcaseSelectContent': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_showCaseSelectContent__WEBPACK_IMPORTED_MODULE_26__["default"])],
  'product:summaryTechnicalSheet': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_summaryTechnicalSheet__WEBPACK_IMPORTED_MODULE_27__["default"])],
  'product:viewItemList': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewItemList__WEBPACK_IMPORTED_MODULE_9__["default"])],
  'product:viewPromotion': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_viewPromotion__WEBPACK_IMPORTED_MODULE_28__["default"])],
  'productlist:selectItem:click': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_selectItem__WEBPACK_IMPORTED_MODULE_5__["default"])],
  'shipping:response:error': [(0,_utils_dataLayerPush__WEBPACK_IMPORTED_MODULE_0__["default"])(_shippingError__WEBPACK_IMPORTED_MODULE_8__["default"])]
};
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ 27341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "itemAdapter": function() { return /* binding */ itemAdapter; },
/* harmony export */   "orderEligibleListOnClick": function() { return /* binding */ orderEligibleListOnClick; },
/* harmony export */   "orderEligibleListOnView": function() { return /* binding */ orderEligibleListOnView; },
/* harmony export */   "orderEligibleListOnViewItemList": function() { return /* binding */ orderEligibleListOnViewItemList; },
/* harmony export */   "orderNotEligibleOnView": function() { return /* binding */ orderNotEligibleOnView; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var screenName = 'lista-pedidos-elegiveis';
var itemAdapter = function itemAdapter(item, index) {
  return {
    index: index,
    item_brand: item.productBrand,
    item_id: item.productSku,
    item_name: item.productDescription
  };
};
var orderEligibleListOnClick = function orderEligibleListOnClick(_ref) {
  var displayMode = _ref.displayMode,
    itemSelected = _ref.itemSelected,
    itemIndex = _ref.itemIndex,
    serviceSlug = _ref.serviceSlug;
  return {
    event: 'select_item',
    eventAction: 'click',
    eventCategory: "".concat(screenName, ":").concat(serviceSlug, ":vitrine"),
    eventLabel: "".concat(displayMode, ":").concat(screenName, ":slot-1:").concat(itemSelected.productSku),
    item: itemAdapter(itemSelected, itemIndex + 1),
    item_list_name: screenName,
    mundos: 'magalu',
    nomeLista: "servico:".concat(screenName),
    pageType: 'servico',
    screenName: screenName
  };
};
var orderEligibleListOnView = function orderEligibleListOnView(_ref2) {
  var device = _ref2.device,
    partnerId = _ref2.partnerId,
    seller = _ref2.seller,
    userId = _ref2.userId,
    userIsLogged = _ref2.userIsLogged,
    userLocation = _ref2.userLocation;
  return {
    barraLocalizacao: undefined,
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .locationToString */ .mZ)(userLocation),
    device: "site-".concat(device),
    event: 'virtualPageview',
    existeDelivery: undefined,
    hitTimestamp: new Date().getTime(),
    idDaLoja: seller == null ? void 0 : seller.id,
    idParceiro: partnerId,
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    nomeDaLoja: seller == null ? void 0 : seller.description,
    pageType: 'servico',
    screenName: screenName,
    usuarioClube: undefined
  };
};
var orderEligibleListOnViewItemList = function orderEligibleListOnViewItemList(_ref3) {
  var displayMode = _ref3.displayMode,
    products = _ref3.products,
    serviceSlug = _ref3.serviceSlug;
  return {
    event: 'view_item_list',
    eventAction: 'impression',
    eventCategory: "".concat(screenName, ":").concat(serviceSlug, ":vitrine"),
    eventLabel: "".concat(displayMode, ":").concat(screenName, ":slot-1"),
    item_list_name: screenName,
    items: (products || []).map(function (product, index) {
      return itemAdapter(product, index + 1);
    }),
    mundos: 'magalu',
    nomeLista: screenName,
    pageType: 'servico',
    posicaoVitrine: displayMode,
    screenName: screenName
  };
};
var orderNotEligibleOnView = function orderNotEligibleOnView(_ref4) {
  var serviceSlug = _ref4.serviceSlug;
  return {
    content_id: "".concat(screenName, "-indisponivel"),
    content_type: 'servico',
    event: 'view_content',
    serviceSlug: serviceSlug
  };
};

/***/ }),

/***/ 64233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "quickClickSelectItem": function() { return /* binding */ quickClickSelectItem; },
/* harmony export */   "quickClickViewItemList": function() { return /* binding */ quickClickViewItemList; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _viewItemList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20944);
/* harmony import */ var _selectItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55544);




var quickClickSelectItem = function quickClickSelectItem(data) {
  var _selectItem, _data$listPosition;
  var buttonLabel = data == null ? void 0 : data.buttonLabel;
  var variationId = decodeURIComponent(data.url).match(/\/p\/([^/]+)/)[1];
  var parsedData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, {
    variationId: variationId
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_selectItem__WEBPACK_IMPORTED_MODULE_2__["default"])(parsedData), {
    eventLabel: "gallery:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":").concat(buttonLabel ? "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(buttonLabel), ":") : '', "slot-").concat(data.listPosition),
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_selectItem = (0,_selectItem__WEBPACK_IMPORTED_MODULE_2__["default"])(parsedData)) == null ? void 0 : _selectItem.items[0], {
      dimension74: '0:',
      dimension107: (_data$listPosition = data == null ? void 0 : data.listPosition) !== null && _data$listPosition !== void 0 ? _data$listPosition : null
    })]
  });
};
var quickClickViewItemList = function quickClickViewItemList(data) {
  var _viewItemList, _data$listPosition2;
  var buttonLabel = data == null ? void 0 : data.buttonLabel;
  var variationId = decodeURIComponent(data.url).match(/\/p\/([^/]+)/)[1];
  var parsedData = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data, {
    variationId: variationId
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (0,_viewItemList__WEBPACK_IMPORTED_MODULE_1__["default"])(parsedData), {
    eventLabel: "gallery:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":").concat(buttonLabel ? "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(buttonLabel), ":") : '', "slot-").concat(data.listPosition),
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_viewItemList = (0,_viewItemList__WEBPACK_IMPORTED_MODULE_1__["default"])(parsedData)) == null ? void 0 : _viewItemList.items[0], {
      dimension74: '0:',
      dimension107: (_data$listPosition2 = data == null ? void 0 : data.listPosition) !== null && _data$listPosition2 !== void 0 ? _data$listPosition2 : null
    })]
  });
};


/***/ }),

/***/ 38774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickAttachImageEvent": function() { return /* binding */ clickAttachImageEvent; },
/* harmony export */   "clickAttachVideoEvent": function() { return /* binding */ clickAttachVideoEvent; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var eventClickAttach = {
  content_type: 'avaliar-produto',
  event: 'select_content'
};
var buildAttachEvent = function buildAttachEvent(contentId, structure) {
  var _structure$config;
  var event = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    content_id: contentId
  }, eventClickAttach);
  if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, event, {
      mini_app_name: 'avaliacoes'
    });
  }
  return event;
};
var clickAttachImageEvent = function clickAttachImageEvent(_ref) {
  var structure = _ref.structure;
  return buildAttachEvent('enviar-foto', structure);
};
var clickAttachVideoEvent = function clickAttachVideoEvent(_ref2) {
  var structure = _ref2.structure;
  return buildAttachEvent('enviar-video', structure);
};

/***/ }),

/***/ 16539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clickCondensedMediaImage": function() { return /* binding */ clickCondensedMediaImage; },
/* harmony export */   "clickCondensedMediaVideo": function() { return /* binding */ clickCondensedMediaVideo; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var eventClickMedia = {
  content_type: 'produto:avaliacao',
  event: 'select_content'
};
var clickCondensedMediaImage = function clickCondensedMediaImage() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventClickMedia, {
    content_id: 'imagem-avaliacoes'
  });
};
var clickCondensedMediaVideo = function clickCondensedMediaVideo() {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventClickMedia, {
    content_id: 'video-avaliacoes'
  });
};

/***/ }),

/***/ 55442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

var reviewFormSubmitModal = function reviewFormSubmitModal(_ref) {
  var _structure$config;
  var structure = _ref.structure;
  var eventFormSubmitModal = {
    content_id: 'voltar-ao-inicio',
    content_type: 'avaliacao-concluida',
    event: 'view_content'
  };
  if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, eventFormSubmitModal, {
      mini_app_name: 'avaliacao'
    });
  }
  return eventFormSubmitModal;
};
/* harmony default export */ __webpack_exports__["default"] = (reviewFormSubmitModal);

/***/ }),

/***/ 13075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77309);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

var search = function search(_ref) {
  var _structure$cookies, _structure$cookies$ac, _structure$route, _structure$route2;
  var data = _ref.data,
    structure = _ref.structure;
  var siteId = structure == null ? void 0 : structure.id;
  var customerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.customer_id;
  var eventFrom = structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.from;
  var term = structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.term;
  var getSearchTermLabel = function getSearchTermLabel() {
    var eventTypes = {
      clickSuggestion: "1:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term)),
      icon: "0:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term)),
      submit: "0:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term))
    };
    return eventTypes[eventFrom] || "0:".concat(slugify__WEBPACK_IMPORTED_MODULE_0___default()(term));
  };
  if (siteId === 'search') {
    var _data$search, _data$search$term, _data$search2, _data$search2$term, _data$search3, _data$search3$product, _data$search4, _data$search4$term;
    var didCorrectTerm = (data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$term = _data$search.term) == null ? void 0 : _data$search$term.refined) !== (data == null ? void 0 : (_data$search2 = data.search) == null ? void 0 : (_data$search2$term = _data$search2.term) == null ? void 0 : _data$search2$term.raw);
    return {
      event: 'search',
      found: (data == null ? void 0 : (_data$search3 = data.search) == null ? void 0 : (_data$search3$product = _data$search3.products) == null ? void 0 : _data$search3$product.length) > 0 ? 'found' : 'not-found',
      loginAtivo: customerId ? 'logado' : 'nao-logado',
      raw: term || null,
      search_term: getSearchTermLabel(),
      wrong_term: "".concat(+didCorrectTerm, ":").concat(data == null ? void 0 : (_data$search4 = data.search) == null ? void 0 : (_data$search4$term = _data$search4.term) == null ? void 0 : _data$search4$term.raw)
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (search);

/***/ }),

/***/ 80773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var getFormatType = function getFormatType(type) {
  var typeMap = {
    "default": 'icone:',
    subsection: 'conheça-tambem:'
  };
  return typeMap[type] || typeMap["default"];
};
var generateContentId = function generateContentId(content, category) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var formatType = type !== 'departamento' ? getFormatType(type) : '';
  return "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content), ":").concat(formatType).concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(category));
};
var selectContent = function selectContent(content, category) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return {
    content_id: generateContentId(content, category, type) || null,
    content_type: 'menu-superior',
    event: 'select_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (selectContent);

/***/ }),

/***/ 23620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var getContentId = function getContentId(content, type) {
  var actions = {
    "default": function _default() {
      return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null;
    },
    login: function login() {
      return "login:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    },
    menu: function menu() {
      return "menu:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    },
    search: function search() {
      return "busca:".concat(content);
    },
    suggestion: function suggestion() {
      return "magalu-has:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    },
    zipcode: function zipcode() {
      return content ? "error:".concat(content) : 'sucesso:sucesso';
    }
  };
  var action = actions[type] || actions["default"];
  return action();
};
var selectContentHeader = function selectContentHeader(content) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    content_id: getContentId(content, type),
    content_type: 'menu-superior',
    event: 'select_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (selectContentHeader);

/***/ }),

/***/ 55544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12608);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var priceValue = function priceValue(data) {
  var _data$installment, _data$price, _data$price2;
  return parseFloat(data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice) || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$brand, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller$id, _data$seller, _data$seller$delivery, _data$seller2, _slug, _slug$replace, _slug$replace$toLower;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      discount: (0,_utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price),
      index: (data == null ? void 0 : data.position) || null,
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : data.category, data == null ? void 0 : data.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()) || null, "|").concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
      item_category4: "ven-por:".concat((_data$seller$id = data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.id) !== null && _data$seller$id !== void 0 ? _data$seller$id : null, "|ent-por:").concat((_data$seller$delivery = data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.deliveryId) !== null && _data$seller$delivery !== void 0 ? _data$seller$delivery : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : data.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
      item_name: (_slug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.title) || 'null')) == null ? void 0 : (_slug$replace = _slug.replace(/[_\s]/g, '-')) == null ? void 0 : (_slug$replace$toLower = _slug$replace.toLowerCase()) == null ? void 0 : _slug$replace$toLower.slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : data.attributes) || null,
      price: priceValue(data)
    }, (0,_utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__.selectItemDimensions)(data))]
  };
};
var selectItem = function selectItem(newData) {
  var _data$customer_id;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.category, {
      id: newData.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 1)
    }),
    subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.subcategory, {
      id: newData.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 2)
    }),
    variationId: newData.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 0)
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    event: 'select_item',
    eventAction: 'click',
    eventCategory: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":magalu:vitrine"),
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.displayMode) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":slot-null:").concat((data == null ? void 0 : data.position) || null, ":").concat((data == null ? void 0 : data.variationId) || null),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
    mundos: 'magalu',
    screenName: (data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data), (data == null ? void 0 : data.term) ? {
    raw: data.term
  } : {});
};
/* harmony default export */ __webpack_exports__["default"] = (selectItem);

/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var selectPromotion = function selectPromotion(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? null : _ref$index,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text;
  var formattedText = text ? text == null ? void 0 : text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_type: 'hotlink',
    creative_name: 'home:magalu:superhotlinks',
    creative_slot: "slot-".concat(index),
    event: 'select_promotion',
    location_id: "home:".concat(formattedText, ":").concat(index),
    screenName: 'home'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (selectPromotion);

/***/ }),

/***/ 87889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var share = function share(data) {
  return {
    content_type: 'produto',
    event: 'share',
    item_id: (data == null ? void 0 : data.variationId) || null,
    method: (data == null ? void 0 : data.iconName) || null
  };
};
/* harmony default export */ __webpack_exports__["default"] = (share);

/***/ }),

/***/ 35468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var shipping = function shipping(data, _ref) {
  var _data$deliveries, _data$deliveries$, _data$deliveries$$ite, _data$deliveries$$ite2, _data$deliveries2, _data$deliveries2$, _data$deliveries2$$st, _data$deliveries3, _data$deliveries3$, _data$deliveries3$$mo, _data$deliveries3$$mo2, _data$deliveries4, _data$deliveries4$, _data$deliveries4$$mo, _data$deliveries4$$mo2, _data$deliveries5, _data$deliveries5$;
  var structure = _ref.structure;
  var skuProduct = structure.route.productId || (data == null ? void 0 : (_data$deliveries = data.deliveries) == null ? void 0 : (_data$deliveries$ = _data$deliveries[0]) == null ? void 0 : (_data$deliveries$$ite = _data$deliveries$.items) == null ? void 0 : (_data$deliveries$$ite2 = _data$deliveries$$ite[0].seller) == null ? void 0 : _data$deliveries$$ite2.sku) || null;
  var productAvailability = (data == null ? void 0 : (_data$deliveries2 = data.deliveries) == null ? void 0 : (_data$deliveries2$ = _data$deliveries2[0]) == null ? void 0 : (_data$deliveries2$$st = _data$deliveries2$.status) == null ? void 0 : _data$deliveries2$$st.code) ? 'verdadeiro' : 'falso';
  var standardDelivery = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$deliveries3 = data.deliveries) == null ? void 0 : (_data$deliveries3$ = _data$deliveries3[0]) == null ? void 0 : (_data$deliveries3$$mo = _data$deliveries3$.modalities) == null ? void 0 : (_data$deliveries3$$mo2 = _data$deliveries3$$mo[0]) == null ? void 0 : _data$deliveries3$$mo2.name) || 'null');
  var pickUpStore = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((data == null ? void 0 : (_data$deliveries4 = data.deliveries) == null ? void 0 : (_data$deliveries4$ = _data$deliveries4[0]) == null ? void 0 : (_data$deliveries4$$mo = _data$deliveries4$.modalities) == null ? void 0 : (_data$deliveries4$$mo2 = _data$deliveries4$$mo[1]) == null ? void 0 : _data$deliveries4$$mo2.name) || 'null');
  var deliveryId = (data == null ? void 0 : (_data$deliveries5 = data.deliveries) == null ? void 0 : (_data$deliveries5$ = _data$deliveries5[0]) == null ? void 0 : _data$deliveries5$.id) || (data == null ? void 0 : data.exceptionDeliveriesId) || null;
  var zipCode = (data == null ? void 0 : data.zipCode) || null;
  var status = data.status,
    _data$errorMessageSer = data.errorMessageServer,
    errorMessageServer = _data$errorMessageSer === void 0 ? '' : _data$errorMessageSer,
    _data$errorMessageUse = data.errorMessageUser,
    errorMessageUser = _data$errorMessageUse === void 0 ? '' : _data$errorMessageUse;
  return {
    cep: zipCode,
    code: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(status || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(errorMessageServer || 'null')),
    content_id: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(errorMessageUser) || null,
    content_type: 'produto:frete',
    deliveriesId: deliveryId,
    event: 'shipping',
    item_id: "".concat(skuProduct, ":").concat(productAvailability, ":").concat(standardDelivery, ":").concat(pickUpStore),
    screenName: 'produto'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (shipping);

/***/ }),

/***/ 53827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var shippingError = function shippingError(data) {
  var _data$value, _data$value$error, _data$value2, _data$value3, _data$value4, _data$value5, _data$value6;
  if (!(data == null ? void 0 : (_data$value = data.value) == null ? void 0 : _data$value.errorCode)) return null;
  var errorMessage = (_data$value$error = data == null ? void 0 : (_data$value2 = data.value) == null ? void 0 : _data$value2.error) !== null && _data$value$error !== void 0 ? _data$value$error : 'cep-invalido';
  return {
    cep: (data == null ? void 0 : (_data$value3 = data.value) == null ? void 0 : _data$value3.zipCode) || null,
    code: data == null ? void 0 : (_data$value4 = data.value) == null ? void 0 : _data$value4.errorCode,
    content_type: "produto:frete",
    deliveriesId: (data == null ? void 0 : (_data$value5 = data.value) == null ? void 0 : _data$value5.deliveriesId) || null,
    event: 'shipping_error',
    item_id: "".concat((data == null ? void 0 : (_data$value6 = data.value) == null ? void 0 : _data$value6.productId) || null, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(errorMessage)).substring(0, 99)
  };
};
/* harmony default export */ __webpack_exports__["default"] = (shippingError);

/***/ }),

/***/ 41547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var ShowCaseSelectContent = function ShowCaseSelectContent(data) {
  var _data$showcase;
  var text = "".concat((data == null ? void 0 : data.type) || null, ":").concat((data == null ? void 0 : (_data$showcase = data.showcase) == null ? void 0 : _data$showcase.title) || null, ":slot-").concat((data == null ? void 0 : data.listPosition) || null, ":descubra-outras-ofertas-aqui");
  var formattedText = text ? text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_id: formattedText,
    content_type: "".concat((data == null ? void 0 : data.pageName) || null, ":mundo-magalu:vitrine"),
    event: 'select_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (ShowCaseSelectContent);

/***/ }),

/***/ 52571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "summaryTechnicalSheet": function() { return /* binding */ summaryTechnicalSheet; }
/* harmony export */ });
var summaryTechnicalSheet = function summaryTechnicalSheet() {
  return {
    content_id: 'principais-informacoes-do-produto',
    content_type: 'produto:informacao-gerada-por-ia',
    event: 'view_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (summaryTechnicalSheet);

/***/ }),

/***/ 29371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var getContent = function getContent(content, type) {
  var actions = {
    "default": function _default() {
      return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content || '') || null;
    },
    error: function error() {
      return "error:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(content) || null);
    }
  };
  var action = actions[type] || actions["default"];
  return action();
};
var viewContentHeader = function viewContentHeader(content, type) {
  return {
    content_id: getContent(content, type),
    content_type: 'menu-superior',
    event: 'view_content'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (viewContentHeader);

/***/ }),

/***/ 75589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7896);
/* harmony import */ var _utils_viewItemDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87191);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6422);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30821);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$product, _data$product$brand, _data$product2, _data$product3, _data$product4, _data$product4$rating, _data$product4$rating2, _data$product5, _data$product5$rating, _data$product5$rating2, _data$product6, _data$product$seller$, _data$product7, _data$product7$seller, _data$product$seller$2, _data$product8, _data$product8$seller, _data$product9, _slug, _slug$replace, _slug$replace$toLower, _data$product10, _data$product11, _data$product12, _data$product12$insta, _data$product13, _data$product13$price, _data$product14, _data$product14$price;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$brand = _data$product.brand) == null ? void 0 : _data$product$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.category, data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$rating = _data$product4.rating) == null ? void 0 : (_data$product4$rating2 = _data$product4$rating.count) == null ? void 0 : _data$product4$rating2.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : (_data$product5$rating = _data$product5.rating) == null ? void 0 : (_data$product5$rating2 = _data$product5$rating.score) == null ? void 0 : _data$product5$rating2.toString()) || null, "|").concat((data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
      item_category4: "ven-por:".concat((_data$product$seller$ = data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$seller = _data$product7.seller) == null ? void 0 : _data$product7$seller.id) !== null && _data$product$seller$ !== void 0 ? _data$product$seller$ : null, "|ent-por:").concat((_data$product$seller$2 = data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$seller = _data$product8.seller) == null ? void 0 : _data$product8$seller.deliveryId) !== null && _data$product$seller$2 !== void 0 ? _data$product$seller$2 : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.variationId) || null,
      item_name: (_slug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)((data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : _data$product10.title) || 'null')) == null ? void 0 : (_slug$replace = _slug.replace(/[_\s]/g, '-')) == null ? void 0 : (_slug$replace$toLower = _slug$replace.toLowerCase()) == null ? void 0 : _slug$replace$toLower.slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : _data$product11.attributes) || null,
      price: parseFloat(data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : (_data$product12$insta = _data$product12.installment) == null ? void 0 : _data$product12$insta.totalAmount) || parseFloat(data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : (_data$product13$price = _data$product13.price) == null ? void 0 : _data$product13$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : (_data$product14$price = _data$product14.price) == null ? void 0 : _data$product14$price.bestPrice) || null
    }, (0,_utils_viewItemDimensions__WEBPACK_IMPORTED_MODULE_0__.viewItemDimensions)(data))]
  };
};
var viewItem = function viewItem(newData) {
  var _newData$product, _newData$product2, _newData$product3, _data$structure, _data$structure$cooki, _data$structure$cooki2, _data$product15, _data$product15$insta, _data$product16, _data$product16$price, _data$product17, _data$product17$price;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    eventId = _ref.eventId;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData, {
    product: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData.product, {
      category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData.product.category, {
        id: newData.product.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : (_newData$product = newData.product) == null ? void 0 : _newData$product.url, 1)
      }),
      subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newData.product.subcategory, {
        id: newData.product.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : (_newData$product2 = newData.product) == null ? void 0 : _newData$product2.url, 2)
      }),
      variationId: newData.product.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : (_newData$product3 = newData.product) == null ? void 0 : _newData$product3.url, 0)
    })
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    currency: _constants__WEBPACK_IMPORTED_MODULE_3__.CURRENCY,
    event: 'view_item',
    eventId: eventId,
    idUsuario: (data == null ? void 0 : (_data$structure = data.structure) == null ? void 0 : (_data$structure$cooki = _data$structure.cookies) == null ? void 0 : (_data$structure$cooki2 = _data$structure$cooki.accountData) == null ? void 0 : _data$structure$cooki2.customer_id) || null,
    mundos: 'magalu',
    screenName: 'produto',
    value: parseFloat(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : (_data$product15$insta = _data$product15.installment) == null ? void 0 : _data$product15$insta.totalAmount) || parseFloat(data == null ? void 0 : (_data$product16 = data.product) == null ? void 0 : (_data$product16$price = _data$product16.price) == null ? void 0 : _data$product16$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$product17 = data.product) == null ? void 0 : (_data$product17$price = _data$product17.price) == null ? void 0 : _data$product17$price.bestPrice) || null
  }, parseEcommerce(data));
};
/* harmony default export */ __webpack_exports__["default"] = (viewItem);

/***/ }),

/***/ 20944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7896);
/* harmony import */ var _utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19175);
/* harmony import */ var _utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58338);
/* harmony import */ var _utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62322);
/* harmony import */ var _utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12608);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6422);







var parseItemCategory = function parseItemCategory(category, subcategory) {
  var categoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((category == null ? void 0 : category.id) || 'null');
  var subcategoryId = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((subcategory == null ? void 0 : subcategory.id) || 'null');
  return "".concat(categoryId, "/").concat(subcategoryId);
};
var priceValue = function priceValue(data) {
  var _data$installment, _data$price, _data$price2;
  return parseFloat(data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || parseFloat(data == null ? void 0 : (_data$price = data.price) == null ? void 0 : _data$price.fullPrice) || parseFloat(data == null ? void 0 : (_data$price2 = data.price) == null ? void 0 : _data$price2.bestPrice) || null;
};
var parseEcommerce = function parseEcommerce(data) {
  var _data$brand, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller$id, _data$seller, _data$seller$delivery, _data$seller2;
  var _formattedTagSeal = (0,_utils_formattedTagSelo__WEBPACK_IMPORTED_MODULE_0__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    items: [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      discount: (0,_utils_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price),
      index: (data == null ? void 0 : data.position) || null,
      item_brand: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : (_data$brand = data.brand) == null ? void 0 : _data$brand.label) || 'null'),
      item_category: parseItemCategory(data == null ? void 0 : data.category, data == null ? void 0 : data.subcategory),
      item_category3: "qtd-av:".concat((data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString()) || null, "|av:").concat((data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()) || null, "|").concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
      item_category4: "ven-por:".concat((_data$seller$id = data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.id) !== null && _data$seller$id !== void 0 ? _data$seller$id : null, "|ent-por:").concat((_data$seller$delivery = data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.deliveryId) !== null && _data$seller$delivery !== void 0 ? _data$seller$delivery : null),
      item_category5: "selo:".concat(seal, "|tag:").concat(tag),
      item_id: (data == null ? void 0 : data.variationId) || null,
      item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
      item_name: (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.title) || 'null').replace(/[_\s]/g, '-').toLowerCase().slice(0, 99),
      item_variant: (0,_utils_itemVariantParser__WEBPACK_IMPORTED_MODULE_5__.itemVariantParser)(data == null ? void 0 : data.attributes) || null,
      price: priceValue(data)
    }, (0,_utils_selectItemDimensions__WEBPACK_IMPORTED_MODULE_1__.selectItemDimensions)(data))]
  };
};
var viewItemList = function viewItemList(newData) {
  var _data$customer_id;
  var data = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData, {
    category: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.category, {
      id: newData.category.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 1)
    }),
    subcategory: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, newData.subcategory, {
      id: newData.subcategory.id || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 2)
    }),
    variationId: newData.variationId || (0,_utils_parseUrl__WEBPACK_IMPORTED_MODULE_6__.parseUrl)(newData == null ? void 0 : newData.url, 0)
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    event: 'view_item_list',
    eventAction: 'impression',
    eventCategory: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":magalu:vitrine"),
    eventLabel: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.displayMode) || 'null'), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null'), ":slot-null"),
    idUsuario: (_data$customer_id = data == null ? void 0 : data.customer_id) !== null && _data$customer_id !== void 0 ? _data$customer_id : null,
    item_list_name: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.pageName) || 'null'), ":").concat((data == null ? void 0 : data.term) || (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)((data == null ? void 0 : data.list) || 'null')),
    mundos: 'magalu',
    screenName: (data == null ? void 0 : data.pageName) || null
  }, parseEcommerce(data), (data == null ? void 0 : data.term) ? {
    raw: data.term
  } : {});
};
/* harmony default export */ __webpack_exports__["default"] = (viewItemList);

/***/ }),

/***/ 67155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
var viewPromotion = function viewPromotion(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? null : _ref$index,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? null : _ref$text;
  var formattedText = text ? text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_type: 'hotlink',
    creative_name: 'home:magalu:superhotlinks',
    creative_slot: "slot-".concat(index),
    event: 'view_promotion',
    location_id: "home:".concat(formattedText, ":").concat(index),
    screenName: 'home'
  };
};
/* harmony default export */ __webpack_exports__["default"] = (viewPromotion);

/***/ }),

/***/ 14093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var formatLocation = function formatLocation(location) {
  if ((location == null ? void 0 : location.zipCodeCity) && (location == null ? void 0 : location.zipCodeState)) {
    return "cep:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCode), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCodeCity), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(location.zipCodeState));
  }
  return null;
};
var getLoginStatus = function getLoginStatus(customerId) {
  return customerId ? 'logado' : 'nao-logado';
};
var virtualPageview = function virtualPageview(_ref) {
  var _structure$cookies2, _data$product, _data$product$categor, _data$product2, _data$product2$subcat;
  var data = _ref.data,
    structure = _ref.structure;
  var siteId = structure.id,
    _structure$cookies = structure.cookies,
    cookies = _structure$cookies === void 0 ? {} : _structure$cookies,
    device = structure.device;
  var cookiesLocation = cookies == null ? void 0 : cookies.location;
  var accountData = (structure == null ? void 0 : (_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.ml2_sid_c) || null;
  var customerId = (accountData == null ? void 0 : accountData.customer_id) || null;
  var clientId = (cookies == null ? void 0 : cookies.clientId) || null;
  var category = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$categor = _data$product.category) == null ? void 0 : _data$product$categor.id) || null;
  var subCategory = (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$subcat = _data$product2.subcategory) == null ? void 0 : _data$product2$subcat.id) || null;
  var location = {
    zipCode: cookiesLocation == null ? void 0 : cookiesLocation.zipCode,
    zipCodeCity: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeCity,
    zipCodeState: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeState
  };
  if (siteId === 'buybox') {
    return {
      buybox: 1,
      cepPreenchido: location.zipCode ? 1 : 0,
      cidadeuf: formatLocation(location),
      clientId: clientId,
      device: device || null,
      event: 'virtualPageview',
      idUsuario: customerId || null,
      loginAtivo: getLoginStatus(customerId),
      mundos: 'magalu',
      pageCategory: "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(category) || null, ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(subCategory) || null),
      pageType: 'produto',
      screenName: 'produto',
      usuarioClube: null
    };
  }
  return null;
};
/* harmony default export */ __webpack_exports__["default"] = (virtualPageview);

/***/ }),

/***/ 57016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _events__WEBPACK_IMPORTED_MODULE_0__["default"]; }
/* harmony export */ });
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36082);


/***/ }),

/***/ 33637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToCartDimensions": function() { return /* binding */ addToCartDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87302);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6422);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80746);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6325);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19175);






var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension112 = function buildDimension112(shipping) {
  if (!shipping) return null;
  var standarDelivery = 'null';
  var standardDeliveryTime = 'null';
  var storePickup = 'null';
  shipping.forEach(function (item) {
    if (item.type === 'conventional') {
      standarDelivery = item.description;
      standardDeliveryTime = item.price;
    }
    if (item.type === 'store_pickup') {
      storePickup = item.description;
    }
  });
  return "entrega-padrao:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(standarDelivery), ":").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(standardDeliveryTime), "|retira-loja:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .slug */ .oF)(storePickup), ":null");
};
var addToCartDimensions = function addToCartDimensions(data) {
  var _data$product, _data$product2, _data$product2$seller, _data$product3, _data$product4, _data$product5, _data$product6, _data$product7, _data$product7$rating, _data$product7$rating2, _data$product8, _data$product8$rating, _data$product8$rating2, _data$product9, _data$product10, _data$product10$selle, _data$product11, _data$product11$selle, _data$product12, _data$product13, _data$product14, _buildDimension, _data$product15, _data$product15$shipp, _data$product15$shipp2, _data$product15$shipp3, _data$product15$shipp4, _data$product16, _data$product17, _data$product17$media, _data$product17$media2;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_3__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  var formattedDate = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .fetchFormattedTime */ .bdZ)();
  var _checkAndCalculateTim = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .checkAndCalculateTime */ .lbA)(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.restrictions, formattedDate),
    show = _checkAndCalculateTim.show;
  return {
    dimension5: (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$seller = _data$product2.seller) == null ? void 0 : _data$product2$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.price),
    dimension8: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension8)(data),
    dimension9: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension9)(data.product),
    dimension11: "".concat((data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
    dimension23: buildDimension23(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.seller, data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : _data$product6.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$rating = _data$product7.rating) == null ? void 0 : (_data$product7$rating2 = _data$product7$rating.count) == null ? void 0 : _data$product7$rating2.toString(), "|av:").concat(data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$rating = _data$product8.rating) == null ? void 0 : (_data$product8$rating2 = _data$product8$rating.score) == null ? void 0 : _data$product8$rating2.toString()),
    dimension40: "contagem-regressiva:".concat(show ? '1' : '0'),
    dimension41: buildDimension41(data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : _data$product9.offerTags),
    dimension61: (data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : (_data$product10$selle = _data$product10.seller) == null ? void 0 : _data$product10$selle.id) || null,
    dimension62: (data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : (_data$product11$selle = _data$product11.seller) == null ? void 0 : _data$product11$selle.deliveryId) || null,
    dimension77: "nominal:".concat((data == null ? void 0 : data.pageName) === 'buybox' ? null : (0,_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getNominalDiscountValue)(data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.installment, data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_4__.getPercentualDiscountValue)(data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : _data$product14.price)),
    dimension86: seal,
    dimension87: tag,
    dimension112: (_buildDimension = buildDimension112(data == null ? void 0 : (_data$product15 = data.product) == null ? void 0 : (_data$product15$shipp = _data$product15.shipping) == null ? void 0 : (_data$product15$shipp2 = _data$product15$shipp[0]) == null ? void 0 : (_data$product15$shipp3 = _data$product15$shipp2.packages) == null ? void 0 : (_data$product15$shipp4 = _data$product15$shipp3[0]) == null ? void 0 : _data$product15$shipp4.deliveryTypes)) == null ? void 0 : _buildDimension.slice(0, 99),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_5__.wishlistItem)(data == null ? void 0 : (_data$product16 = data.product) == null ? void 0 : _data$product16.variationId),
    dimension120: (data == null ? void 0 : (_data$product17 = data.product) == null ? void 0 : (_data$product17$media = _data$product17.media) == null ? void 0 : (_data$product17$media2 = _data$product17$media.images) == null ? void 0 : _data$product17$media2.length) || null
  };
};

/***/ }),

/***/ 8886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToWishlistDimensions": function() { return /* binding */ addToWishlistDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80746);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6325);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);





var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension112 = function buildDimension112(shippingTag) {
  if (!shippingTag) return "entrega-padr\xE3o:null:null|retira-loja:null";
  var cost = (shippingTag == null ? void 0 : shippingTag.cost) === 0 ? 0 : shippingTag.cost || 'null';
  var timeSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.time) || 'null');
  var complementSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.complement) || 'null');
  return "entrega-padr\xE3o:".concat(timeSlug || null, ":").concat(cost || null, "|retira-loja:").concat(complementSlug || null, ":").concat(shippingTag.source || null);
};
var addToWishlistDimensions = function addToWishlistDimensions(data) {
  var _data$seller, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller2, _data$seller3, _data$origin, _data$ads, _data$ads2, _buildDimension, _data$media, _data$media$images;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    dimension5: (data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : data.price),
    dimension8: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension8)(data),
    dimension9: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension9)(data),
    dimension11: "".concat((data == null ? void 0 : data.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
    dimension23: buildDimension23(data == null ? void 0 : data.seller, data == null ? void 0 : data.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString(), "|av:").concat(data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()),
    dimension40: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension40)(data),
    dimension41: buildDimension41(data == null ? void 0 : data.offerTags),
    dimension61: (data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id) || null,
    dimension62: (data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.deliveryId) || null,
    dimension77: "nominal:".concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getPercentualDiscountValue)(data == null ? void 0 : data.price)),
    dimension80: (data == null ? void 0 : data.pageName) === 'busca' ? (data == null ? void 0 : data.term) || null : null,
    dimension86: seal,
    dimension87: tag,
    dimension103: (data == null ? void 0 : (_data$origin = data.origin) == null ? void 0 : _data$origin.includes('ads:')) ? "ads:".concat((data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.id) || null, "|campaignId:").concat((data == null ? void 0 : (_data$ads2 = data.ads) == null ? void 0 : _data$ads2.campaignId) || null) : "".concat((data == null ? void 0 : data.origin) || null),
    dimension112: (_buildDimension = buildDimension112(data == null ? void 0 : data.shippingTag)) == null ? void 0 : _buildDimension.slice(0, 99),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_4__.wishlistItem)(data == null ? void 0 : data.variationId),
    dimension120: (data == null ? void 0 : (_data$media = data.media) == null ? void 0 : (_data$media$images = _data$media.images) == null ? void 0 : _data$media$images.length) || null
  };
};

/***/ }),

/***/ 6325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "buildDimension40": function() { return /* binding */ buildDimension40; },
/* harmony export */   "buildDimension8": function() { return /* binding */ buildDimension8; },
/* harmony export */   "buildDimension9": function() { return /* binding */ buildDimension9; }
/* harmony export */ });
/* harmony import */ var _magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87302);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6422);


var buildDimension40 = function buildDimension40(data) {
  var restrictions = data.restrictions;
  if (!restrictions) return "contagem-regressiva:0";
  var formattedDate = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .fetchFormattedTime */ .bdZ)();
  var _checkAndCalculateTim = (0,_magalu_stereo_ui__WEBPACK_IMPORTED_MODULE_0__/* .checkAndCalculateTime */ .lbA)(restrictions, formattedDate),
    show = _checkAndCalculateTim.show;
  return "contagem-regressiva:".concat(show ? '1' : '0');
};
var buildDimension8 = function buildDimension8(data) {
  var _data$product, _previousInstallment, _previousInstallment2, _previousInstallment3, _data$product2, _data$product2$instal, _data$installment, _data$product3, _data$product3$instal, _data$installment2, _data$product4, _data$product4$instal, _data$installment3;
  if ((data == null ? void 0 : data.pageName) === 'buybox') {
    return "cartao-luiza:null:null:null|cartao-credito:null:null:null";
  }
  var paymentMethods = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.paymentMethods) || (data == null ? void 0 : data.paymentMethods);
  var luizaOuroMethod = paymentMethods == null ? void 0 : paymentMethods.find(function (method) {
    return method.id === 'luiza_ouro';
  });
  var installmentPlans = (luizaOuroMethod == null ? void 0 : luizaOuroMethod.installmentPlans) || [];
  var previousInstallment = null;
  installmentPlans.find(function (currentInstallment) {
    if (currentInstallment.interest !== '0.00') {
      return true;
    }
    previousInstallment = currentInstallment;
    return false;
  });
  var luizaCardTotalAmount = ((_previousInstallment = previousInstallment) == null ? void 0 : _previousInstallment.totalAmount) || null;
  var luizaCardInstallmentLength = ((_previousInstallment2 = previousInstallment) == null ? void 0 : _previousInstallment2.installment) || null;
  var luizaCardLastInstallmentAmount = ((_previousInstallment3 = previousInstallment) == null ? void 0 : _previousInstallment3.installmentAmount) || null;
  var creditCardTotalAmount = (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$instal = _data$product2.installment) == null ? void 0 : _data$product2$instal.totalAmount) || (data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) || null;
  var creditCardQuantity = (data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : (_data$product3$instal = _data$product3.installment) == null ? void 0 : _data$product3$instal.quantity) || (data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) || null;
  var creditCardAmount = (data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : (_data$product4$instal = _data$product4.installment) == null ? void 0 : _data$product4$instal.amount) || (data == null ? void 0 : (_data$installment3 = data.installment) == null ? void 0 : _data$installment3.amount) || null;
  return "cartao-luiza:".concat(luizaCardTotalAmount, ":").concat(luizaCardInstallmentLength, ":").concat(luizaCardLastInstallmentAmount, "|cartao-credito:").concat(creditCardTotalAmount, ":").concat(creditCardQuantity, ":").concat(creditCardAmount);
};
var formatValue = function formatValue(value) {
  return value ? parseFloat(value).toFixed(2) : 'nao-calculado';
};
var buildDimension9 = function buildDimension9(product) {
  var _product$tax, _product$tax2;
  if (!(0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .isInternationalPrice */ .xx)(product)) {
    return null;
  }
  var icms = formatValue(product == null ? void 0 : (_product$tax = product.tax) == null ? void 0 : _product$tax.icms);
  var importTax = formatValue(product == null ? void 0 : (_product$tax2 = product.tax) == null ? void 0 : _product$tax2.importValue);
  return "imposto:".concat(importTax, "|icms:").concat(icms);
};

/***/ }),

/***/ 45842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);


var dataLayerPush = function dataLayerPush(listener) {
  return function () {
    var _ref, _structure$config;
    var _ref2 = (_ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref]) || {},
      config = _ref2.config,
      structure = _ref2.structure;
    if (!listener || _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .whereAmI.onServer */ .er.onServer || !window.dataLayer || !document) return;
    var object = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, listener.apply(void 0, arguments), {
      hitTimestamp: new Date().getTime()
    });
    if (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.isMiniApp) {
      (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .useFirebasePush */ .Gz)(object);
    } else {
      window.dataLayer.push(object);
    }
    if ((config == null ? void 0 : config.environment) === 'development') {
      var listnerResult = listener.apply(void 0, arguments);
      if (listnerResult) {
        var event = listnerResult.event,
          eventCategory = listnerResult.eventCategory,
          pageType = listnerResult.pageType,
          contentType = listnerResult.content_type;
        var title = "%c[ga log] ".concat(eventCategory || pageType || contentType, " ").concat(event, "\n");
        console.groupCollapsed(title, 'color: #03A9F4');
        console.log("\uD83D\uDCE1 [dataLayer.push]", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, listener.apply(void 0, arguments)));
        console.groupEnd(title);
      }
    }
  };
};
/* harmony default export */ __webpack_exports__["default"] = (dataLayerPush);

/***/ }),

/***/ 80746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getNominalDiscountValue": function() { return /* binding */ getNominalDiscountValue; },
/* harmony export */   "getPercentualDiscountValue": function() { return /* binding */ getPercentualDiscountValue; }
/* harmony export */ });
var getNominalDiscountValue = function getNominalDiscountValue(installment, price) {
  if ((installment == null ? void 0 : installment.totalAmount) && (price == null ? void 0 : price.bestPrice)) {
    return parseFloat(((installment == null ? void 0 : installment.totalAmount) - (price == null ? void 0 : price.bestPrice)).toFixed(2));
  }
  if ((price == null ? void 0 : price.bestPrice) && (price == null ? void 0 : price.fullPrice)) {
    return parseFloat(((price == null ? void 0 : price.fullPrice) - (price == null ? void 0 : price.bestPrice)).toFixed(2));
  }
  return null;
};
var getPercentualDiscountValue = function getPercentualDiscountValue(price) {
  return (price == null ? void 0 : price.discount) || 'null';
};

/***/ }),

/***/ 19175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formattedTagSeal": function() { return /* binding */ formattedTagSeal; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);

var hasKey = function hasKey() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return Object.prototype.hasOwnProperty.call(obj, key);
};
var getCouponTag = function getCouponTag(product) {
  var _product$seller, _product$seller$tags;
  var coupon = product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : (_product$seller$tags = _product$seller.tags) == null ? void 0 : _product$seller$tags.find(function (tag) {
    return tag.type === 'coupon';
  });
  if (!coupon) return null;
  var discountLabels = {
    absolute: 'R$',
    percentage: '%'
  };
  var currentDiscount = discountLabels[coupon.discountType];
  return "cupom-".concat(coupon.discountValue, "-").concat(currentDiscount, "-off");
};
var getOfferTag = function getOfferTag(product) {
  var _product$offerTags, _product$offerTags$;
  var noTag = 'sem-tag';
  var hasOfferTags = hasKey(product, 'offerTags');
  return hasOfferTags ? "".concat(((_product$offerTags = product.offerTags) == null ? void 0 : (_product$offerTags$ = _product$offerTags[0]) == null ? void 0 : _product$offerTags$.replace(/_/g, '-')) || noTag) : null;
};
var getInternationalTag = function getInternationalTag(product) {
  return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .isInternationalPrice */ .xx)(product) ? 'compra-internacional' : null;
};
var getBadgeSeal = function getBadgeSeal(product) {
  var _product$badges, _product$badges$;
  var noSeal = 'sem-selo';
  var hasBadges = hasKey(product, 'badges');
  return hasBadges ? "".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .normalize */ .Fv)((_product$badges = product.badges) == null ? void 0 : (_product$badges$ = _product$badges[0]) == null ? void 0 : _product$badges$.text) || noSeal) : null;
};
var formattedTagSeal = function formattedTagSeal(product) {
  var offerTag = getOfferTag(product);
  var internationalTag = getInternationalTag(product);
  var badgeSeal = getBadgeSeal(product);
  var couponTag = getCouponTag(product);
  var tag = [offerTag, internationalTag, couponTag].filter(Boolean).join('|') || null;
  return {
    seal: badgeSeal,
    tag: tag
  };
};

/***/ }),

/***/ 58338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "itemVariantParser": function() { return /* binding */ itemVariantParser; }
/* harmony export */ });
var itemVariantParser = function itemVariantParser(attributes) {
  if (!attributes || !Array.isArray(attributes)) {
    return '';
  }
  var values = attributes.map(function (item) {
    var tipo = item.type || '';
    var valor = item.value || '';
    return [tipo, valor].filter(Boolean).join(':');
  }).filter(Boolean).join('|');
  return values.replace(/[_\s]/g, '-').replace(/,(?:-\s*)/g, ',').toLowerCase();
};

/***/ }),

/***/ 62322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "parseUrl": function() { return /* binding */ parseUrl; }
/* harmony export */ });
var parseUrl = function parseUrl(data, position) {
  var _data$split, _data$split$;
  if (!data) {
    return null;
  }
  return data == null ? void 0 : (_data$split = data.split('/p/')) == null ? void 0 : (_data$split$ = _data$split[1]) == null ? void 0 : _data$split$.split('/')[position];
};

/***/ }),

/***/ 12608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "selectItemDimensions": function() { return /* binding */ selectItemDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80746);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19175);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6325);





var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension11 = function buildDimension11(data) {
  var _data$product;
  return (data == null ? void 0 : data.available) || (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : _data$product.available) ? 'verdadeiro' : 'falso:indisponivel-cep';
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension4 = function buildDimension4(data) {
  var _ref, _data$ads;
  return (_ref = (data == null ? void 0 : data.campaignId) || (data == null ? void 0 : (_data$ads = data.ads) == null ? void 0 : _data$ads.campaignId)) !== null && _ref !== void 0 ? _ref : null;
};
var buildDimension103 = function buildDimension103(data) {
  var _data$ads2;
  if ((data == null ? void 0 : data.campaignId) || (data == null ? void 0 : (_data$ads2 = data.ads) == null ? void 0 : _data$ads2.campaignId)) {
    return 'ads';
  }
  return (data == null ? void 0 : data.origin) || 'null';
};
var buildDimension112 = function buildDimension112(shippingTag) {
  if (!shippingTag) return null;
  var cost = (shippingTag == null ? void 0 : shippingTag.cost) === 0 ? 0 : shippingTag == null ? void 0 : shippingTag.cost;
  var timeSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.time) || '');
  var complementSlug = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)((shippingTag == null ? void 0 : shippingTag.complement) || '');
  var sourceValue = shippingTag == null ? void 0 : shippingTag.source;
  var deliveryString = "entrega-padr\xE3o:".concat(timeSlug || null, ":").concat(cost === 0 ? 'frete-gratis' : cost || null, "|retira-loja:").concat(complementSlug || null, ":").concat(sourceValue || null);
  return deliveryString.slice(0, 99) || null;
};
var selectItemDimensions = function selectItemDimensions(data) {
  var _data$seller, _data$installment$tot, _data$installment, _data$installment$qua, _data$installment2, _data$installment$amo, _data$installment3, _data$rating, _data$rating$count, _data$rating2, _data$rating2$score, _data$seller2, _data$seller3, _data$parsedAttribute, _data$parsedAttribute2, _data$parsedAttribute3, _data$parsedAttribute4, _data$parsedAttribute5, _data$parsedAttribute6, _data$shippingTag;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_1__.formattedTagSeal)(data),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    dimension4: buildDimension4(data),
    dimension5: (data == null ? void 0 : (_data$seller = data.seller) == null ? void 0 : _data$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : data.price),
    dimension8: "cartao-luiza:null:null:null|cartao-credito:".concat((_data$installment$tot = data == null ? void 0 : (_data$installment = data.installment) == null ? void 0 : _data$installment.totalAmount) !== null && _data$installment$tot !== void 0 ? _data$installment$tot : null, ":").concat((_data$installment$qua = data == null ? void 0 : (_data$installment2 = data.installment) == null ? void 0 : _data$installment2.quantity) !== null && _data$installment$qua !== void 0 ? _data$installment$qua : null, ":").concat((_data$installment$amo = data == null ? void 0 : (_data$installment3 = data.installment) == null ? void 0 : _data$installment3.amount) !== null && _data$installment$amo !== void 0 ? _data$installment$amo : null),
    dimension11: buildDimension11(data),
    dimension23: buildDimension23(data == null ? void 0 : data.seller, data == null ? void 0 : data.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$rating = data.rating) == null ? void 0 : (_data$rating$count = _data$rating.count) == null ? void 0 : _data$rating$count.toString(), "|av:").concat(data == null ? void 0 : (_data$rating2 = data.rating) == null ? void 0 : (_data$rating2$score = _data$rating2.score) == null ? void 0 : _data$rating2$score.toString()),
    dimension40: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_2__.buildDimension40)(data),
    dimension41: buildDimension41(data == null ? void 0 : data.offerTags),
    dimension61: (data == null ? void 0 : (_data$seller2 = data.seller) == null ? void 0 : _data$seller2.id) || null,
    dimension62: (data == null ? void 0 : (_data$seller3 = data.seller) == null ? void 0 : _data$seller3.deliveryId) || null,
    dimension74: "".concat(data == null ? void 0 : (_data$parsedAttribute = data.parsedAttributes) == null ? void 0 : (_data$parsedAttribute2 = _data$parsedAttribute[0]) == null ? void 0 : (_data$parsedAttribute3 = _data$parsedAttribute2.values) == null ? void 0 : _data$parsedAttribute3.length, ":").concat(data == null ? void 0 : (_data$parsedAttribute4 = data.parsedAttributes) == null ? void 0 : (_data$parsedAttribute5 = _data$parsedAttribute4[0]) == null ? void 0 : (_data$parsedAttribute6 = _data$parsedAttribute5.values) == null ? void 0 : _data$parsedAttribute6.toString()),
    dimension77: "nominal:".concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getNominalDiscountValue)(data == null ? void 0 : data.installment, data == null ? void 0 : data.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getPercentualDiscountValue)(data == null ? void 0 : data.price)),
    dimension80: (data == null ? void 0 : data.pageName) === 'busca' ? (data == null ? void 0 : data.term) || null : null,
    dimension86: seal,
    dimension87: tag,
    dimension103: buildDimension103(data),
    dimension106: "alg:".concat((data == null ? void 0 : data.pageName) || 'null', "-null-").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(data == null ? void 0 : data.list) || 'null', "|type:").concat((data == null ? void 0 : data.displayMode) || 'null'),
    dimension112: buildDimension112(data == null ? void 0 : data.shippingTag),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_4__.wishlistItem)(data == null ? void 0 : data.variationId),
    dimension121: (data == null ? void 0 : (_data$shippingTag = data.shippingTag) == null ? void 0 : _data$shippingTag.uuid) || 'null'
  };
};

/***/ }),

/***/ 87191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "viewItemDimensions": function() { return /* binding */ viewItemDimensions; }
/* harmony export */ });
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6422);
/* harmony import */ var _wishlistItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(988);
/* harmony import */ var _discountCalc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80746);
/* harmony import */ var _buildDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6325);
/* harmony import */ var _formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19175);





var buildDimension7 = function buildDimension7(priceData) {
  var price = (priceData == null ? void 0 : priceData.price) || null;
  var bestPrice = (priceData == null ? void 0 : priceData.bestPrice) || null;
  var fullPrice = (priceData == null ? void 0 : priceData.fullPrice) || null;
  return "preco-de:".concat(price !== null ? price : 'null', "|pix:").concat(bestPrice !== null ? bestPrice : 'null', "|mpay:null|boleto:").concat(fullPrice !== null ? fullPrice : 'null');
};
var buildDimension23 = function buildDimension23(seller, togglePdpSellerScore) {
  var _seller$details, _seller$details$score;
  return seller.category === '1p' || !!_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .magaluCompanies */ .p5[seller.id] ? '0' : "".concat(Number(!!togglePdpSellerScore) || '1', ":").concat(((_seller$details = seller.details) == null ? void 0 : (_seller$details$score = _seller$details.score) == null ? void 0 : _seller$details$score.toString()) || null);
};
var buildDimension41 = function buildDimension41(offerTags) {
  return "etiqueta:".concat((offerTags == null ? void 0 : offerTags.includes('magalu_indica')) ? '1:magalu-indica' : '0');
};
var buildDimension112 = function buildDimension112(shipping) {
  if (!shipping) return null;
  var standarDelivery = 'null';
  var standardDeliveryTime = 'null';
  var storePickup = 'null';
  shipping.forEach(function (item) {
    if (item.type === 'conventional') {
      var _item$shippingTime, _item$cost;
      standarDelivery = item == null ? void 0 : (_item$shippingTime = item.shippingTime) == null ? void 0 : _item$shippingTime.description;
      standardDeliveryTime = item == null ? void 0 : (_item$cost = item.cost) == null ? void 0 : _item$cost.customer;
    }
    if (item.type === 'store_pickup') {
      var _item$shippingTime2;
      storePickup = item == null ? void 0 : (_item$shippingTime2 = item.shippingTime) == null ? void 0 : _item$shippingTime2.description;
    }
  });
  var deliveryString = "entrega-padrao:".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(standarDelivery) || null, ":").concat(standardDeliveryTime || 0, "|retira-loja:").concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_0__/* .slug */ .oF)(storePickup) || null, ":null");
  return deliveryString.slice(0, 99) || null;
};
var viewItemDimensions = function viewItemDimensions(data) {
  var _data$product, _data$product$seller, _data$product2, _data$product3, _data$product4, _data$structure, _data$product5, _data$product5$rating, _data$product5$rating2, _data$product6, _data$product6$rating, _data$product6$rating2, _data$product7, _data$product8, _data$product8$seller, _data$product9, _data$product9$seller, _data$product10, _data$product11, _data$product12, _data$deliveries, _data$deliveries$, _data$product13, _data$product14, _data$product14$media, _data$product14$media2;
  var _formattedTagSeal = (0,_formattedTagSelo__WEBPACK_IMPORTED_MODULE_2__.formattedTagSeal)(data == null ? void 0 : data.product),
    seal = _formattedTagSeal.seal,
    tag = _formattedTagSeal.tag;
  return {
    dimension5: (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$seller = _data$product.seller) == null ? void 0 : _data$product$seller.category) || null,
    dimension7: buildDimension7(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.price),
    dimension8: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension8)(data),
    dimension11: "".concat((data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.available) ? 'verdadeiro' : 'falso:indisponivel-cep'),
    dimension23: buildDimension23(data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.seller, data == null ? void 0 : (_data$structure = data.structure) == null ? void 0 : _data$structure.togglePdpSellerScore),
    dimension24: "qtd-av:".concat(data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : (_data$product5$rating = _data$product5.rating) == null ? void 0 : (_data$product5$rating2 = _data$product5$rating.count) == null ? void 0 : _data$product5$rating2.toString(), "|av:").concat(data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : (_data$product6$rating = _data$product6.rating) == null ? void 0 : (_data$product6$rating2 = _data$product6$rating.score) == null ? void 0 : _data$product6$rating2.toString()),
    dimension40: (0,_buildDimensions__WEBPACK_IMPORTED_MODULE_1__.buildDimension40)(data == null ? void 0 : data.product),
    dimension41: buildDimension41(data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : _data$product7.offerTags),
    dimension61: (data == null ? void 0 : (_data$product8 = data.product) == null ? void 0 : (_data$product8$seller = _data$product8.seller) == null ? void 0 : _data$product8$seller.id) || null,
    dimension62: (data == null ? void 0 : (_data$product9 = data.product) == null ? void 0 : (_data$product9$seller = _data$product9.seller) == null ? void 0 : _data$product9$seller.deliveryId) || null,
    dimension77: "nominal:".concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getNominalDiscountValue)(data == null ? void 0 : (_data$product10 = data.product) == null ? void 0 : _data$product10.installment, data == null ? void 0 : (_data$product11 = data.product) == null ? void 0 : _data$product11.price), "|percentual:").concat((0,_discountCalc__WEBPACK_IMPORTED_MODULE_3__.getPercentualDiscountValue)(data == null ? void 0 : (_data$product12 = data.product) == null ? void 0 : _data$product12.price)),
    dimension86: seal,
    dimension87: tag,
    dimension112: buildDimension112(data == null ? void 0 : (_data$deliveries = data.deliveries) == null ? void 0 : (_data$deliveries$ = _data$deliveries[0]) == null ? void 0 : _data$deliveries$.modalities),
    dimension115: (0,_wishlistItem__WEBPACK_IMPORTED_MODULE_4__.wishlistItem)(data == null ? void 0 : (_data$product13 = data.product) == null ? void 0 : _data$product13.variationId),
    dimension120: (data == null ? void 0 : (_data$product14 = data.product) == null ? void 0 : (_data$product14$media = _data$product14.media) == null ? void 0 : (_data$product14$media2 = _data$product14$media.images) == null ? void 0 : _data$product14$media2.length) || null
  };
};

/***/ }),

/***/ 988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wishlistItem": function() { return /* binding */ wishlistItem; }
/* harmony export */ });
var wishlistItem = function wishlistItem(data) {
  var wishlistData = JSON.parse(localStorage.getItem('wishlist') || null);
  if (!wishlistData) {
    return 0;
  }
  var prodId = data;
  return wishlistData.items.some(function (item) {
    return item.id === prodId;
  }) ? 1 : 0;
};

/***/ })

}]);